var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArabic1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2667.953 1010.299",
    style: {
      enableBackground: "new 0 0 2667.953 1010.299"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_19_);}\n\t.st19{fill:url(#SVGID_20_);}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_21_);}\n\t.st21{fill:url(#SVGID_22_);}\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_23_);}\n\t.st23{fill:url(#SVGID_24_);}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_25_);}\n\t.st25{fill:url(#SVGID_26_);}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_27_);}\n\t.st27{fill:url(#SVGID_28_);}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_29_);}\n\t.st29{fill:url(#SVGID_30_);}\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_31_);}\n\t.st31{fill:url(#SVGID_32_);}\n\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_33_);}\n\t.st33{fill:url(#SVGID_34_);}\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_35_);}\n\t.st35{fill:url(#SVGID_36_);}\n\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_37_);}\n\t.st37{fill:url(#SVGID_38_);}\n\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_39_);}\n\t.st39{fill:url(#SVGID_40_);}\n\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_41_);}\n\t.st41{fill:url(#SVGID_42_);}\n\t.st42{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_43_);}\n\t.st43{fill:url(#SVGID_44_);}\n\t.st44{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_45_);}\n\t.st45{fill:url(#SVGID_46_);}\n\t.st46{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_47_);}\n\t.st47{fill:url(#SVGID_48_);}\n\t.st48{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_49_);}\n\t.st49{fill:url(#SVGID_50_);}\n\t.st50{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_51_);}\n\t.st51{fill:url(#SVGID_52_);}\n\t.st52{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_53_);}\n\t.st53{fill:url(#SVGID_54_);}\n\t.st54{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_55_);}\n\t.st55{fill:url(#SVGID_56_);}\n\t.st56{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_57_);}\n\t.st57{fill:url(#SVGID_58_);}\n\t.st58{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_59_);}\n\t.st59{fill:url(#SVGID_60_);}\n\t.st60{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_61_);}\n\t.st61{fill:url(#SVGID_62_);}\n\t.st62{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_63_);}\n\t.st63{fill:url(#SVGID_64_);}\n\t.st64{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_65_);}\n\t.st65{fill:url(#SVGID_66_);}\n\t.st66{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_67_);}\n\t.st67{fill:url(#SVGID_68_);}\n\t.st68{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_69_);}\n\t.st69{fill:url(#SVGID_70_);}\n\t.st70{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_71_);}\n\t.st71{fill:url(#SVGID_72_);}\n\t.st72{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_73_);}\n\t.st73{fill:url(#SVGID_74_);}\n\t.st74{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_75_);}\n\t.st75{fill:url(#SVGID_76_);}\n\t.st76{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_77_);}\n\t.st77{fill:url(#SVGID_78_);}\n\t.st78{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_79_);}\n\t.st79{fill:url(#SVGID_80_);}\n\t.st80{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_81_);}\n\t.st81{fill:url(#SVGID_82_);}\n\t.st82{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_83_);}\n\t.st83{fill:url(#SVGID_84_);}\n\t.st84{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_85_);}\n\t.st85{fill:url(#SVGID_86_);}\n\t.st86{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_87_);}\n\t.st87{fill:url(#SVGID_88_);}\n\t.st88{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_89_);}\n\t.st89{fill:url(#SVGID_90_);}\n\t.st90{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_91_);}\n\t.st91{fill:url(#SVGID_92_);}\n\t.st92{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_93_);}\n\t.st93{fill:url(#SVGID_94_);}\n\t.st94{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_95_);}\n\t.st95{fill:url(#SVGID_96_);}\n\t.st96{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_97_);}\n\t.st97{fill:url(#SVGID_98_);}\n\t.st98{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_99_);}\n\t.st99{fill:url(#SVGID_100_);}\n\t.st100{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_101_);}\n\t.st101{fill:url(#SVGID_102_);}\n\t.st102{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_103_);}\n\t.st103{fill:url(#SVGID_104_);}\n\t.st104{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_105_);}\n\t.st105{fill:url(#SVGID_106_);}\n\t.st106{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_107_);}\n\t.st107{fill:url(#SVGID_108_);}\n\t.st108{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_109_);}\n\t.st109{fill:url(#SVGID_110_);}\n\t.st110{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_111_);}\n\t.st111{fill:url(#SVGID_112_);}\n\t.st112{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_113_);}\n\t.st113{fill:url(#SVGID_114_);}\n\t.st114{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_115_);}\n\t.st115{fill:url(#SVGID_116_);}\n\t.st116{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_117_);}\n\t.st117{fill:url(#SVGID_118_);}\n\t.st118{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_119_);}\n\t.st119{fill:url(#SVGID_120_);}\n\t.st120{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_121_);}\n\t.st121{fill:url(#SVGID_122_);}\n\t.st122{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_123_);}\n\t.st123{fill:url(#SVGID_124_);}\n\t.st124{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_125_);}\n\t.st125{fill:url(#SVGID_126_);}\n\t.st126{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_127_);}\n\t.st127{fill:url(#SVGID_128_);}\n\t.st128{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_129_);}\n\t.st129{fill:url(#SVGID_130_);}\n\t.st130{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_131_);}\n\t.st131{fill:url(#SVGID_132_);}\n\t.st132{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_133_);}\n\t.st133{fill:url(#SVGID_134_);}\n\t.st134{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_135_);}\n\t.st135{fill:url(#SVGID_136_);}\n\t.st136{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_137_);}\n\t.st137{fill:url(#SVGID_138_);}\n\t.st138{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_139_);}\n\t.st139{fill:url(#SVGID_140_);}\n\t.st140{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_141_);}\n\t.st141{fill:url(#SVGID_142_);}\n\t.st142{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_143_);}\n\t.st143{fill:url(#SVGID_144_);}\n\t.st144{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_145_);}\n\t.st145{fill:url(#SVGID_146_);}\n\t.st146{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_147_);}\n\t.st147{fill:url(#SVGID_148_);}\n\t.st148{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_149_);}\n\t.st149{fill:url(#SVGID_150_);}\n\t.st150{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_151_);}\n\t.st151{fill:url(#SVGID_152_);}\n\t.st152{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_153_);}\n\t.st153{fill:url(#SVGID_154_);}\n\t.st154{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_155_);}\n\t.st155{fill:url(#SVGID_156_);}\n\t.st156{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_157_);}\n\t.st157{fill:url(#SVGID_158_);}\n\t.st158{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_159_);}\n\t.st159{fill:url(#SVGID_160_);}\n\t.st160{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_161_);}\n\t.st161{fill:url(#SVGID_162_);}\n\t.st162{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_163_);}\n\t.st163{fill:url(#SVGID_164_);}\n\t.st164{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_165_);}\n\t.st165{fill:url(#SVGID_166_);}\n\t.st166{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_167_);}\n\t.st167{fill:url(#SVGID_168_);}\n\t.st168{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_169_);}\n\t.st169{fill:url(#SVGID_170_);}\n\t.st170{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_171_);}\n\t.st171{fill:url(#SVGID_172_);}\n\t.st172{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_173_);}\n\t.st173{fill:url(#SVGID_174_);}\n\t.st174{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_175_);}\n\t.st175{fill:url(#SVGID_176_);}\n\t.st176{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_177_);}\n\t.st177{fill:url(#SVGID_178_);}\n\t.st178{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_179_);}\n\t.st179{fill:url(#SVGID_180_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.7494,
    y1: 520.9968,
    x2: 2614.0103,
    y2: 520.9968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2060.467,582.59c13.052-10.192,46.884-41.45,93.648-38.005c14.858,1.095,28.53,5.9,39.704,16.199 c4.552,4.192,4.261,2.647,24.749-18.087c6.923-6.998,6.763-1.295-59.985-49.591c-39.492-28.576-29.097-90.55,17.526-100.668 c58.237-12.632,193.001,2.082,247.532,9.928c14.434,2.077,4.076,15.698,1.612-264.114c-0.048-5.612,3.757-11.542,20.031-39.544 c0.333-0.57,1.029-0.924,2.282-2.006c31.409,60.02,20.528,48.628,69.662,135.059c30.891,54.356,97.203,162.924,96.78,267.005 c-0.313,83.971-21.191,155.216-57.821,214.753c-48.031,78.068-36.943,65.964-44.023,83.276 c-66.605,162.994-309.36,237.378-379.627,34.316c-1.765-5.09-3.158-7.933-9.015-9.865 c-83.749-27.58-83.682-128.803-90.805-160.134c-54.922,73.335-86.489,141.848-143.997,118.003 c-36.997-15.327-43.6-58.541-35.157-87.143c8.246-27.911,6.379-21.726,5.69-28.083c-0.618-0.14-1.235-0.276-1.853-0.412 c-23.208,36.072-29.123,51.581-57.37,57.51c-15.645,3.277,4.106,13.728-21.828,72.705c-4.432,10.084-11.319,18.026-20.434,23.873 c-264.439,169.785-753.232,150.575-979.461,40.943c-43.375-21.006-102.755-95.3-113.737-106.926 c-2.644,4.47-13.437,33.392-57.031,45.626c-11.183,3.134-8.807,9.776-32.019,39.446 c-101.289,129.549-252.545,125.478-318.19,20.084c-22.798-36.619-23.671-62.517-29.445-92.926 c-0.432-2.273-1.472-4.95-3.136-6.395c-63.587-55.141-47.539-135.71-58.384-356.404c-0.268-5.442-13.046-8.19-24.002-15.202 c-77.728-49.76-54.13-175.522-7.861-231.865c0.642,0.245,1.284,0.491,1.927,0.734c-6.151,22.31-62.181,114.281,1.818,175.623 c7.046,6.755,15.029,13.393,25.533,15.084c0-262.054-31.553-177.105,3.594-257.438c0.532-0.046,1.067-0.09,1.601-0.135 c12.918,49.526,17.92,217.654,22.498,266.01c1.299,13.692,115.748,8.242,234.616-73.654c5.064-3.491,7.944-7.23,6.568-14.418 c-6.695-34.951,2.445-18.621-17.611-79.316c-2.18-6.593-8.02-12.13-4.891-27.443c0.931-4.549,5.881-25.878,9.098-31.622 c18.31,31.595,23.06,51.25,59.7,46.29c43.34-5.863,46.912-44.086,68.661-64.93c3.331,6.577,1.842,12.006-0.486,16.203 c-11.433,20.605,8.783,43.471,26.58,43.184c20.813-0.34,31.193-6.303,26.539-10.896c-8.712-8.597-7.758-17.966-3.303-28.262 c3.093-7.146,4.937-14.827,7.433-22.239c0.423-1.255,1.323-2.348,2.254-3.942c25.747,19.907,15.898,121.648-45.184,111.959 c-29.677-4.713-33.465-26.627-36.703-35.674c-16.248,23.165-29.779,41.752-69.447,42.004c-11.775,0.076,3.12,10.508-14.587,65.364 c-5.777,17.911-15.986,32.794-32.586,42.527c-28.637,16.793-128.622,83.446-215.798,76.048c0,32.544,1.414,32.378,2.841,67.149 c3.602,87.934-2.138,184.981,33.412,225.586c25.687-144.884,52.245-102.84,29.32-136.804c0.344-0.477,0.688-0.951,1.034-1.428 c25.953,8.633,9.137,6.991,46.898-32.417c28.901-30.164,43.364-33.767,36.892-38.383c-52.236-37.264-49.01-34.854-89.945-19.609 c1.951-7.133,3.22-12.754,5.046-18.183c1.91-5.675,4.781-11.043,6.465-16.773c8.456-28.738,117.062-50.162,224.296-12.909 c6.597,2.293,5.331,3.052-9.99,42.047c-2.389,6.08-46.736,21.328-69.948,35.056c25.172,31.758,84.973,29.772,114.072,14.177 c-1.402-5.504-3.007-10.966-4.177-16.518c-3.516-16.71,3.416-64.346,29.042-91.007c15.337-15.956,39.394-30.145,53.075-10.447 c22.586,32.531,13.464,76.353-8.743,111.218c8.176,0,30.827,2.841,54.404-14.241c1.807-1.31,1.59-1.847-0.926-58.303 c-11.633-261.334-22.57-293.831,7.613-331.914c6.618,6.525,10.727,17.624,23.573,36.905 c127.621,191.624,265.285,323.036,87.812,643.864c-5.999,10.845-12.883,14.03-6.661,16.742 c40.445,17.578,92.824,44.41,196.575,67.393c351.792,77.876,710.47-8.965,817.7-93.666c8.896-7.029-3.787-54.617-21.849-86.101 c-3.51-6.122-2.221-8.227,6.229-46.669c0.21-0.968,0.985-1.813,1.918-3.456c17.678,25.609,26.984,43.727,54.422,35.779 c16.4-4.753,28.402-14.346,35.963-30.085c4.512-9.396,10.876-17.916,16.654-26.668c5.207-7.891,8.305-1.097,12.546-6.22 c15.929-19.257,34.887-40.943,58.772-32.656c24.401,8.469,33.596,51.5,30.575,78.251c-2.545,22.447-18.298,43.468-27.978,46.524 c-24.861,7.829-69.788-26.525-73.258-28.302c-2.103,9.94-4.74,19.147-5.857,28.53c-4.869,40.925,21.575,56.026,43.975,50.256 c32.565-8.39,49.1-39.365,78.576-78.146c49.078-64.574,50.511-63.799,50.445-68.558c-2.263-172.733-2.3-144.779-3.916-173.422 c-11.481-0.797-22.3-1.391-33.094-2.332c-36.572-3.192-102.703-34.573-102.703-131.37c-4.39,5.75,0.781-2.864-26.501,44.253 c-17.119,29.568-28.736,44.044-28.635,74.848c0.061,16.929,15.69,40.406,32.021,21.451c2.424-2.808,3.58-5.21,10.68-19.668 c3.549,3.462,5.836,6.406-7.21,40.655c-4.774,12.526-13.154,22.502-24.946,28.891c-22.536,12.194-50.541-34.445-25.665-85.019 c50.778-103.187,68.315-100.732,76.311-134.966c4.77-20.39,22.285-70.669,36.791-81.364c0.455,0.235,0.916,0.469,1.375,0.705 c-4.314,18.336-43.839,78.841-19.427,129.625c22.922,47.708,59.287,67.088,108.393,65.559 c2.063-12.271-6.876-171.873-8.577-192.779c-2.549-31.359-8.792-32.609,1.73-58.01c13.074-31.561,11.684-27.362,13.899-29.467 c18.01,84.681,10.271,115.93,20.106,231.697c35.902-28.659,73.59-53.789,102.356-89.432c-11.783-8.42-18.721-11.024-14.915-20.669 c3.373-8.537,6.768-17.215,14.744-22.953c3.671-2.639,7.381-4.28,11.858-2.788c10.295,3.429,6.359,12.518,2.238,35.298 c4.889,5.747,5.441,8.934,1.726,15.171c-3.924,6.587-6.029,2.779-11.201-0.789c-16.238,20.175-36.666,45.761-59.275,60.279 c-40.581,26.051-47.598,27.817-47.523,32.507c0.193,12.453,0.811,24.9,1.336,38.363c54.251-13.1,118.876-43.516,164.532-83.446 c9.094-7.968-3.767-55.409-9.032-70.424c-18.17-51.818-15.052-20.32-0.539-78.197c0.906-0.121,1.809-0.241,2.716-0.362 c18.333,32.275,14.528,39.381,39.052,44.424c52.014,10.688,62.173-46.74,84.441-61.615c0.495,0.258,0.994,0.517,1.489,0.776 c-1.696,11.399-0.692,7.604-4.363,19.642c-8.589,28.186,25.776,50.325,54.549,31.78c-4.72-10.442-8.837-17.883-7.666-22.441 c1.221-4.772,8.743-33.619,12.51-40.459c19.113,26.348,13.707,65.695-2.961,94.551c-16.998,29.414-62.035,29.83-77.905-15.562 c-0.219,0.136-70.721,43.384-69.364,42.551c-11.168,77.968-8.701,85.723-66.779,125.349 c-132.617,90.535-120.277,19.459-118.687,101.288C2057.359,479.97,2058.759,572.063,2060.467,582.59z M691.28,487.566 c-29.225,10.742-9.369,26.576-11.525,169.959c-0.239,15.866-1.29,31.788-3.221,47.536c-3.209,26.168-13.401,35.309-4.118,39.752 c0,0,33.717,27.894,72.198,46.993c3.406,1.691,5.114,1.244,6.627-2.111c11.448-25.358,23.558-50.44,34.301-76.092 c11.608-27.719,19.604-56.643,25.496-86.145c39.842-199.449-40.89-287.544-149.262-445.412 c-2.822,6.987,10.358,274.993,12.108,282.117c8.306-9.929,18.481-21.691,29.703-26.444c17.604-7.448-2.542,35.933,20.5,52.722 c11.388,8.295,21.151,5.048,31.984,5.048c0.298-0.043,19.733-9.118,20.003-9.251c6.935-3.432,1.7-7.759-4.781-22.386 c-3.698-8.36-4.706-2.87,7.162-46.502c0.32-1.181,1.516-2.125,2.296-3.167c8.323,4.78,27.542,42.215,4.36,96.969 c-14.797,34.954-63.21,40.349-81.326,19.412C691.619,516.499,692.264,500.125,691.28,487.566z M2484.125,412.519 c0,1.529,0.289,2.672-0.048,3.581c-4.578,12.322-9.146,24.653-14.013,36.861c-2.729,6.857-10.105,1.001-9.562,11.201 c10.948,206.671-13.505,135.422,30.452,173.976c43.43,38.101,36.424,82.947,34.259,113.842c6.003-8.858,4.347-8.381,13.045-25.8 c10.283-20.587,22.851-38.287,35.184-87.687c52.947-212.018-62.316-329.338-120.658-450.773 c-2.451,3.443,4.16,140.319,5.484,213.42C2458.415,409.214,2461.427,408.009,2484.125,412.519z M2186.066,613.796 c-31.529,44.806-55.044,105.343-42.875,158.395c1.171,5.154,8.695,6.284,14.14,6.868c83.096,8.961,132.279-34.963,188.51-63.989 c9.552-4.936,6.114,7.155,8.222,25.52c3.045,26.524,19.403,44.166,48.776,40.076c16.3-2.272,38.348-7.948,37.356-24.337 c-5.739-94.693,3.297-92.645-11.004-94.525c-17.714-2.33-35.428-5.046-53.235-6.238c-56.933-3.808-140.455,7.301-176.889-29.406 C2194.87,621.931,2190.433,617.935,2186.066,613.796z M285.983,588.188c-6.781,8.404-21.735,34.839-26.512,45.114 c-8.833,19.004-13.541,31.689-18.536,74.769c-0.553,4.769,4.34,8.919,20.513,19.65c35.83,23.769,71.456,19.571,114.486,17.005 c98.706-5.88,182.154-85.435,179.095-57.777c-2.437,22.086,4.002,56.509,29.859,63.673c13.709,3.793,19.364,0.403,18.42-13.702 c-6.834-102.42-140.552-102.078-217.003-105.169C333.746,629.631,305.261,602.768,285.983,588.188z M2163.73,828.374 c95.142,141.082,270.082,71.874,339.901-52.828c5.55-9.908,11.197-19.773,8.919-32.608c-4.606-25.939-18.66-49.818-47.431-67.979 c-7.038,33.556,6.627,40.995-17.934,107.464c-20.681,56.028-110.146,64.472-114.977-6.54c-0.32-4.709-1.38-9.365-2.199-14.718 c-13.07,6.299-90.01,66.207-155.018,66.411C2171.641,827.586,2168.294,828.037,2163.73,828.374z M253.466,778.928 c-0.488,0.228-0.979,0.46-1.467,0.688c4.715,9.391,8.954,19.059,14.249,28.109c56.429,96.448,194.565,118.862,306.385-9.33 c-6.189-3.961-36.915-13.834-36.971-65.303c-0.013-10.111-6.115-3.63-23.492,4.617 C444.22,769.979,363.096,819.495,253.466,778.928z M649.289,530.459c-34.005,22.993-50.478,29.952-91.213,14.022 c-4.56-1.779-7.894-1.31-12.024,0.824c-69.598,36.002-128.77,39.083-172.903-25.325c-0.832-1.216-4.205-2.015-5.545-1.334 c-29.1,14.808-55.505,38.828-63.927,49.547c-10.152,12.944,131.36,20.397,148.099,21.433c39.264,2.43,93.581,3.572,133.856,36.69 c33.57,27.598,39.194,77.311,30.312,119.3c-0.966,4.568,0.37,5.213,4.323,3.657c23.528-9.258,35.939-10.873,35.707-23.882 c-0.25-13.855,0.661-27.741,0.149-41.579C654.64,643.743,651.287,572.396,649.289,530.459z M2435.109,612.294 c0-93.873,0.13-47.769-1.437-130.4c-0.177-9.155,6.982-10.928-69.188,20.277c-54.233,22.215-61.752,27.165-94.384,43.121 c-6.497,3.169-0.508,7.074-1.476,26.015c-0.135,2.637-3.114,5.13-4.801,7.688c-25.397-17.976-4.874-29.605-48.324,2.585 c0.096,0.863,0.193,1.734,0.293,2.602C2290.25,619.676,2338.363,599.749,2435.109,612.294z M2125.428,770.496 c4.514-38.994,8.519-111.893,42.744-165.062c2.716-4.227,1.524-6.282-2.756-7.946c-35.299-13.714-67.895,1.641-96.605,25.196 c-7.768,6.367-14.811,8.173-0.048,68.558C2078.398,730.694,2099.899,757.059,2125.428,770.496z M2402.357,447.212 c-30.368-7.018-116.92-10.226-149.967-11.323c-71.253-2.37-104.626,7.127-93.644,14.571c4.227,2.865,8.209,6.1,12.48,8.892 c13.474,8.805,27.452,16.902,40.435,26.366c59.984,43.716,5.731,42.609,110.504-4.703 C2343.444,471.408,2357.34,466.133,2402.357,447.212z M593.667,469.285c-5.161-45.611-27.913-49.49-54.532-15.053 c-3.988,5.165-4.805,10.879-1.058,16.324c17.817,25.901,22.912,25.456,30.045,20.551 C592.997,473.99,590.623,473.318,593.667,469.285z M1937.868,653.61c-6.847-15.326-12.727-36.359-35.31-33.738 c-6.409,0.74-11.166,4.376-14.942,9.462C1900.197,640.985,1927.592,654.635,1937.868,653.61z M419.919,453.031 c-12.018-6.063-54.698-8.789-63.345-4.751C390.572,476.28,374.231,472.215,419.919,453.031z M2150.076,220.909 c4.666,3.029,8.998,5.839,13.466,8.741C2169.562,213.59,2158.418,209.86,2150.076,220.909z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1352.8799,
    y1: 954.1777,
    x2: 1352.8799,
    y2: 87.8159
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.884,91.771c8.466,36.878,13.463,126.491,17.142,192.486c1.651,29.603,3.076,55.169,4.457,69.757 c0.596,6.283,13.231,7.602,23.725,7.602c36.471,0,122.588-16.807,214.018-79.798c4.838-3.336,9.082-7.636,7.397-16.441 c-2.244-11.715-2.684-17.504-3.072-22.612c-0.758-9.976-1.259-16.567-14.605-56.956c-0.55-1.662-1.285-3.199-2.063-4.826 c-2.358-4.928-5.03-10.514-2.768-21.589c0.876-4.281,4.481-19.684,7.381-27.576c1.658,2.929,3.205,5.742,4.715,8.488 c11.963,21.75,19.866,36.118,44.34,36.118c3.297,0,6.788-0.256,10.672-0.781c30.175-4.082,41.594-23.206,52.637-41.7 c4.725-7.913,9.215-15.433,15.059-21.663c1.213,3.869,0.704,7.643-1.538,11.684c-5.02,9.046-4.722,19.63,0.817,29.037 c6.029,10.24,16.951,17.12,27.179,17.12c0.121,0,0.242-0.001,0.365-0.003c15.713-0.256,27.198-3.745,29.259-8.887 c0.749-1.868,0.257-3.847-1.349-5.432c-6.946-6.854-7.805-14.643-2.872-26.045c2.08-4.805,3.616-9.876,5.101-14.779 c0.761-2.511,1.547-5.107,2.392-7.615c0.157-0.466,0.441-0.955,0.804-1.529c11.751,11.679,14.495,44.161,5.527,70.422 c-4.736,13.868-16.643,37.133-43.177,37.133c-2.476,0-5.055-0.21-7.666-0.624c-25.446-4.041-30.851-21.032-34.081-31.184 c-0.366-1.151-0.712-2.237-1.053-3.189l-1.302-3.637l-2.218,3.163c-7.436,10.602-15.125,21.564-25.483,29.127 c-11.08,8.091-24.534,11.912-42.339,12.025c-1.856,0.012-3.948,0.222-5.386,1.69c-1.808,1.845-1.77,4.58-1.701,9.544 c0.124,8.852,0.354,25.327-9.391,55.517c-6.027,18.684-16.69,32.618-31.694,41.415c-2.59,1.519-5.758,3.442-9.427,5.669 c-34.842,21.149-116.436,70.675-191.607,70.675c-4.606,0-9.176-0.19-13.584-0.564l-2.169-0.184v2.177 c0,19.815,0.526,27.593,1.253,38.359c0.482,7.137,1.029,15.226,1.589,28.872c0.66,16.099,1.01,32.739,1.35,48.831 c1.565,74.198,3.043,144.281,32.556,177.99l2.746,3.137l0.728-4.105c13.925-78.541,28.239-102.109,34.351-112.172 c5.658-9.317,5.272-10.378-3.58-23.491c0.715,0.245,1.392,0.479,2.032,0.7c4.758,1.644,7.631,2.636,10.016,2.636 c4.125,0,6.093-2.802,10.013-8.385c3.899-5.552,10.425-14.844,23.895-28.902c12.973-13.54,22.949-21.637,29.551-26.995 c6.531-5.301,9.512-7.721,9.421-10.664c-0.065-2.098-1.794-3.331-2.362-3.736c-31.022-22.131-42.629-30.411-55.88-30.411 c-7.967,0-15.898,2.998-29.037,7.966c-1.051,0.397-2.134,0.807-3.252,1.228c0.244-0.927,0.48-1.832,0.712-2.724 c1.114-4.277,2.076-7.97,3.292-11.584c0.833-2.476,1.886-4.967,2.905-7.377c1.289-3.049,2.623-6.203,3.583-9.469 c2.363-8.03,14.14-15.946,32.313-21.718c19.537-6.206,45.293-9.624,72.524-9.624c27.377,0,69.878,3.428,116.884,19.757 c1.332,0.463,2.139,0.808,2.319,1.202c0.864,1.887-2.37,10.053-8.813,26.322c-1.39,3.51-2.954,7.459-4.698,11.899 c-0.167,0.371-1.32,1.884-9.163,5.796c-5.526,2.756-12.926,6.005-20.761,9.444c-13.355,5.862-28.491,12.507-39.183,18.831 l-1.973,1.167l1.424,1.797c13.048,16.462,37.022,25.904,65.775,25.904c18.722,0,37.716-4.189,50.809-11.206l1.38-0.739 l-0.386-1.517c-0.448-1.761-0.918-3.518-1.387-5.275c-0.976-3.653-1.985-7.431-2.771-11.162 c-1.567-7.447-1.07-22.969,3.572-40.858c3.63-13.99,10.906-33.735,24.955-48.351c11.7-12.173,24.553-19.44,34.382-19.44 c6.326,0,11.577,2.943,15.608,8.747c10.376,14.944,14.441,32.898,12.082,53.364c-2.105,18.27-9.322,37.509-20.869,55.639 l-1.958,3.074h3.645c0.843,0,1.862,0.032,3.041,0.069c1.626,0.051,3.469,0.108,5.577,0.108c17.855,0,33.215-4.84,46.96-14.798 c1.71-1.24,2.048-2.621,2.01-8.213c-0.038-5.589-0.515-16.206-1.465-37.356c-0.196-4.354-0.411-9.153-0.647-14.442 c-2.575-57.84-5.13-104.744-7.183-142.433c-3.623-66.497-5.81-106.634-4.146-133.489c1.49-24.062,6.011-38.205,17.082-52.817 c2.857,3.348,5.454,7.871,8.851,13.791c3.219,5.609,7.226,12.589,12.92,21.136c13.283,19.944,26.762,39.364,39.798,58.144 c28.43,40.958,55.284,79.645,77.462,119.649c24.868,44.856,40.205,84.817,48.268,125.759c9.402,47.743,8.575,96.449-2.529,148.899 c-12.291,58.058-36.913,119.991-75.273,189.336c-2.012,3.638-4.125,6.379-5.824,8.583c-2.42,3.14-4.019,5.215-3.419,7.552 c0.485,1.887,2.249,2.849,3.534,3.409c5.15,2.238,10.48,4.62,16.123,7.143c38.025,16.996,90.102,40.273,180.817,60.368 c91.109,20.169,187.477,30.395,286.427,30.395c113.475,0,227.105-13.494,328.605-39.025 c89.699-22.562,164.178-53.696,204.34-85.42c6.624-5.234,2.769-24.77-0.119-35.95c-4.619-17.883-12.558-37.59-21.236-52.715 c-2.619-4.57-2.177-6.551,3.242-30.807c0.926-4.143,1.992-8.915,3.207-14.444c0.012-0.056,0.035-0.121,0.068-0.195 c0.86,1.258,1.701,2.496,2.527,3.711c12.732,18.736,21.932,32.273,39.786,32.273c3.88,0,7.989-0.644,12.562-1.968 c17.393-5.04,29.565-15.226,37.209-31.14c3.394-7.068,7.97-13.798,12.395-20.306c1.361-2.002,2.769-4.072,4.125-6.126 c2.15-3.258,3.575-3.258,4.518-3.258c0.321,0,0.637,0.019,0.952,0.036c0.383,0.021,0.763,0.041,1.143,0.041 c1.598,0,3.703-0.326,5.805-2.866c14.71-17.783,29.356-33.746,46.777-33.746c3.242,0,6.538,0.573,9.798,1.704 c10.303,3.576,18.943,14.587,24.326,31.004c4.594,14.012,6.479,31.306,4.917,45.133c-2.445,21.568-17.818,42.072-26.591,44.842 c-2.247,0.707-4.793,1.066-7.569,1.066c-21.042,0-50.755-20.208-60.519-26.849c-2.139-1.455-3.108-2.11-3.657-2.391l-2.327-1.191 l-0.541,2.558c-0.65,3.071-1.36,6.11-2.047,9.05c-1.572,6.728-3.057,13.083-3.839,19.658c-2.657,22.331,3.98,35.12,10.016,41.916 c6.735,7.584,16.206,11.76,26.668,11.76c3.275,0,6.563-0.42,9.775-1.247c27.293-7.032,43.762-29.727,64.612-58.46 c4.752-6.549,9.667-13.322,15.056-20.413c17.218-22.654,28.55-37.238,36.049-46.888c14.298-18.4,14.856-19.118,14.803-22.907 c-1.883-143.715-2.22-148.488-3.221-162.656c-0.2-2.833-0.427-6.045-0.698-10.852l-0.099-1.76l-1.759-0.122 c-3.613-0.251-7.16-0.481-10.662-0.709c-7.724-0.502-15.019-0.977-22.397-1.62c-8.435-0.736-37.966-5.078-63.852-30.031 c-11.248-10.843-20.086-24.028-26.269-39.188c-7.137-17.502-10.756-37.742-10.756-60.159v-5.915l-3.59,4.702 c-0.607,0.795-1.016,1.295-1.377,1.736c-1.88,2.299-1.88,2.299-15.007,24.997c-2.779,4.806-6.151,10.637-10.259,17.731 c-2.387,4.123-4.645,7.915-6.828,11.582c-13.347,22.415-22.165,37.224-22.076,64.275c0.024,6.614,2.254,14.083,5.967,19.981 c4.265,6.774,9.793,10.505,15.566,10.505c4.869,0,9.58-2.603,14.001-7.735c2.409-2.791,3.627-5.164,9.51-17.14 c1.231,3.334,0.18,10.896-9.424,36.107c-4.726,12.398-12.811,21.766-24.029,27.844c-2.11,1.142-4.314,1.721-6.551,1.721 c-6.259,0-12.665-4.524-17.576-12.413c-8.775-14.095-13.724-41.327,1.208-71.685c27.384-55.647,45.082-80.5,56.793-96.945 c9.921-13.932,15.909-22.341,19.671-38.448c4.765-20.369,20.016-63.237,32.966-77.386c-1.28,3.511-3.211,7.935-5.469,13.107 c-11.952,27.378-31.956,73.2-12.508,113.656c21.589,44.934,55.9,66.777,104.894,66.777c1.764,0,3.569-0.028,5.364-0.084 l1.638-0.051l0.272-1.616c2.124-12.634-6.977-173.869-8.556-193.273c-0.752-9.252-1.828-15.935-2.692-21.305 c-2.087-12.965-2.951-18.331,4.276-35.777c6.628-15.999,9.498-22.703,10.969-25.652c10.378,50.15,11.585,81.701,13.239,124.924 c1.053,27.505,2.246,58.681,5.956,102.361l0.317,3.728l0.534-0.426c-0.646,1.01-0.867,2.003-0.849,3.183 c0.147,9.491,0.537,18.913,0.951,28.887c0.129,3.125,0.261,6.295,0.387,9.523l0.095,2.439l2.373-0.573 c59.192-14.293,122.562-46.436,165.381-83.886c4.58-4.013,5.077-15.278,1.517-34.439c-2.63-14.159-7.017-29.702-9.98-38.151 c-3.645-10.395-6.422-17.414-8.451-22.54c-2.536-6.408-3.808-9.624-3.964-12.35c-0.152-2.655,0.767-5.326,2.599-10.646 c2.035-5.91,5.082-14.758,8.997-30.195l0.032-0.004c4.188,7.451,7.197,13.555,9.638,18.508 c8.012,16.254,10.712,21.729,30.087,25.713c4.386,0.901,8.654,1.358,12.686,1.358c28.289,0,42.295-21.51,54.653-40.488 c5.516-8.472,10.757-16.52,16.629-21.306c-0.136,0.956-0.25,1.771-0.348,2.482c-0.654,4.707-0.654,4.707-2.759,11.587 l-0.803,2.628c-2.916,9.568-1.334,19.142,4.453,26.956c6.601,8.912,17.683,14.232,29.646,14.232c8.087,0,16.195-2.47,23.446-7.144 l1.449-0.934l-0.71-1.571c-0.791-1.749-1.564-3.414-2.299-4.996c-3.38-7.273-6.049-13.018-5.251-16.125 c2.521-9.855,7.602-28.434,10.927-36.877c16.855,26.522,9.864,63.658-5.047,89.472c-7.079,12.249-19.388,19.562-32.926,19.562 c-18.284,0-33.745-13.003-41.36-34.783l-0.823-2.347l-2.117,1.306c-0.236,0.145-21.167,12.985-39.634,24.314 c-15.216,9.334-29.135,17.873-29.766,18.26l1.057,1.675l-1.95-0.279c-0.708,4.943-1.361,9.603-1.979,14.008 c-9.11,65.004-10.281,73.356-63.948,109.973c-59.668,40.734-90.115,48.664-104.748,52.475 c-16.496,4.296-16.437,5.76-15.456,30.216c0.216,5.39,0.486,12.098,0.645,20.287c0.028,1.464,0.072,3.962,0.129,7.255 c0.737,42.5,1.876,99.983,3.252,108.468l0.542,3.336l2.664-2.08c1.137-0.888,2.397-1.907,3.855-3.087 c13.947-11.282,42.967-34.758,81.401-34.758c2.33,0,4.69,0.087,7.014,0.258c15.497,1.142,28.449,6.416,38.496,15.676 c1.225,1.127,2.613,2.405,4.556,2.405c2.96,0,5.549-2.668,14.125-11.508c2.374-2.446,5.327-5.491,8.844-9.049 c0.313-0.317,0.612-0.607,0.89-0.877c1.43-1.39,2.782-2.702,2.613-4.64c-0.257-2.958-3.504-5.167-17.171-14.464 c-9.736-6.624-24.449-16.634-46.567-32.637c-9.35-6.765-16.319-15.911-20.154-26.447c-3.595-9.874-4.354-20.54-2.198-30.843 c4.299-20.539,18.927-35.418,39.129-39.802c14.944-3.241,36.159-4.885,63.057-4.885c63.655,0,145.463,9.326,183.767,14.837 c0.711,0.102,1.36,0.235,1.987,0.364c0.996,0.205,1.857,0.381,2.707,0.381c1.247,0,2.272-0.409,3.048-1.215 c2.663-2.767,2.398-9.692,1.124-42.971c-1.365-35.666-3.907-102.055-4.969-222.67c-0.039-4.527,3.24-10.154,15.435-31.09 c1.314-2.255,2.73-4.687,4.257-7.314c11.279,21.636,16.781,33.464,22.106,44.913c8.675,18.648,16.167,34.753,46.438,88.005 c1.958,3.445,4.057,7.107,6.273,10.972c16.476,28.736,39.04,68.09,57.575,112.657c21.849,52.537,32.841,100.44,32.671,142.381 c-0.299,80.253-19.653,152.157-57.524,213.712c-37.283,60.599-39.069,67.021-41.331,75.152c-0.628,2.26-1.278,4.596-2.84,8.415 c-9.21,22.54-22.003,43.864-38.021,63.379c-15.404,18.767-33.372,35.375-53.406,49.362 c-40.081,27.985-85.71,43.397-128.482,43.397c-16.624,0-32.672-2.324-47.7-6.907c-15.687-4.784-30.331-12.058-43.526-21.619 c-28.785-20.857-50.57-52.212-64.752-93.196c-1.826-5.264-3.529-8.882-10.279-11.109c-16.231-5.345-30.349-13.937-41.963-25.538 c-9.956-9.945-18.372-22.411-25.014-37.051c-12.201-26.895-16.34-55.854-19.362-77c-1.087-7.611-2.027-14.184-3.142-19.089 l-0.959-4.217l-2.592,3.461c-9.944,13.278-19.03,26.264-27.817,38.822c-32.527,46.487-58.218,83.206-92.104,83.206 c-7.026,0-14.127-1.528-21.71-4.673c-20.501-8.493-29.522-25.002-33.479-37.356c-4.728-14.76-4.925-32.469-0.525-47.373 c6.882-23.294,6.882-23.294,6.152-26.567c-0.13-0.583-0.277-1.244-0.392-2.298l-0.154-1.418l-1.392-0.316 c-0.623-0.141-1.245-0.279-1.868-0.415l-1.358-0.298l-0.752,1.169c-3.126,4.858-5.997,9.437-8.53,13.477 c-16.445,26.229-23.951,38.2-47.568,43.157c-8.456,1.771-8.504,6.097-8.59,13.95c-0.105,9.525-0.3,27.254-14.659,59.908 c-4.212,9.581-10.834,17.318-19.684,22.995c-65.275,41.91-146.811,74.047-242.343,95.516 c-44.053,9.9-90.928,17.436-139.323,22.398c-46.471,4.765-94.532,7.181-142.848,7.181c-174.765,0-344.109-31.502-452.995-84.269 c-36.011-17.44-83.852-72.78-104.281-96.411c-4.106-4.75-7.073-8.182-8.874-10.088l-1.824-1.93l-1.352,2.285 c-0.278,0.47-0.608,1.123-1.025,1.949c-3.983,7.891-16.106,31.904-54.824,42.77c-7.29,2.043-9.46,5.509-14.704,13.883 c-3.708,5.922-8.787,14.032-18.351,26.256c-25.09,32.091-53.89,56.889-85.6,73.707c-29.324,15.553-60.89,23.773-91.283,23.773 c-57.156,0-107.467-28.146-138.033-77.221c-18.693-30.026-22.488-52.809-26.506-76.93c-0.827-4.963-1.681-10.094-2.672-15.312 c-0.29-1.527-1.24-5.318-3.791-7.533c-48.594-42.139-50.05-99.695-53.242-225.802c-0.943-37.237-2.011-79.443-4.455-129.19 c-0.227-4.606-5.781-7.189-12.812-10.458c-3.802-1.768-8.112-3.772-12.109-6.33c-13.467-8.621-24.416-19.978-32.544-33.755 c-7.483-12.683-12.589-27.411-15.178-43.774c-4.03-25.471-1.898-54.053,6.165-82.656c6.91-24.513,17.737-47.139,30.739-64.374 c-1.1,2.826-2.522,6.193-4.139,10.018c-15.046,35.606-46.356,109.698,8.379,162.161c7.379,7.074,15.708,13.862,26.6,15.615 l2.318,0.373v-2.348c0-127.214-7.483-173.105-11.08-195.159c-3.402-20.864-3.402-20.864,9.821-50.829 C165.562,97.047,166.681,94.512,167.884,91.771 M672.883,468.476l2.534-3.029c8.933-10.677,18.526-21.471,28.948-25.886 c1.088-0.46,1.991-0.694,2.685-0.694c0.591,0,1.58,0,2.195,2.916c0.55,2.609,0.549,6.418,0.549,10.829 c-0.001,12.613-0.003,29.887,13.115,39.446c7.371,5.369,14.176,6.058,19.282,6.058c2.332,0,4.673-0.159,6.938-0.313 c2.265-0.154,4.607-0.313,6.941-0.313h0.144l0.142-0.021c0.934-0.135,20.419-9.347,20.604-9.438 c2.256-1.116,3.564-2.418,4.116-4.095c0.986-2.994-0.68-6.233-3.44-11.6c-1.28-2.489-2.873-5.587-4.515-9.293 c-0.387-0.874-0.741-1.595-1.054-2.231c-2.185-4.445-2.185-4.445,5.832-33.823c0.757-2.774,1.584-5.803,2.485-9.117 c0.068-0.253,0.351-0.614,0.669-0.979c3.782,3.44,9.217,13.102,11.721,27.379c2.47,14.078,2.825,36.974-9.506,66.1 c-9.525,22.499-32.035,30.482-48.417,30.482c-12.405,0-23.177-4.228-29.555-11.599c-10.195-11.788-10.993-25.136-11.698-36.913 c-0.103-1.717-0.2-3.338-0.325-4.933l-0.206-2.632l-2.478,0.911c-19.363,7.117-18.732,16.499-16.079,55.985 c1.622,24.14,4.074,60.62,3.244,115.821c-0.241,16.013-1.32,31.934-3.207,47.323c-1.283,10.459-3.733,18.256-5.523,23.949 c-2.611,8.307-4.505,14.334,2.301,17.74c2.77,2.263,35.62,28.838,72.397,47.09c1.606,0.797,2.894,1.169,4.054,1.169 c3.021,0,4.464-2.425,5.286-4.248c3.73-8.262,7.595-16.636,11.333-24.734c7.736-16.759,15.736-34.089,22.989-51.408 c10.719-25.597,19.097-53.9,25.613-86.526c36.171-181.071-25.605-269.399-119.114-403.101 c-9.845-14.076-20.025-28.632-30.461-43.834l-2.108-3.071l-1.395,3.454c-0.371,0.919-1.143,2.83,0.311,46.842 c1.017,30.799,2.674,68.665,3.885,95.007c2.994,65.14,6.853,137.541,7.824,141.495L672.883,468.476 M2482.201,414.178 c0.034,0.48,0.069,1.043,0.002,1.226l-0.473,1.272c-4.343,11.69-8.833,23.779-13.524,35.545c-0.819,2.059-2.02,2.398-3.837,2.911 c-3.297,0.931-6.227,2.33-5.865,9.136c4.005,75.604,3.274,113.676,2.881,134.13c-0.437,22.755-0.454,23.643,8.062,27.695 c4.125,1.963,10.359,4.929,20.188,13.549c17.569,15.414,28.295,33.198,32.791,54.368c3.88,18.273,2.509,35.737,1.299,51.146 c-0.18,2.292-0.355,4.522-0.507,6.685l-0.52,7.415l4.17-6.154c3.649-5.384,4.605-7.548,6.51-11.859 c1.322-2.991,3.132-7.088,6.668-14.17c1.864-3.732,3.784-7.331,5.816-11.142c9.082-17.028,19.376-36.328,29.518-76.954 c42.036-168.324-22.113-278.37-78.71-375.461c-15.365-26.359-29.879-51.257-42.085-76.663l-1.467-3.054l-1.965,2.76 c-0.666,0.935-1.354,1.903-0.543,33.958c0.484,19.146,1.388,44.82,2.345,72.001c1.361,38.666,2.769,78.648,3.312,108.657 c0.151,8.269,3.744,8.923,17.112,11.354C2475.956,412.998,2478.831,413.52,2482.201,414.178 M561.601,495.73 c2.924,0,5.407-1.43,7.655-2.976c21.153-14.555,22.978-17.501,24.91-20.62c0.337-0.544,0.655-1.058,1.097-1.644l0.481-0.637 l-0.09-0.793c-3.913-34.577-17.188-39.74-24.753-39.74c-9.838,0-21.369,8.191-33.349,23.689 c-4.766,6.172-5.165,12.806-1.122,18.679C548.486,489.214,555.308,495.73,561.601,495.73 M2249.46,519.537 c3.525,0,7.325-2.208,15.653-7.045c10.182-5.914,27.225-15.813,57.875-29.654c13.285-5.998,23.582-10.261,40.642-17.323 c10.089-4.176,22.645-9.374,39.502-16.46l5.707-2.399l-6.031-1.394c-21.096-4.875-73.087-8.808-150.351-11.374 c-7.402-0.246-14.647-0.371-21.535-0.371c-33.258,0-73.129,3.368-76.043,12.859c-0.368,1.199-0.501,3.538,2.744,5.738 c1.898,1.286,3.792,2.683,5.624,4.033c2.22,1.637,4.516,3.329,6.884,4.877c4.59,2.999,9.307,5.96,13.87,8.824 c8.831,5.543,17.962,11.274,26.482,17.484c15.621,11.384,23.258,19.527,28.311,24.915 C2243.2,516.948,2245.628,519.537,2249.46,519.537 M383.991,470.351c3.808,0,7.774-1.95,14.975-5.489 c5.086-2.5,12.052-5.924,21.727-9.987l3.996-1.678l-3.869-1.952c-8.533-4.304-30.715-6.877-47.23-6.877 c-6.098,0-14.147,0.364-17.862,2.1l-2.871,1.341l2.446,2.015c4.992,4.111,8.919,7.55,12.074,10.314 C375.384,467.15,379.039,470.351,383.991,470.351 M2263.4,576.208c-6.324-4.779-9.37-9.03-11.438-11.915 c-1.989-2.776-3.56-4.969-6.503-4.969c-3.561,0-7.879,3.236-20.695,12.844c-3.027,2.269-6.458,4.841-10.457,7.803l-0.925,0.685 l0.128,1.144l0.069,0.62c0.074,0.662,0.148,1.327,0.225,1.99l0.127,1.099l0.999,0.476c47.49,22.639,83.665,22.918,129.465,23.271 c25.787,0.199,55.014,0.425,90.456,5.02l2.257,0.293v-2.276l0.002-19.815c0.006-45.386,0.006-45.386-0.432-63.547 c-0.212-8.795-0.533-22.085-1.006-47.077c-0.014-0.719,0.022-1.395,0.058-2.049c0.094-1.755,0.184-3.413-0.972-4.633 c-0.701-0.74-1.704-1.115-2.983-1.115c-4.209,0-13.74,3.923-45.321,16.923c-6.602,2.717-14.134,5.818-22.727,9.338 c-43.428,17.789-56.919,24.51-77.34,34.684c-4.982,2.482-10.629,5.295-17.163,8.49c-5.024,2.451-4.447,5.97-3.648,10.84 c0.616,3.752,1.459,8.891,1.052,16.87c-0.059,1.154-1.307,2.669-2.514,4.134C2263.875,575.624,2263.636,575.914,2263.4,576.208  M617.302,752.034c0.975,0,2.115-0.278,3.697-0.9c4.272-1.681,8.227-3.127,11.717-4.404c15.884-5.81,25.472-9.316,25.257-21.375 c-0.112-6.187,0.012-12.503,0.132-18.611c0.148-7.536,0.3-15.329,0.016-23.006c-1.102-29.791-3.337-79.96-6.835-153.374 l-0.169-3.556l-2.949,1.994c-22.353,15.114-35.966,22.308-52.87,22.308c-10.083,0-21.679-2.698-36.496-8.493 c-2.125-0.829-4.073-1.231-5.954-1.231c-2.468,0-4.847,0.66-7.716,2.142c-32.827,16.981-60.673,25.235-85.13,25.235 c-34.319,0-62.19-16.327-85.204-49.914c-1.091-1.594-3.835-2.455-5.862-2.455c-0.876,0-1.63,0.157-2.241,0.468 c-28.68,14.595-55.498,38.519-64.594,50.095c-1.008,1.285-1.222,2.75-0.602,4.124c1.059,2.349,4.533,5.199,22.264,8.522 c10.531,1.973,25.056,3.894,43.172,5.71c32.098,3.217,67.259,5.281,80.496,6.057c1.804,0.106,3.23,0.19,4.219,0.251 c2.435,0.151,4.929,0.296,7.473,0.445c19.326,1.13,41.231,2.41,63.14,7.272c25.264,5.607,45.576,14.936,62.097,28.521 c15.354,12.622,25.578,30.496,30.389,53.125c4.204,19.773,3.94,41.979-0.764,64.217c-0.412,1.947-0.673,4.134,0.51,5.594 C614.955,751.361,615.813,752.034,617.302,752.034 M332.602,748.752c11.099,0,22.49-0.718,34.55-1.479 c2.933-0.185,5.899-0.372,8.901-0.551c56.999-3.395,108.196-30.77,142.074-48.884c15.371-8.219,27.512-14.71,32.851-14.71 c0.822,0,1.381,0.158,1.66,0.471c0.249,0.278,0.632,1.054,0.402,3.131c-2.459,22.289,3.851,58.211,31.314,65.82 c3.685,1.02,6.725,1.515,9.292,1.515c3.72,0,6.492-1.03,8.475-3.15c2.628-2.809,3.639-7.299,3.182-14.128 c-2.926-43.847-28.233-73.147-77.367-89.576c-41.097-13.741-90.341-15.557-129.909-17.016c-4.004-0.148-7.891-0.291-11.641-0.443 c-20.532-0.828-39.069-5.477-56.67-14.21c-15.036-7.461-26.751-16.642-36.165-24.02c-2.233-1.75-4.342-3.403-6.362-4.93 l-1.546-1.169l-1.217,1.508c-6.687,8.289-21.793,34.824-26.769,45.527c-9.235,19.87-13.796,33.006-18.708,75.382 c-0.682,5.885,4.476,10.321,21.394,21.547C286.065,746.451,311.305,748.752,332.602,748.752 M2127.079,773.626l0.335-2.899 c0.504-4.353,1.004-9.152,1.534-14.233c4.281-41.067,10.749-103.128,40.906-149.978c1.034-1.609,2.317-4.031,1.525-6.466 c-0.788-2.423-3.213-3.638-5.239-4.426c-9.059-3.52-18.381-5.304-27.708-5.304c-22.426,0-45.614,10.081-70.89,30.818 c-0.379,0.311-0.757,0.611-1.13,0.907c-8.892,7.061-13.257,13.778,0.408,69.672c9.071,37.141,29.554,65.747,57.676,80.55 L2127.079,773.626 M2178.949,782.243c54.895,0,94.841-23.424,133.473-46.076c11.173-6.551,22.725-13.325,34.337-19.319 c1.416-0.731,2.199-0.885,2.607-0.885c1.468,0,1.648,5.52,1.821,10.857c0.126,3.886,0.283,8.723,0.889,13.999 c3.051,26.572,18.974,42.436,42.593,42.436c2.709,0,5.55-0.204,8.446-0.607c26.765-3.73,39.912-12.626,39.076-26.439 c-2.219-36.606-2.226-58.893-2.23-72.208c-0.007-21.082-0.007-22.804-10.125-24.128l-0.384-0.05 c-3.55-0.467-7.1-0.949-10.651-1.432c-13.967-1.898-28.408-3.861-42.712-4.818c-13.633-0.912-28.563-0.971-44.37-1.034 c-48.779-0.194-104.066-0.415-131.232-27.784c-2.911-2.935-5.979-5.797-8.946-8.564c-1.367-1.275-2.737-2.553-4.099-3.845 l-1.68-1.592l-1.332,1.893c-37.726,53.613-53.871,113.423-43.19,159.989c1.564,6.878,11.231,7.915,15.876,8.413 C2164.471,781.841,2171.817,782.243,2178.949,782.243 M1936.706,655.664c0.477,0,0.935-0.022,1.362-0.064l2.757-0.276l-1.13-2.53 c-0.76-1.701-1.496-3.447-2.276-5.295c-5.613-13.299-12.598-29.851-31.129-29.851c-1.277,0-2.61,0.08-3.96,0.236 c-6.406,0.74-11.744,4.094-16.318,10.256l-1.07,1.441l1.316,1.219C1897.979,641.657,1924.548,655.664,1936.706,655.664  M2383.18,824.797c-22.063,0-46.515-12.885-48.976-49.048c-0.223-3.278-0.785-6.486-1.38-9.883 c-0.282-1.611-0.574-3.276-0.838-5.001l-0.409-2.674l-2.436,1.174c-2.559,1.233-7.251,4.295-13.747,8.534 c-14.333,9.353-35.993,23.487-61.159,35.637c-30.147,14.555-56.811,21.971-79.249,22.042c-2.313,0.006-4.58,0.211-7.204,0.448 c-1.319,0.119-2.684,0.243-4.2,0.355l-3.439,0.254l1.928,2.859c34.931,51.798,83.064,79.177,139.194,79.177 c77.831,0,159.856-53.105,204.11-132.145l0.208-0.37c5.56-9.924,11.31-20.186,8.935-33.564 c-5.151-29.005-21.412-52.328-48.332-69.321l-2.434-1.536l-0.591,2.817c-2.513,11.982-2.434,20.624-2.35,29.773 c0.149,16.217,0.317,34.597-15.502,77.409C2435.95,807.087,2410.402,824.797,2383.18,824.797 M335.741,792.2 c-27.351,0-54.036-4.955-81.581-15.147l-0.783-0.29l-0.756,0.353l-0.757,0.355l-0.711,0.333l-1.865,0.87l0.924,1.839 c1.457,2.902,2.895,5.886,4.286,8.772c3.113,6.46,6.332,13.14,10.024,19.45c29.542,50.492,81.503,80.636,138.995,80.636 c59.593,0,120.189-31.843,170.623-89.662l1.525-1.749l-1.954-1.251c-0.735-0.47-1.693-0.97-2.906-1.602 c-4.852-2.529-12.972-6.763-20.045-15.983c-8.67-11.302-13.077-26.791-13.098-46.036c-0.002-1.77-0.009-7.159-4.682-7.159 c-2.524,0-5.735,1.714-11.056,4.553c-2.876,1.535-6.455,3.445-10.612,5.418c-6.396,3.038-12.781,6.165-19.54,9.476 C446.967,767.325,396.185,792.2,335.741,792.2 M2164.451,199.899c0.905,0,1.799,0.151,2.734,0.463 c6.674,2.223,6.098,6.596,2.841,22.963c-0.594,2.984-1.267,6.366-1.938,10.081l-0.168,0.931l0.613,0.721 c4.443,5.223,4.715,7.505,1.531,12.852c-1.448,2.43-2.209,2.619-2.409,2.619c-0.673,0-2-1.039-3.283-2.044 c-0.778-0.61-1.66-1.3-2.655-1.987l-1.529-1.055l-1.165,1.447l-0.717,0.891c-16.073,19.973-36.076,44.83-58.081,58.959 c-14.034,9.009-23.924,15.034-31.145,19.433c-3.257,1.984-5.93,3.612-8.115,4.993c5.974-4.689,12.001-9.319,17.878-13.834 c27.659-21.247,56.259-43.218,78.843-71.202l1.332-1.65l-1.726-1.233c-1.766-1.262-3.453-2.414-4.942-3.431 c-9.26-6.325-11.817-8.435-9.276-14.876l0.06-0.151c3.363-8.512,6.539-16.552,13.992-21.913 C2159.991,200.817,2162.25,199.899,2164.451,199.899 M2164.541,232.685l0.874-2.332c2.369-6.321,2.444-11.577,0.21-14.8 c-1.329-1.918-3.382-2.974-5.781-2.974c-3.804,0-7.946,2.597-11.364,7.125l-1.293,1.713l1.801,1.169l5.638,3.66l7.828,5.082 L2164.541,232.685 M168.977,87.816c-0.535,0.046-1.069,0.09-1.601,0.135c-35.147,80.334-3.594-4.615-3.594,257.438 c-10.504-1.691-18.488-8.329-25.533-15.084c-63.999-61.343-7.969-153.313-1.818-175.623c-0.644-0.243-1.286-0.489-1.927-0.734 c-46.269,56.344-69.867,182.105,7.861,231.865c10.957,7.012,23.734,9.761,24.002,15.202 c10.846,220.694-5.202,301.263,58.385,356.404c1.665,1.446,2.705,4.122,3.136,6.395c5.774,30.408,6.647,56.306,29.445,92.926 c31.704,50.902,83.361,78.164,139.731,78.164c60.345,0,126.089-31.268,178.458-98.248c23.211-29.67,20.835-36.312,32.019-39.446 c43.594-12.234,54.387-41.156,57.031-45.626c10.982,11.626,70.362,85.92,113.737,106.926 c108.696,52.674,277.952,84.469,453.867,84.469c190.217,0,388.211-37.203,525.595-125.412c9.115-5.848,16.002-13.79,20.434-23.873 c25.934-58.978,6.182-69.428,21.828-72.706c28.247-5.929,34.162-21.438,57.37-57.51c0.618,0.135,1.235,0.271,1.853,0.412 c0.689,6.356,2.556,0.172-5.69,28.083c-8.443,28.602-1.84,71.817,35.157,87.143c7.947,3.295,15.39,4.825,22.476,4.825 c44.194,0,74.189-59.627,121.521-122.828c7.123,31.331,7.056,132.554,90.805,160.134c5.857,1.932,7.25,4.775,9.015,9.865 c30.107,87.005,91.853,123.066,157.868,123.066c88.058,0,183.692-64.226,221.759-157.382c7.08-17.311-4.008-5.208,44.023-83.276 c36.63-59.537,57.508-130.782,57.821-214.753c0.424-104.081-65.889-212.649-96.78-267.005 c-49.133-86.431-38.252-75.039-69.662-135.059c-1.253,1.082-1.949,1.437-2.282,2.006c-16.275,28.002-20.079,33.932-20.031,39.544 c2.147,243.827,10.289,264.839,2.797,264.839c-1.105,0-2.553-0.458-4.409-0.725c-39.264-5.649-120.113-14.858-184.051-14.858 c-24.861,0-47.176,1.393-63.481,4.93c-46.623,10.118-57.018,72.091-17.526,100.668c66.748,48.295,66.908,42.593,59.985,49.591 c-14.833,15.011-18.774,19.964-21.548,19.964c-1.057,0-1.945-0.72-3.201-1.877c-11.174-10.298-24.846-15.104-39.704-16.199 c-2.423-0.179-4.808-0.264-7.161-0.264c-43.051,0-74.112,28.604-86.488,38.268c-1.708-10.528-3.108-102.62-3.355-115.441 c-1.59-81.828-13.93-10.753,118.687-101.288c58.078-39.626,55.612-47.381,66.779-125.349c-0.013,0.008-0.019,0.012-0.02,0.012 c0,0,0.006-0.004,0.02-0.012c1.318-0.81,69.148-42.418,69.364-42.552c8.748,25.02,26.357,36.123,43.248,36.123 c13.752,0,27.029-7.36,34.658-20.561c16.668-28.856,22.074-68.203,2.961-94.551c-3.767,6.841-11.29,35.688-12.51,40.46 c-1.171,4.558,2.946,11.999,7.666,22.441c-7.36,4.744-15.083,6.825-22.363,6.825c-21.178,0-38.578-17.629-32.187-38.605 c3.67-12.038,2.667-8.242,4.363-19.642c-0.495-0.259-0.995-0.517-1.489-0.775c-20.394,13.623-30.624,62.931-72.158,62.931 c-3.817,0-7.905-0.418-12.283-1.317c-24.523-5.043-20.719-12.149-39.052-44.424c-0.906,0.121-1.809,0.241-2.715,0.362 c-14.514,57.877-17.631,26.378,0.539,78.196c5.266,15.015,18.127,62.456,9.032,70.424 c-45.656,39.931-110.281,70.346-164.532,83.447c-0.526-13.463-1.143-25.91-1.336-38.363c-0.075-4.69,6.943-6.456,47.523-32.507 c22.61-14.518,43.038-40.104,59.275-60.279c3.115,2.148,5.117,4.384,7.074,4.384c1.293,0,2.566-0.975,4.126-3.595 c3.715-6.238,3.163-9.424-1.726-15.171c4.121-22.78,8.057-31.869-2.239-35.298c-1.17-0.39-2.288-0.566-3.366-0.566 c-3.047,0-5.78,1.405-8.491,3.354c-7.977,5.738-11.371,14.416-14.744,22.953c-3.806,9.645,3.132,12.249,14.915,20.669 c-28.766,35.643-66.455,60.773-102.357,89.432c-9.834-115.767-2.096-147.016-20.106-231.697 c-2.215,2.105-0.825-2.094-13.899,29.467c-10.522,25.401-4.279,26.651-1.73,58.01c1.701,20.906,10.64,180.508,8.577,192.779 c-1.786,0.056-3.549,0.083-5.301,0.083c-46.426,0-81.003-19.671-103.091-65.643c-24.412-50.784,15.112-111.289,19.427-129.625 c-0.46-0.236-0.92-0.47-1.375-0.705c-14.506,10.695-32.021,60.974-36.791,81.364c-7.996,34.235-25.533,31.779-76.311,134.966 c-22.159,45.052-2.357,86.981,18.163,86.981c2.515,0,5.041-0.63,7.502-1.962c11.792-6.389,20.172-16.365,24.946-28.891 c13.046-34.249,10.759-37.192,7.21-40.654c-7.1,14.458-8.256,16.86-10.68,19.668c-4.302,4.993-8.554,7.042-12.487,7.042 c-10.997,0-19.489-16.023-19.534-28.492c-0.101-30.804,11.516-45.28,28.635-74.848c27.282-47.117,22.111-38.503,26.501-44.253 c0,96.797,66.131,128.178,102.703,131.37c10.793,0.942,21.613,1.535,33.094,2.332c1.616,28.643,1.653,0.689,3.916,173.422 c0.066,4.759-1.367,3.984-50.445,68.558c-29.475,38.781-46.01,69.757-78.575,78.147c-3.047,0.785-6.168,1.183-9.276,1.183 c-19.737,0-38.905-16.082-34.698-51.44c1.117-9.383,3.754-18.59,5.857-28.53c3.116,1.595,39.661,29.46,65.087,29.46 c2.888,0,5.635-0.36,8.17-1.158c9.68-3.056,25.433-24.077,27.978-46.524c3.021-26.751-6.174-69.782-30.575-78.251 c-3.595-1.247-7.076-1.815-10.454-1.815c-19.066,0-34.786,18.113-48.318,34.471c-1.518,1.834-2.89,2.141-4.264,2.141 c-0.691,0-1.383-0.078-2.095-0.078c-1.826,0-3.781,0.511-6.187,4.157c-5.778,8.752-12.143,17.272-16.654,26.668 c-7.561,15.739-19.563,25.332-35.963,30.085c-4.439,1.286-8.403,1.889-12.005,1.889c-18.661,0-27.599-16.203-42.417-37.668 c-0.933,1.642-1.709,2.488-1.918,3.456c-8.451,38.441-9.739,40.547-6.229,46.669c18.062,31.484,30.745,79.072,21.85,86.101 c-77.791,61.448-287.875,124.014-531.705,124.014c-92.272,0-189.415-8.968-285.994-30.348 c-103.751-22.983-156.13-49.815-196.575-67.393c-6.223-2.711,0.662-5.896,6.661-16.742 c177.473-320.828,39.809-452.24-87.812-643.863c-12.846-19.281-16.955-30.38-23.573-36.905 c-30.183,38.082-19.246,70.58-7.613,331.914c2.516,56.456,2.733,56.993,0.926,58.303c-17.694,12.819-34.862,14.418-45.786,14.418 c-3.633,0-6.578-0.177-8.618-0.177c22.207-34.865,31.329-78.687,8.743-111.218c-4.762-6.856-10.78-9.607-17.251-9.607 c-12.12,0-25.826,9.651-35.824,20.054c-25.626,26.661-32.558,74.297-29.042,91.007c1.169,5.552,2.775,11.014,4.177,16.519 c-12.622,6.764-31.021,10.968-49.865,10.968c-24.598,0-49.954-7.164-64.207-25.146c23.212-13.728,67.559-28.977,69.948-35.056 c15.321-38.995,16.586-39.754,9.99-42.047c-40.854-14.193-81.902-19.868-117.541-19.868c-57.905,0-101.521,14.988-106.755,32.777 c-1.684,5.73-4.556,11.098-6.465,16.773c-1.827,5.429-3.095,11.05-5.046,18.183c16.962-6.317,26.341-10.431,35.226-10.43 c12.557,0,24.127,8.216,54.718,30.039c6.472,4.616-7.99,8.219-36.892,38.383c-26.44,27.594-26.122,36.671-32.464,36.671 c-2.716,0-6.653-1.665-14.434-4.253c-0.346,0.477-0.69,0.95-1.034,1.428c22.925,33.964-3.633-8.08-29.32,136.804 c-35.55-40.605-29.81-137.652-33.412-225.586c-1.426-34.771-2.841-34.605-2.841-67.149c4.555,0.387,9.141,0.571,13.753,0.571 c83.673,0,174.905-60.703,202.045-76.619c16.6-9.733,26.808-24.616,32.585-42.527c17.707-54.857,2.812-65.289,14.587-65.365 c39.668-0.252,53.199-18.839,69.447-42.004c3.238,9.048,7.027,30.962,36.703,35.674c2.766,0.439,5.422,0.649,7.979,0.649 c53.917,0,61.786-93.602,37.205-112.607c-0.931,1.595-1.831,2.687-2.254,3.942c-2.497,7.412-4.341,15.093-7.433,22.239 c-4.455,10.296-5.41,19.666,3.303,28.263c4.654,4.593-5.725,10.556-26.539,10.896c-0.111,0.002-0.221,0.003-0.332,0.003 c-17.715,0-37.609-22.71-26.247-43.186c2.328-4.197,3.817-9.626,0.486-16.203c-21.749,20.844-25.321,59.067-68.661,64.93 c-3.795,0.514-7.243,0.763-10.404,0.763c-27.36,0-32.882-18.73-49.296-47.053c-3.218,5.744-8.168,27.073-9.099,31.622 c-3.129,15.314,2.711,20.85,4.891,27.443c20.056,60.694,10.916,44.364,17.611,79.316c1.376,7.188-1.505,10.927-6.568,14.418 c-88.201,60.767-173.967,79.445-212.882,79.445c-13.531,0-21.399-2.258-21.734-5.791 C186.897,305.47,181.895,137.342,168.977,87.816L168.977,87.816z M673.883,464.164c-1.75-7.124-14.93-275.13-12.108-282.117 C770.148,339.915,850.88,428.009,811.038,627.459c-5.892,29.502-13.888,58.426-25.496,86.145 c-10.743,25.651-22.852,50.734-34.301,76.092c-0.952,2.112-1.982,3.071-3.463,3.071c-0.873,0-1.902-0.333-3.164-0.96 c-38.481-19.098-72.198-46.993-72.198-46.993c-9.283-4.443,0.909-13.584,4.118-39.752c1.931-15.748,2.983-31.671,3.221-47.536 c2.157-143.383-17.7-159.217,11.525-169.959c0.984,12.559,0.339,28.933,12.504,42.998c7.036,8.131,18.637,12.29,31.068,12.29 c19.578,0,41.208-10.323,50.258-31.702c23.181-54.754,3.963-92.189-4.36-96.969c-0.78,1.042-1.976,1.987-2.296,3.167 c-11.867,43.633-10.86,38.142-7.162,46.502c6.481,14.627,11.717,18.954,4.781,22.386c-0.27,0.133-19.705,9.208-20.003,9.251 c-4.757,0-9.306,0.626-13.879,0.626c-5.84,0-11.718-1.022-18.104-5.675c-21.247-15.481-5.773-53.574-17.036-53.574 c-0.951,0-2.093,0.272-3.464,0.852C692.364,442.473,682.189,454.236,673.883,464.164L673.883,464.164z M2525.213,751.98 c2.165-30.895,9.171-75.741-34.259-113.842c-43.958-38.555-19.504,32.695-30.452-173.976c-0.543-10.2,6.833-4.344,9.562-11.201 c4.867-12.208,9.436-24.539,14.013-36.861c0.337-0.909,0.048-2.052,0.048-3.581c-22.698-4.51-25.71-3.304-25.858-11.38 c-1.323-73.1-7.935-209.977-5.484-213.42c58.342,121.436,173.605,238.755,120.658,450.773c-12.332,49.4-24.901,67.1-35.183,87.687 C2529.56,743.599,2531.217,743.122,2525.213,751.98L2525.213,751.98z M2163.542,229.651c-4.468-2.902-8.8-5.712-13.466-8.741 c3.221-4.267,6.861-6.33,9.768-6.33C2164.466,214.579,2167.238,219.792,2163.542,229.651L2163.542,229.651z M561.601,493.73 c-5.022,0-11.259-5.346-23.524-23.175c-3.748-5.445-2.93-11.159,1.058-16.324c11.732-15.177,22.712-22.912,31.766-22.912 c11.49,0,19.879,12.456,22.766,37.965c-3.044,4.033-0.67,4.705-25.545,21.821C565.9,492.635,563.875,493.73,561.601,493.73 L561.601,493.73z M2249.46,517.537c-6.494,0-8.766-10.66-37.799-31.819c-12.983-9.464-26.961-17.561-40.435-26.366 c-4.271-2.792-8.253-6.027-12.48-8.892c-9.813-6.652,15.78-14.941,72.176-14.941c6.718,0,13.884,0.118,21.468,0.37 c33.047,1.097,119.599,4.306,149.967,11.323c-45.016,18.921-58.912,24.196-80.192,33.803 C2268.103,505.428,2256.382,517.537,2249.46,517.537L2249.46,517.537z M383.991,468.351c-5.94,0-10.296-5.969-27.417-20.07 c2.813-1.314,9.226-1.912,17.015-1.912c16.154,0,38.222,2.572,46.33,6.662C397.239,462.554,389.846,468.351,383.991,468.351 L383.991,468.351z M2263.822,578.994c1.687-2.558,4.666-5.051,4.801-7.688c0.969-18.941-5.021-22.846,1.476-26.015 c32.633-15.955,40.151-20.905,94.385-43.121c47.564-19.486,62.635-26.112,67.29-26.112c2.8,0,1.832,2.397,1.898,5.835 c1.567,82.631,1.437,36.527,1.437,130.4c-96.746-12.544-144.859,7.382-219.318-28.113c-0.101-0.868-0.197-1.739-0.293-2.602 c19.829-14.69,26.335-20.254,29.962-20.254C2249.78,561.325,2250.015,569.221,2263.822,578.994L2263.822,578.994z  M617.302,750.034c-1.601,0-2.021-1.288-1.359-4.418c8.882-41.989,3.258-91.702-30.312-119.3 c-40.275-33.118-94.592-34.261-133.856-36.69c-16.739-1.036-158.251-8.49-148.099-21.433 c8.422-10.718,34.827-34.738,63.927-49.547c0.339-0.172,0.809-0.25,1.334-0.25c1.551,0,3.59,0.676,4.212,1.584 c24.561,35.844,53.773,50.784,86.854,50.784c26.362,0,55.183-9.493,86.049-25.459c2.402-1.241,4.535-1.918,6.797-1.918 c1.627,0,3.32,0.351,5.228,1.095c15.005,5.868,26.713,8.629,37.223,8.629c18.022,0,32.511-8.128,53.99-22.651 c1.998,41.937,5.352,113.284,6.834,153.353c0.512,13.837-0.399,27.723-0.149,41.579c0.232,13.008-12.179,14.624-35.707,23.882 C619.023,749.762,618.038,750.034,617.302,750.034L617.302,750.034z M332.602,746.752c-24.994,0-48.033-3.693-71.153-19.031 c-16.173-10.731-21.066-14.881-20.513-19.65c4.994-43.08,9.703-55.765,18.535-74.769c4.777-10.274,19.731-36.709,26.512-45.114 c19.277,14.58,47.763,41.442,100.322,43.563c76.451,3.091,210.169,2.749,217.002,105.169c0.709,10.596-2.305,15.145-9.661,15.145 c-2.436,0-5.349-0.499-8.759-1.443c-25.856-7.164-32.296-41.588-29.859-63.673c0.451-4.075-0.973-5.821-4.051-5.821 c-17.809,0-90.882,58.585-175.044,63.598C360.671,745.636,346.343,746.752,332.602,746.752L332.602,746.752z M2125.428,770.496 c-25.529-13.438-47.029-39.802-56.665-79.255c-14.763-60.384-7.719-62.191,0.048-68.558 c21.242-17.428,44.605-30.365,69.622-30.365c8.796,0,17.801,1.601,26.984,5.169c4.279,1.664,5.471,3.719,2.755,7.946 C2133.947,658.603,2129.942,731.502,2125.428,770.496L2125.428,770.496z M2178.949,780.243c-6.948,0-14.153-0.379-21.619-1.184 c-5.444-0.584-12.968-1.714-14.14-6.868c-12.169-53.052,11.346-113.589,42.875-158.395c4.367,4.139,8.804,8.134,13.001,12.366 c36.434,36.707,119.956,25.598,176.889,29.406c17.807,1.191,35.521,3.907,53.235,6.238c14.3,1.88,5.264-0.168,11.003,94.525 c0.992,16.389-21.056,22.065-37.356,24.337c-2.847,0.396-5.568,0.588-8.17,0.588c-24.245,0-37.856-16.711-40.606-40.664 c-1.787-15.57,0.413-26.629-4.697-26.629c-0.917,0-2.071,0.357-3.525,1.108C2294.662,741.489,2249.334,780.243,2178.949,780.243 L2178.949,780.243z M1936.705,653.664c-11.048,0-36.957-13.094-49.089-24.331c3.776-5.086,8.533-8.722,14.942-9.462 c1.298-0.151,2.539-0.223,3.73-0.223c19.529,0,25.127,19.516,31.58,33.961C1937.502,653.646,1937.114,653.664,1936.705,653.664 L1936.705,653.664z M2383.18,826.797c25.715,0,53.588-16.15,64.006-44.373c24.561-66.469,10.895-73.908,17.933-107.464 c28.771,18.161,42.824,42.041,47.431,67.979c2.278,12.835-3.369,22.7-8.918,32.608 c-42.452,75.823-123.754,131.123-202.365,131.123c-50.677,0-100.243-22.995-137.536-78.295c4.564-0.337,7.911-0.789,11.262-0.797 c65.007-0.204,141.948-60.112,155.018-66.411c0.819,5.353,1.879,10.009,2.199,14.718 C2334.606,811.125,2357.845,826.797,2383.18,826.797L2383.18,826.797z M335.741,794.199c69.878,0,126.686-32.867,176.429-56.491 c11.055-5.247,17.546-9.778,20.81-9.778c1.867,0,2.677,1.483,2.682,5.161c0.056,51.469,30.782,61.342,36.971,65.303 c-54.292,62.242-114.781,88.977-169.116,88.977c-57.573,0-108.238-30.027-137.269-79.646c-5.296-9.05-9.534-18.718-14.249-28.109 c0.489-0.228,0.979-0.46,1.467-0.688C282.84,789.798,310.164,794.199,335.741,794.199L335.741,794.199z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1143.1141,
    y1: 318.3216,
    x2: 1545.5387,
    y2: 318.3216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1233.349,426.99c-33.507,0-95.465,5.004-86.254-26.403c4.726-16.118,15.62-25.794,30.38-32.006 c9.821-4.135,16.214-11.801,22.267-20.126c5.883-8.081,17.105-17.259,19.937-4.95c10.523,45.717,53.888,43.91,100.736,42.752 c3.399-0.085,4.822-1.373,4.494-4.921c-2.818-30.554-0.83-32.966-7.464-31.892c-34.085,5.524-83.11,14.671-99.998-35.855 c-4.642-13.907-27.915,3.318-34.811,17.477c-8.333,17.108-16.877,34.247-29.673,20.17c-9.464-10.41-9.558-23.214-9.849-35.985 c-0.046-1.914,1.338-3.862,2.061-5.793c0.477,0.026,0.953,0.05,1.428,0.076c0.186,2.094,0.508,4.186,0.537,6.279 c0.396,26.832,16.476,33.83,22.944,23.256c13.003-21.244,15.854-36.926,36.509-45.219c7.471-2.999,15.463-2.733,18.509,7.685 c12.76,43.623,58.257,36.97,95.25,32.122c-2.791-41.346,2.652-33.732-26.191-31.313c-68.117,5.723-58.584-50.261-62.78-61.1 c-8.6,20.335-13.885,42.525-38.541,50.591c-9.413,3.077-14.407,7.316-26.041,11.744c-0.318-0.449-0.635-0.898-0.95-1.345 c22.58-18.356,35.105-23.892,47.505-38.628c6.464-7.684,5.928-4.133,1.719-25.409c-14.89,12.313-18.796,18.388-32.98,30.847 c-16.157,14.195-39.238,3.878-33.459-25.941c2.918-15.078,15.569-33.008,20.474-32.569c-2.218,3.551-12.112,15.422-17.292,39.535 c-2.001,9.319,7.655,16.54,16.151,12.18c16.175-8.305,28.802-22.507,38.079-31.25c2.131-2.006,2.753-3.87,0.548-6.229 c-20.393-21.812-18.981-23.803-29.34-16.227c1.722-11.819,1.548-28.547,12.736-19.637c17.623,14.033,20.858,20.922,27.728,31.861 c14.854-8.26,8.508,1.564,6.133-58.686c-0.191-4.823,2.19-9.744,4.374-14.506c7.613,20.542,6.339,42.172,9.326,63.159 c28.896-7.232,33.339-6.732,29.671-13.034c-7.104-12.196,3.452-26.537,14.729-22.914c9.302,2.992,16.501,8.991,21.917,16.976 c3.202,4.72-0.839,17.2-6.13,19.339c-10.873,4.407-17.203,1.013-18.415,11.794c-3.337-9.943-8.795-5.459-36.861,1.213 c-3.426,0.815-4.085,2.895-3.892,5.918c1.571,24.823,4.648,41.262,21.49,49.709c17.479,8.774,23.445,6.386,51.809,4.702 c7.485-0.445,3.703-2.931-0.57-54.15c-0.471-5.646,1.962-10.769,6.107-16.192c5.962,15.763,13.189,29.992,17.419,45.339 c-0.521,0.359-1.043,0.72-1.562,1.08c-2.149-1.544-4.297-3.088-7.3-5.248c-2.009,9.6-0.965-0.241,0.022,21.672 c0.277,6.204,4.551,4.532,22.655-1.89c9.494-3.367,1.812-8.825-0.611-46.22c-0.399-6.135,2.267-12.469,3.544-18.711 c0.867-0.013,1.737-0.024,2.604-0.035c3.633,11.677,2.8,0.926,8.34,52.911c0.667,6.252,1.594,6.139,10.39,0.635 c11.609-7.289,8.072-7.257,3.92-63.24c-3.232-43.629-1.585-35.502-5.278-63.463c-0.53-4.041,3.469-13.523,7.127-15.804 c5.016,13.875,11.547,27.128,14.337,41.627c-0.569,0.425-1.139,0.848-1.708,1.273c-2.094-1.98-4.184-3.958-7.048-6.667 c0,37.824,6.524,57.403,4.082,89.386c-2.624,34.294-24.556,28.258-23.947,39.954c0.556,10.5,0.67,21.024,0.99,32.789 c37.166-15.431,21.323-11.449,30.063,6.36c2.304,4.694,7.42,6.321,12.751,4.707c11.42-3.458,12.011-3.487,11.818-12.28 c-1.432-65.677-9.777-173.306-9.777-173.306c0.328-4.646,3.022-9.122,4.656-13.675c0.604,0.044,1.209,0.085,1.813,0.129 c2.596,10.338,6.707,50.589,7.797,61.005c6.03,57.567,0.523,110.141,17.009,116.133c-4.085-14.222-12.887-28.759,3.701-47.582 c3.629-4.11,12.112-2.252,9.444-19.125c-1.612-10.182-1.779-20.594-2.624-31.635c-5.349,1.881-9.913,3.489-14.661,5.16 c0.153-4.227,1.559-5.994,5.589-7.486c10.43-3.868,8.191-2.519,7.359-12.353c-0.767-9.081-0.044-18.431-1.971-27.222 c-1.783-8.134,1.984-13.614,4.836-19.876c0.569-0.107,1.134-0.215,1.7-0.322c4.433,12.539,8.866,25.08,13.299,37.621 c-0.591,0.368-1.183,0.734-1.774,1.102c-1.778-1.163-3.552-2.324-7.109-4.647c0.552,6.886,0.986,12.326,1.485,18.56 c6.584-2.225,11.875-4.012,17.653-5.964c-1.033,6.367-5.97,7.234-10.044,8.8c-9.521,3.655-8.047-1.915-2.506,47.444 c6.956,0.896,13.785,1.774,21.276,2.738c0-42.854-8.041-36.489,7.438-68.866c38.231,41.393,75.416,147.633,30.093,219.675 c1.604,0.933,2.847,1.658,4.092,2.383c0.013,0.508,0.018,1.018,0.031,1.526c-14.602,2.233-12.181-0.356-19.037,18.494 c-1.83,5.038-0.577,5.714,0.981,9.747c4.91-5.197,3.127-3.099,6.146-7.616c0.302,1.724,0.776,2.644,0.499,3.154 c-1.321,2.432-8.701,17.302-11.914,15.112c-9.33-6.34,1.545-23.513,8.078-36.311c-31.386,2.793-10.236,6.31-138.237,9.762 c-3.439,0.092-4.42,1.099-4.262,4.253c2.344,46.522,0.27,49.929,9.825,63.75c8.525,12.321,26.521,4.646,40.168-0.214 c3.255-1.159,3.544-2.629,1.393-5.509c-3.907-5.226-9.269-6.121-15.025-5.672c-39.572,3.081-13.5-57.229,9.751-38.274 c16.33,13.31,21.809,35.982,9.361,58.193c-3.564,6.365-26.091,13.551-33.019,14.293c-28.034,3.004-33.203-27.176-31.994-82.801 c0.211-9.406-4.194-5.652-18.021-6.161c-10.802-0.395,1.928,19.366-12.675,45.894c-9.784,17.765-91.58,80.849-111.113,23.098 C1211.455,467.242,1224.163,445.001,1233.349,426.99z M1458.215,364.359c-83.834,36.471-89.329,20.538-88.283,38.742 c0.444,7.713-2.634,3.352,86.644,1.818c55.763-0.963,64.007,1.546,66.433-3.936c6.697-15.121,18.625-36.597,13.334-85.541 c-3.914-36.225-22.189-78.294-41.259-106.934c-0.653,0.293-1.301,0.589-1.954,0.883c5.997,61.323,2.478,43.261,12.292,56.7 c-2.847-0.129-4.394-0.197-6.733-0.302c1.2,11.654,2.361,22.964,3.645,35.44c6.299-4.555,11.306-8.178,16.886-12.215 c-1.06,10.222-1.331,13.715-6.632,17.154c-8.257,5.359-9.032,11.809-8.428,20.897c4.717,71.017-33.51,68.697-41.031,52.175 C1461.036,374.644,1459.91,369.611,1458.215,364.359z M1295.987,424.434c-0.004-0.077-0.009-0.156-0.013-0.232 c-54.887,2.899-57.663,2.224-60.094,6.301c-36.384,61.116,12.768,99.429,88.51,32.054c6.181-5.497,7.727-5.386,4.547-35.33 c-0.169-1.603-3.014-4.189-4.602-4.172C1314.882,423.164,1305.435,423.906,1295.987,424.434z M1384.081,325.474 c-11.182,4.607-17.298,6.048-17.153,10.649c1.483,46.392,1.586,42.621,11.591,40.468c80.479-17.297,85.092-37.525,87.332-22.916 c2.3,15.038,6.974,19.282,19.26,17.491c15.713-2.294,12.882-11.486,8.476-50.254c-28.201,10.244-45.566,22.083-65.794-4.827 c-0.802,3.673-1.209,6.108-1.87,8.474c-7.942,28.46-33.963,28.848-38.657,12.219 C1386.267,333.24,1385.272,329.701,1384.081,325.474z M1326.858,408.929c4.243-22.904-90.718,23.463-113.329-49.019 c-2.583-8.272-5.856-9.2-20.233,9.661c-7.878,10.338-19.444,15.156-30.337,21.112c-2.797,1.529-4.807,4.503-7.18,6.814 c17.5,15.725,20.625,15.337,110.104,13.588C1317.964,410.068,1318.942,409.454,1326.858,408.929z M1460.352,300.214 c-0.517-0.188-1.038-0.377-1.559-0.565c-1.637-31.701-0.95-24.005-3.058-29.699c-3.104,1.234-12.416,3.291-10.434,9.063 c1.981,5.738,7.281,25.671,21.736,32.437c8.524,3.986,16.891-0.624,24.661-4.637c0.719-0.372,1.073-2.203,0.972-3.3 c-3.788-41.762-1.753-40.81-13.378-39.303C1457.855,266.979,1471.853,268.484,1460.352,300.214z M1336.105,384.64 c29.7-4.312,23.716,3.47,21.173-47.317c-19.984,6.547-24.146,7.092-23.904,11.137 C1334.081,360.206,1335.099,371.935,1336.105,384.64z M1354.627,287.323c-25.689,9.059-27.122,8.023-26.606,13.632 c2.36,25.619,1.401,30.899,6.851,29.197c18.014-5.623,21.324-6.586,21.214-10.675 C1355.823,309.146,1355.197,298.824,1354.627,287.323z M1359.174,396.945c-20.388,2.606-21.396,1.392-21.241,8.632 c0.089,4.073,6.403,3.255,21.241,3.255C1359.174,404.036,1359.174,400.732,1359.174,396.945z M1415.532,460.809 c-7.385-9.427-14.74-10.318-19.795-2.99C1401.475,462.863,1408.287,459.663,1415.532,460.809z M1275.449,190.194 c-0.692,0.78-1.384,1.557-2.078,2.337c1.842,2.788,3.119,6.866,5.69,7.999c2.493,1.097,6.317-0.834,9.556-1.437 c0.087-0.778,0.175-1.555,0.263-2.332C1284.403,194.57,1279.926,192.382,1275.449,190.194z M1222.006,248.027 c0.554,0.107,1.111,0.214,1.665,0.322c4.411-17.238,3.6-12.476,2.155-17.333C1221.349,235.739,1222.006,230.918,1222.006,248.027z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1344.3264,
    y1: 515.5187,
    x2: 1344.3264,
    y2: 121.1245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1377.863,124.696c1.182,3.136,2.424,6.25,3.635,9.286c3.418,8.57,6.942,17.406,9.002,26.528l-1.754-1.659 l-3.115-2.947l-3.374-3.192v4.645c0,17.109,1.301,30.243,2.559,42.944c1.47,14.844,2.859,28.864,1.529,46.289 c-1.555,20.319-10.077,25.69-16.3,29.611c-4.084,2.574-7.941,5.004-7.65,10.601c0.395,7.465,0.567,14.965,0.748,22.905 c0.073,3.195,0.148,6.463,0.239,9.833l0.079,2.908l2.687-1.116c4.212-1.749,7.813-3.278,10.706-4.506 c7.042-2.99,11.366-4.826,12.987-4.921c0.125,0.462,0.223,1.377,0.305,2.138c0.305,2.83,0.766,7.107,3.502,12.684 c2.006,4.087,5.877,6.431,10.619,6.431c1.476,0,2.992-0.233,4.508-0.692l0.564-0.171c11.436-3.461,12.889-4.279,12.675-14.068 c-1.392-63.843-9.411-168.592-9.771-173.263c0.233-2.821,1.464-5.662,2.766-8.667c0.153-0.354,0.307-0.71,0.461-1.069 c2.412,12.948,5.7,44.503,6.852,55.555l0.193,1.849c1.931,18.437,2.681,36.505,3.343,52.446 c1.466,35.317,2.525,60.834,14.972,65.359l3.689,1.341l-1.084-3.773c-0.611-2.128-1.334-4.287-2.033-6.375 c-4.155-12.412-8.08-24.135,5.312-39.331c0.692-0.783,1.728-1.33,2.927-1.963c5.032-2.656,9.032-5.903,6.993-18.798 c-1.104-6.974-1.519-14.021-1.957-21.483c-0.191-3.245-0.388-6.6-0.648-9.992l-0.199-2.599l-2.459,0.865l-9.27,3.262l-2.113,0.744 c0.591-1.145,1.69-1.837,3.67-2.57l1.445-0.533c7.381-2.718,8.581-3.347,7.706-9.629c-0.155-1.117-0.349-2.506-0.495-4.234 c-0.271-3.206-0.354-6.53-0.435-9.744c-0.148-5.861-0.3-11.921-1.575-17.738c-1.349-6.158,0.793-10.545,3.274-15.624 c0.125-0.257,0.252-0.515,0.379-0.776l10.294,29.122l1.117,3.159l-4.972-3.25l-3.413-2.23l0.326,4.064l0.87,10.873l0.615,7.686 l0.205,2.556l2.429-0.821l13.484-4.556c-1.244,1.423-3.131,2.165-5.594,3.035c-0.554,0.196-1.104,0.39-1.639,0.596 c-0.816,0.313-1.566,0.561-2.227,0.78c-7.113,2.354-6.942,3.763-4.076,27.315c0.688,5.651,1.543,12.684,2.526,21.439l0.175,1.56 l1.557,0.201l19.93,2.565l1.346,0.173l2.255,0.29v-2.274c0-13.724-0.829-22.536-1.434-28.971 c-1.237-13.16-1.61-17.113,7.393-36.325c19.627,22.394,36.33,58.514,43.899,95.177c4.455,21.581,5.626,42.377,3.479,61.811 c-2.002,18.133-6.886,34.709-14.548,49.417c6.611-14.855,14.965-37.217,10.377-79.653c-4.32-39.98-25.1-83.073-41.582-107.828 l-0.939-1.41l-1.546,0.695l-1.042,0.47l-0.914,0.413l-1.309,0.589l0.14,1.429c1.073,10.972,1.829,19.264,2.436,25.926 c2.062,22.622,2.101,23.054,5.84,26.704c0.486,0.475,1.025,1.001,1.647,1.676l-2.283-0.102l-2.317-0.104l0.238,2.307l2.163,21.029 l1.482,14.41l0.354,3.446l2.807-2.03l11.427-8.266l1.816-1.314c-0.812,6.876-1.608,8.858-5.25,11.22 c-9.601,6.231-9.894,14.297-9.335,22.707c2.154,32.43-4.733,47.08-10.891,53.66c-4.629,4.947-9.458,5.985-12.694,5.985 c-5.857,0-11.335-3.388-13.631-8.432c-1.374-3.015-2.325-6.269-3.333-9.715c-0.47-1.606-0.955-3.268-1.499-4.951l-0.678-2.1 l-2.023,0.88c-40.358,17.557-62.525,22.931-74.434,25.817c-12.982,3.147-15.684,3.802-15.047,14.874 c0.013,0.232,0.023,0.453,0.033,0.662c0.207,4.55,1.886,5.661,8.554,5.661c3.101,0,7.563-0.208,14.318-0.522 c12.319-0.574,32.936-1.534,65.771-2.098c10.008-0.173,19.463-0.253,29.756-0.253c3.598,0,6.837,0.009,9.753,0.018 c2.392,0.007,4.567,0.013,6.547,0.013c10.838,0,16.441-0.113,19.515-1.877l-0.282,0.448l1.79,1.041l1.228,0.715 c-0.229,0.031-0.453,0.061-0.672,0.09c-3.353,0.447-5.619,0.854-7.311,1.649l-3.542,0.315c-8.708,0.775-13.379,1.599-18.325,2.472 c-12.703,2.242-27.101,4.783-119.788,7.282c-1.722,0.046-3.657,0.281-4.949,1.677c-1.254,1.354-1.33,3.21-1.257,4.677 c0.46,9.131,0.754,16.719,0.991,22.816c0.999,25.748,1.179,30.387,9.187,41.971c3.448,4.983,8.658,7.509,15.486,7.509 c7.731,0,16.429-3.153,24.102-5.934c0.983-0.356,1.95-0.707,2.895-1.043c1.413-0.503,3.359-1.395,3.942-3.32 c0.592-1.958-0.553-3.844-1.618-5.27c-3.309-4.425-7.943-6.576-14.169-6.576c-0.832,0-1.686,0.035-2.613,0.107 c-0.924,0.072-1.829,0.108-2.692,0.108c-5.394,0-9.473-1.384-12.125-4.114c-2.865-2.951-3.467-6.916-3.467-9.723 c0-10.687,8.804-24.245,18.699-24.245c2.818,0,5.585,1.092,8.226,3.245c16.712,13.621,20.198,35.471,8.879,55.666 c-3.032,5.414-24.52,12.535-31.487,13.282c-1.197,0.128-2.366,0.193-3.474,0.193c-5.961,0-10.657-1.838-14.357-5.619 c-11.683-11.939-12.648-43.267-11.951-75.341c0.077-3.446-0.45-5.49-1.762-6.832c-1.463-1.496-3.587-1.698-5.471-1.698 c-1.061,0-2.251,0.068-3.629,0.148c-1.844,0.106-3.934,0.226-6.408,0.226c-0.897,0-1.797-0.016-2.677-0.049 c-0.131-0.005-0.26-0.007-0.385-0.007c-1.879,0-3.378,0.549-4.456,1.633c-2.203,2.215-2.181,6.06-2.152,11.382 c0.044,7.996,0.111,20.08-7.507,33.92c-3.059,5.555-14.699,17.053-30.244,27.422c-10.346,6.901-30.36,18.478-48.158,18.478 c-14.241,0-24.02-7.563-29.064-22.478c-5.135-15.18-1.744-29.756,3.677-42.829c-5.063,14.633-4.967,27.749,0.565,37.479 c5.296,9.316,15.195,14.447,27.872,14.447c20.261,0,45.827-12.816,71.988-36.087c0.262-0.233,0.516-0.457,0.762-0.672 c6.393-5.618,7.5-7.585,4.445-36.362c-0.276-2.619-3.962-5.963-6.614-5.963c-7.111,0.082-14.312,0.526-21.275,0.955 c-1.722,0.106-3.444,0.212-5.166,0.313l-0.013-0.223l-1.989,0.105c-9.353,0.494-17.35,0.892-23.776,1.212 c-30.717,1.529-34.795,1.732-37.185,4.92c0.075-0.146,0.149-0.292,0.224-0.438l1.484-2.909h-3.265 c-3.849,0-8.052,0.065-12.501,0.135c-4.972,0.077-10.113,0.158-15.37,0.158c-21.549,0-47.274-1.323-54.996-11.635 c-2.482-3.314-2.962-7.402-1.467-12.497c4.204-14.337,13.494-24.1,29.237-30.725c10.625-4.474,17.5-13.079,23.108-20.792 c4.27-5.866,9.664-10.123,12.825-10.123c0.624,0,2.524,0,3.547,4.445c9.497,41.259,45.945,44.714,79.363,44.714 c6.911,0,13.848-0.173,21.193-0.357l2.18-0.054c1.52-0.038,3.708-0.277,5.153-1.901c1.075-1.209,1.495-2.911,1.283-5.203 c-0.683-7.405-1.076-13.06-1.392-17.603c-0.871-12.521-1.134-16.3-6.158-16.3c-0.603,0-1.269,0.066-2.225,0.221l-2.206,0.359 c-11.623,1.892-24.797,4.037-37.682,4.037c-30.624,0-49.019-12.364-57.892-38.91c-1.399-4.192-4.491-6.501-8.707-6.502 c-10.103,0-24.562,12.985-29.799,23.737c-5.535,11.364-11.809,24.245-18.715,24.245c-2.355,0-4.938-1.529-7.679-4.544 c-8.767-9.643-9.032-21.424-9.312-33.897l-0.018-0.79c-0.001-0.048,0-0.097,0.002-0.147c0.013,0.263,0.021,0.525,0.025,0.787 c0.29,19.655,8.948,29.939,17.352,29.939c3.706,0,7.095-2.066,9.298-5.668c3.28-5.358,5.967-10.456,8.339-14.953 c7.195-13.646,12.393-23.505,27.209-29.453c2.5-1.003,4.79-1.512,6.808-1.512c4.526,0,7.482,2.585,9.037,7.902 c9.723,33.24,37.708,37.085,57.912,37.085c12.553,0,25.427-1.691,37.877-3.326l1.64-0.215l1.862-0.244l-0.126-1.874 c-0.416-6.162-0.651-11.286-0.84-15.403c-0.683-14.901-0.913-19.92-8.53-19.921c-1.897,0-4.282,0.339-7.3,0.769 c-3.08,0.438-6.914,0.984-11.684,1.384c-3.179,0.267-6.27,0.403-9.189,0.403c-19.91,0-33.429-5.989-41.33-18.308 c-6.632-10.342-7.803-22.844-8.658-31.973c-0.407-4.342-0.728-7.771-1.571-9.95l-1.783-4.607l-1.924,4.55 c-1.209,2.86-2.367,5.79-3.487,8.623c-6.949,17.586-13.512,34.198-33.834,40.846c-5.005,1.636-8.814,3.598-12.846,5.675 c-1.702,0.877-3.429,1.767-5.312,2.671c5.445-4.203,10.256-7.668,14.649-10.833c10.205-7.35,18.266-13.156,26.174-22.554 c0.645-0.767,1.219-1.42,1.726-1.996c4.53-5.152,4.333-6.1,1.929-17.698c-0.437-2.109-0.932-4.499-1.504-7.39l-0.651-3.291 l-2.585,2.138c-8.25,6.821-13.109,11.697-18.254,16.858c-4.142,4.156-8.425,8.453-14.772,14.028 c-4.253,3.737-9.245,5.795-14.056,5.795c-4.811,0-9.139-2.035-12.188-5.731c-2.538-3.078-4.089-7.149-4.604-11.932 c0.445,1.785,1.28,3.463,2.485,4.954c2.492,3.084,6.335,4.925,10.281,4.925c2.136,0,4.218-0.513,6.188-1.524 c13.429-6.895,24.293-17.606,33.023-26.212c1.953-1.926,3.798-3.745,5.513-5.36c4.001-3.765,2.555-7,0.638-9.051 c-3.197-3.42-5.81-6.299-8.115-8.839c-7.72-8.508-10.915-12.029-14.965-12.03c-1.721,0-3.312,0.651-5.172,1.804 c0.038-0.331,0.076-0.661,0.114-0.989c0.727-6.313,1.723-14.959,4.685-14.959c0.698,0,1.984,0.361,4.141,2.079 c15.552,12.384,19.626,18.982,25.264,28.113c0.647,1.048,1.313,2.126,2.016,3.247l1.009,1.606l1.657-0.922 c1.407-0.783,2.615-1.396,3.68-1.938c7.641-3.885,7.527-5.075,6.131-19.649c-0.756-7.899-1.899-19.837-2.652-38.927 c-0.113-2.862,0.847-5.898,2.111-8.936c3.689,12.18,4.651,24.894,5.585,37.238c0.515,6.801,1.047,13.834,2.026,20.711l0.313,2.197 l2.153-0.539c5.149-1.289,9.432-2.31,13.211-3.212c13.051-3.113,17.447-4.162,18.75-7.203c0.817-1.906-0.021-3.801-1.048-5.566 c-2.653-4.554-2.709-9.93-0.151-14.38c2.162-3.761,5.828-6.098,9.568-6.098c0.991,0,1.991,0.16,2.971,0.474 c8.394,2.7,15.417,8.149,20.875,16.195c1.066,1.571,1.05,5.032-0.039,8.613c-1.154,3.794-3.286,6.981-5.188,7.75 c-3.203,1.298-5.986,1.883-8.441,2.399c-4.315,0.907-7.943,1.67-9.888,5.826c-1.34-1.434-3.251-2.378-6.156-2.378 c-3.424,0-8.112,1.255-15.207,3.155c-4.099,1.098-9.201,2.464-15.295,3.913c-5.24,1.247-5.606,5.158-5.425,7.99 c1.483,23.43,4.087,42.091,22.589,51.37c9.734,4.886,16.132,6.536,25.354,6.536c4.298,0,9.142-0.352,15.274-0.799 c3.558-0.259,7.59-0.552,12.197-0.826c1.77-0.105,3.601-0.331,4.838-1.805c1.958-2.333,1.512-6.214,0.032-19.074 c-0.934-8.118-2.214-19.235-3.565-35.434c-0.312-3.749,0.808-7.488,3.593-11.823c1.737,4.41,3.553,8.719,5.32,12.914 c3.726,8.843,7.265,17.243,9.899,26.006l-4.974-3.576l-2.496-1.795l-0.63,3.009c-0.342,1.633-0.59,2.681-0.772,3.447 c-0.488,2.054-0.503,2.3-0.265,4.38c0.2,1.755,0.616,5.407,1.019,14.343c0.172,3.844,1.977,5.794,5.365,5.794 c3.367,0,8.803-1.93,18.672-5.432l1.284-0.455c7.321-2.596,6.489-7.145,4.666-17.112c-1.192-6.513-2.992-16.356-3.949-31.122 c-0.253-3.889,0.848-7.925,2.013-12.199c0.323-1.183,0.652-2.39,0.952-3.604c0.365,1.068,0.678,1.906,0.95,2.633 c1.827,4.889,2.108,5.641,6.588,47.677c0.277,2.595,0.695,6.516,4.231,6.516c1.965,0,4.431-1.408,9.212-4.4 c10.052-6.312,9.851-8.497,7.38-35.242c-0.713-7.721-1.601-17.331-2.528-29.839c-1.173-15.832-1.696-24.735-2.078-31.236 c-0.653-11.111-0.85-14.465-3.211-32.34C1373.19,134.067,1375.402,128.003,1377.863,124.696 M1280.826,202.861 c1.719,0,3.531-0.534,5.284-1.051c1.021-0.301,1.986-0.586,2.873-0.75l1.456-0.271l0.166-1.472l0.14-1.238l0.123-1.095 l0.158-1.401l-1.266-0.62c-4.477-2.19-8.954-4.379-13.431-6.567l-1.366-0.667l-1.009,1.137c-0.691,0.779-1.382,1.555-2.076,2.334 l-1.023,1.149l0.848,1.284c0.505,0.764,0.976,1.661,1.474,2.611c1.303,2.481,2.649,5.046,5.078,6.116 C1279.009,202.693,1279.875,202.861,1280.826,202.861 M1225.141,250.67l0.467-1.826c0.6-2.344,1.103-4.28,1.521-5.889 c2.148-8.268,2.232-8.59,1.265-10.771c-0.19-0.429-0.405-0.914-0.651-1.739l-0.987-3.318l-2.381,2.512 c-0.808,0.853-1.431,1.36-1.931,1.768c-2.513,2.048-2.509,2.718-2.458,10.919c0.01,1.565,0.021,3.441,0.021,5.7v1.65l1.62,0.313 l0.833,0.161l0.831,0.161L1225.141,250.67 M1460.48,293.473c-0.097-1.918-0.184-3.649-0.262-5.211 c-0.75-14.99-0.75-14.99-1.785-17.098c-0.223-0.454-0.475-0.968-0.823-1.907l-0.711-1.921l-1.903,0.757 c-0.401,0.159-0.951,0.345-1.587,0.56c-3.209,1.085-8.059,2.724-9.771,6.204c-0.724,1.472-0.803,3.134-0.228,4.81 c0.171,0.496,0.368,1.101,0.594,1.795c2.459,7.56,8.218,25.263,22.186,31.801c2.438,1.14,5.041,1.718,7.738,1.718 c6.342,0,12.235-3.05,17.934-5.999l0.757-0.391c1.969-1.02,2.14-4.219,2.044-5.257c-0.54-5.949-0.955-10.953-1.321-15.369 c-0.861-10.38-1.38-16.645-2.347-20.331c-1.091-4.161-3.101-5.937-6.719-5.937c-1.231,0-2.652,0.188-4.297,0.407l-0.942,0.124 c-13.441,1.736-14.622,3.452-15.222,12.313C1463.535,278.682,1463.137,284.573,1460.48,293.473 M1333.29,332.443 c0.644,0,1.356-0.125,2.178-0.381l0.885-0.276c18.111-5.652,21.88-6.828,21.733-12.358c-0.199-7.831-0.607-15.667-1.039-23.962 c-0.14-2.688-0.282-5.429-0.422-8.24l-0.133-2.679l-2.53,0.892c-5.331,1.88-9.616,3.324-13.058,4.485 c-13.373,4.508-15.428,5.201-14.875,11.217c0.465,5.047,0.807,9.389,1.083,12.877c0.501,6.352,0.832,10.548,1.424,13.261 C1328.844,328.69,1329.663,332.443,1333.29,332.443 M1401.963,345.911c-6.194,0-11.089-3.708-12.773-9.677 c-0.597-2.114-1.192-4.229-1.829-6.491l-1.355-4.812l-0.609-2.162l-2.077,0.856c-1.91,0.787-3.705,1.494-5.289,2.118 c-8.273,3.259-13.266,5.227-13.102,10.444c0.569,17.791,0.93,28.153,1.736,34.254c0.592,4.482,1.613,9.265,6.249,9.265 c1.211,0,2.51-0.318,4.013-0.687c0.621-0.152,1.29-0.316,2.012-0.472c43.297-9.306,64.392-19.287,75.726-24.649 c3.98-1.883,6.856-3.244,8.119-3.244c0.103,0,0.155,0.011,0.164,0.011c0.001,0,0.001,0,0.001,0c0.116,0.095,0.51,0.61,0.924,3.313 c1.797,11.748,5.289,19.573,16.492,19.573c1.517,0,3.164-0.133,5.035-0.405c16.095-2.349,15.009-11.513,11.411-41.874 c-0.386-3.257-0.803-6.778-1.236-10.585l-0.286-2.52l-2.384,0.866c-3.613,1.312-7.021,2.64-10.317,3.924 c-10.464,4.076-19.501,7.595-27.669,7.595c-9.508,0-17.38-4.832-25.525-15.668l-2.622-3.489l-0.93,4.264 c-0.277,1.27-0.507,2.392-0.717,3.416c-0.396,1.933-0.71,3.46-1.125,4.947C1419.487,340.178,1409.309,345.911,1401.963,345.911  M1334.279,386.926l2.113-0.307c3.598-0.522,6.627-0.861,9.299-1.16c7.937-0.888,12.309-1.377,14.471-5.281 c1.952-3.526,1.525-8.959,0.59-20.864c-0.454-5.781-1.02-12.976-1.476-22.092l-0.131-2.616l-2.489,0.815 c-3.2,1.049-5.994,1.943-8.429,2.722c-13.513,4.326-17.145,5.488-16.849,10.436c0.547,9.086,1.276,18.111,2.048,27.665 c0.227,2.808,0.457,5.654,0.686,8.552L1334.279,386.926 M1211.187,413.914c12.451,0,28.799-0.321,49.497-0.727l5.238-0.103 c44.346-0.866,51.812-1.449,57.81-1.919c1.061-0.083,2.082-0.163,3.258-0.241l1.551-0.103l0.283-1.529 c0.445-2.404,0.02-4.406-1.265-5.951c-2.066-2.483-6.103-3.543-13.501-3.543c-3.735,0-8.157,0.255-12.838,0.525 c-5.689,0.328-12.137,0.7-18.759,0.7c-16.487,0-28.939-2.344-39.185-7.377c-13.611-6.686-22.717-17.916-27.839-34.334 c-0.711-2.278-2.192-7.018-6.246-7.018c-3.822,0-8.562,4.354-17.488,16.063c-6.296,8.262-14.989,12.817-24.192,17.639 c-1.81,0.948-3.682,1.929-5.513,2.93c-2.217,1.212-3.906,3.096-5.54,4.919c-0.708,0.79-1.377,1.536-2.076,2.216l-1.531,1.492 l1.59,1.429C1167.613,410.818,1172.648,413.914,1211.187,413.914 M1348.463,410.898c1.321,0,2.775-0.014,4.367-0.029 c1.911-0.018,4.023-0.038,6.344-0.038h2v-2v-11.886v-2.272l-2.254,0.288c-3.148,0.402-5.793,0.709-8.127,0.979 c-12.441,1.441-15.03,1.741-14.859,9.68C1336.049,410.898,1342.36,410.898,1348.463,410.898 M1404.812,462.777 c1.146,0,2.316-0.06,3.447-0.119c1.135-0.059,2.308-0.119,3.462-0.119c1.311,0,2.456,0.08,3.499,0.245l5.023,0.794l-3.136-4.003 c-4.423-5.645-9.096-8.629-13.514-8.629c-2.529,0-6.231,0.995-9.502,5.737l-1.01,1.464l1.336,1.174 C1397.881,462.366,1401.615,462.777,1404.812,462.777 M1158.646,223.919c-3.139,6.346-6.438,14.807-8.785,25.733 c-0.028,0.13-0.054,0.259-0.078,0.388c0.104-2.096,0.375-4.286,0.815-6.555C1151.75,237.533,1154.72,230.338,1158.646,223.919  M1507.628,427.085c-1.334,4.042-0.74,5.733,0.467,8.462c0.245,0.553,0.522,1.18,0.802,1.904l1.143,2.957l1.411-1.494 c-0.285,0.471-0.576,0.941-0.871,1.402c-2.462,3.854-3.787,4.913-4.263,5.195C1502.028,442.215,1504.083,434.845,1507.628,427.085  M1378.675,121.124c-3.657,2.282-7.657,11.763-7.127,15.804c3.693,27.961,2.046,19.834,5.278,63.463 c4.151,55.983,7.688,55.951-3.92,63.24c-4.301,2.691-6.72,4.093-8.148,4.093c-1.493,0-1.901-1.533-2.242-4.728 c-5.54-51.984-4.708-41.234-8.34-52.911c-0.867,0.011-1.737,0.022-2.604,0.035c-1.277,6.242-3.943,12.576-3.544,18.711 c2.423,37.395,10.105,42.853,0.611,46.22c-10.307,3.656-16.132,5.773-19.288,5.773c-2.387,0-3.248-1.211-3.367-3.883 c-0.987-21.912-2.031-12.071-0.022-21.672c3.003,2.159,5.151,3.704,7.3,5.248c0.519-0.359,1.041-0.72,1.562-1.08 c-4.229-15.347-11.457-29.576-17.419-45.339c-4.144,5.423-6.577,10.546-6.107,16.192c4.273,51.219,8.055,53.705,0.57,54.15 c-12.501,0.742-20.649,1.621-27.352,1.621c-8.505,0-14.682-1.416-24.457-6.323c-16.842-8.447-19.919-24.887-21.49-49.709 c-0.193-3.022,0.466-5.103,3.892-5.918c16.304-3.876,24.978-7.014,30.04-7.013c3.651,0,5.423,1.633,6.821,5.8 c1.212-10.782,7.542-7.387,18.415-11.794c5.292-2.14,9.333-14.62,6.13-19.339c-5.416-7.986-12.615-13.985-21.917-16.976 c-1.21-0.389-2.411-0.571-3.584-0.571c-9.755,0-17.487,12.597-11.146,23.484c3.668,6.302-0.775,5.802-29.671,13.034 c-2.987-20.986-1.713-42.617-9.326-63.159c-2.184,4.761-4.565,9.683-4.374,14.506c2.375,60.25,8.721,50.426-6.133,58.686 c-6.87-10.939-10.105-17.828-27.728-31.861c-2.203-1.754-3.964-2.514-5.387-2.514c-5.805,0-5.966,12.66-7.349,22.151 c3.477-2.543,5.627-4.008,7.721-4.007c4.146,0.001,8.071,5.743,21.619,20.235c2.205,2.359,1.583,4.223-0.548,6.229 c-9.277,8.743-21.904,22.945-38.079,31.25c-1.746,0.896-3.542,1.303-5.275,1.303c-6.698,0-12.466-6.08-10.876-13.483 c5.179-24.114,15.074-35.985,17.292-39.535c-0.059-0.005-0.119-0.008-0.181-0.008c-5.028,0-17.411,17.68-20.293,32.576 c-4.053,20.914,6.089,32.234,18.083,32.234c5.107,0,10.551-2.053,15.376-6.293c14.185-12.459,18.09-18.534,32.98-30.847 c4.209,21.275,4.745,17.724-1.719,25.409c-12.401,14.736-24.925,20.272-47.505,38.628c0.315,0.447,0.633,0.896,0.95,1.345 c11.634-4.428,16.628-8.667,26.041-11.744c24.656-8.067,29.941-30.256,38.541-50.591c3.993,10.315-4.447,61.51,53.424,61.51 c2.943,0,6.059-0.133,9.356-0.409c9.462-0.793,15.233-2.146,18.816-2.146c7.339,0.001,5.499,5.677,7.374,33.459 c-12.642,1.657-26.275,3.524-39.257,3.524c-25.007,0-47.593-6.931-55.993-35.646c-2.016-6.892-6.195-9.341-10.956-9.341 c-2.436,0-5.025,0.641-7.553,1.656c-20.655,8.293-23.505,23.974-36.509,45.219c-1.91,3.122-4.658,4.713-7.593,4.713 c-7.004,0-15.073-9.059-15.352-27.968c-0.029-2.093-0.351-4.185-0.537-6.279c-0.475-0.026-0.951-0.05-1.428-0.076 c-0.723,1.931-2.107,3.879-2.061,5.793c0.291,12.771,0.385,25.575,9.849,35.985c3.315,3.647,6.344,5.199,9.159,5.199 c8.049,0,14.339-12.693,20.513-25.369c5.099-10.469,19.149-22.614,28.003-22.612c3.121,0.001,5.598,1.511,6.808,5.135 c10.84,32.433,34.916,40.277,59.789,40.277c13.875,0,28.003-2.443,40.209-4.421c0.735-0.119,1.364-0.195,1.905-0.195 c4.347,0,3.054,4.917,5.559,32.087c0.328,3.548-1.095,4.836-4.494,4.921c-7.923,0.196-15.741,0.41-23.323,0.41 c-37.248,0-68.67-5.178-77.414-43.163c-0.995-4.325-3.025-5.997-5.496-5.997c-4.562,0-10.626,5.705-14.442,10.946 c-6.054,8.325-12.447,15.99-22.268,20.126c-14.76,6.212-25.654,15.888-30.38,32.006c-6.985,23.818,26.957,26.695,58.383,26.695 c10.014,0,19.775-0.292,27.871-0.292c-9.186,18.011-21.894,40.252-13.627,64.692c5.888,17.409,17.433,23.837,30.959,23.837 c31.344,0,73.32-34.525,80.154-46.935c14.46-26.267,2.12-45.9,12.363-45.899c0.102,0,0.206,0.002,0.312,0.006 c0.962,0.035,1.877,0.05,2.75,0.05c4.391,0,7.669-0.374,10.037-0.374c3.924,0,5.356,1.028,5.234,6.485 c-1.154,53.095,3.5,83.005,28.307,83.005c1.182,0,2.412-0.068,3.687-0.205c6.928-0.742,29.455-7.928,33.019-14.293 c12.448-22.211,6.969-44.884-9.361-58.193c-3.169-2.583-6.389-3.694-9.49-3.694c-19.08,0-33.585,42.082-3.108,42.082 c0.907,0,1.859-0.038,2.847-0.115c0.829-0.065,1.649-0.101,2.458-0.101c4.811,0,9.222,1.301,12.567,5.774 c2.151,2.88,1.861,4.35-1.393,5.509c-8.205,2.922-17.981,6.862-26.327,6.862c-5.536,0-10.442-1.734-13.842-6.647 c-9.555-13.821-7.481-17.228-9.825-63.75c-0.157-3.154,0.823-4.161,4.262-4.253c128.001-3.451,106.85-6.969,138.237-9.762 c-6.532,12.798-17.407,29.972-8.078,36.311c0.219,0.149,0.458,0.219,0.712,0.219c3.479,0,9.971-13.065,11.202-15.332 c0.276-0.51-0.197-1.43-0.499-3.154c-3.018,4.516-1.236,2.418-6.146,7.616c-1.558-4.033-2.812-4.709-0.981-9.747 c6.857-18.849,4.435-16.261,19.037-18.494c-0.013-0.508-0.018-1.019-0.031-1.526c-1.244-0.725-2.488-1.45-4.092-2.383 c45.323-72.042,8.138-178.282-30.093-219.675c-15.479,32.377-7.438,26.012-7.438,68.866c-7.491-0.964-14.32-1.842-21.276-2.738 c-5.542-49.359-7.016-43.79,2.506-47.444c4.074-1.566,9.01-2.433,10.044-8.8c-5.777,1.952-11.069,3.739-17.653,5.964 c-0.499-6.234-0.933-11.674-1.485-18.56c3.557,2.324,5.331,3.485,7.11,4.647c0.591-0.368,1.183-0.733,1.774-1.102 c-4.433-12.541-8.866-25.082-13.299-37.621c-0.565,0.107-1.13,0.215-1.7,0.322c-2.852,6.262-6.619,11.742-4.836,19.876 c1.927,8.792,1.205,18.142,1.971,27.222c0.832,9.834,3.071,8.485-7.359,12.353c-4.03,1.491-5.436,3.259-5.589,7.486 c4.748-1.671,9.312-3.278,14.661-5.16c0.845,11.041,1.012,21.453,2.624,31.635c2.668,16.873-5.816,15.015-9.444,19.125 c-16.589,18.823-7.786,33.36-3.702,47.582c-16.486-5.993-10.979-58.566-17.009-116.133c-1.09-10.417-5.201-50.667-7.797-61.005 c-0.604-0.044-1.209-0.086-1.813-0.129c-1.634,4.553-4.328,9.03-4.656,13.675c0,0,8.345,107.629,9.777,173.306 c0.193,8.794-0.399,8.822-11.818,12.28c-1.337,0.405-2.659,0.606-3.928,0.606c-3.791,0-7.097-1.796-8.823-5.312 c-5.041-10.273-1.902-15.944-5.477-15.944c-2.623,0-8.859,3.054-24.586,9.584c-0.32-11.766-0.434-22.289-0.99-32.789 c-0.609-11.696,21.323-5.66,23.947-39.954c2.442-31.983-4.082-51.562-4.082-89.386c2.864,2.709,4.954,4.687,7.048,6.667 c0.569-0.425,1.139-0.847,1.708-1.273C1390.222,148.252,1383.691,134.999,1378.675,121.124L1378.675,121.124z M1280.826,200.861 c-0.637,0-1.232-0.096-1.765-0.331c-2.571-1.133-3.848-5.21-5.69-7.999c0.694-0.78,1.386-1.557,2.078-2.337 c4.477,2.188,8.954,4.376,13.431,6.566c-0.088,0.777-0.175,1.555-0.263,2.332C1286.071,199.567,1283.164,200.861,1280.826,200.861 L1280.826,200.861z M1505.422,266.091c-9.814-13.439-6.295,4.623-12.292-56.7c0.653-0.294,1.301-0.589,1.954-0.883 c19.07,28.64,37.345,70.709,41.259,106.934c5.291,48.944-6.636,70.419-13.334,85.541c-1.478,3.339-5.115,3.713-20.343,3.713 c-4.394,0-9.751-0.031-16.3-0.031c-8.01,0-17.803,0.047-29.79,0.254c-50.219,0.863-71.215,2.62-80.054,2.62 c-6.875,0-6.396-1.063-6.59-4.438c-1.046-18.205,4.448-2.272,88.283-38.742c1.695,5.252,2.821,10.285,4.915,14.88 c2.561,5.625,8.678,9.603,15.451,9.603c13.12,0,28.692-14.939,25.58-61.778c-0.604-9.087,0.171-15.537,8.428-20.897 c5.3-3.439,5.572-6.932,6.632-17.154c-5.58,4.037-10.587,7.659-16.886,12.215c-1.283-12.476-2.444-23.785-3.645-35.44 C1501.029,265.894,1502.575,265.962,1505.422,266.091L1505.422,266.091z M1223.671,248.348c-0.554-0.107-1.111-0.214-1.665-0.322 c0-17.109-0.658-12.288,3.82-17.011C1227.271,235.872,1228.082,231.11,1223.671,248.348L1223.671,248.348z M1460.352,300.214 c11.501-31.73-2.497-33.236,18.941-36.004c2.05-0.266,3.675-0.514,4.982-0.514c6.104,0,5.276,5.421,8.395,39.817 c0.101,1.097-0.254,2.928-0.972,3.3c-5.664,2.924-11.643,6.166-17.771,6.166c-2.279,0-4.58-0.449-6.891-1.53 c-14.455-6.766-19.755-26.699-21.736-32.437c-1.982-5.772,7.33-7.829,10.434-9.063c2.108,5.693,1.421-2.003,3.058,29.699 C1459.314,299.838,1459.836,300.026,1460.352,300.214L1460.352,300.214z M1333.29,330.443c-3.696,0-3.17-6.694-5.269-29.488 c-0.516-5.609,0.917-4.573,26.606-13.632c0.57,11.501,1.196,21.823,1.459,32.154c0.109,4.089-3.2,5.052-21.214,10.675 C1334.27,330.34,1333.748,330.443,1333.29,330.443L1333.29,330.443z M1401.963,347.911c8.989,0,19.423-7.099,23.959-23.352 c0.662-2.366,1.069-4.801,1.87-8.474c9.204,12.245,17.815,16.467,27.124,16.467c11.15,0,23.3-6.057,38.67-11.639 c4.405,38.768,7.237,47.96-8.476,50.254c-1.728,0.252-3.304,0.384-4.746,0.384c-8.808,0-12.538-4.952-14.515-17.875 c-0.54-3.525-1.218-5.021-3.067-5.021c-5.814,0-23.204,14.813-84.265,27.937c-2.377,0.511-4.194,1.114-5.604,1.114 c-4.527,0-4.855-6.211-5.986-41.582c-0.145-4.6,5.971-6.042,17.154-10.649c1.191,4.227,2.186,7.766,3.185,11.304 C1389.278,343.91,1395.213,347.911,1401.963,347.911L1401.963,347.911z M1336.104,384.64c-1.005-12.705-2.024-24.434-2.731-36.18 c-0.242-4.045,3.92-4.59,23.904-11.137C1359.821,388.11,1365.805,380.328,1336.104,384.64L1336.104,384.64z M1211.187,411.914 c-37.435,0-42.531-2.847-55.408-14.417c2.372-2.31,4.383-5.285,7.18-6.813c10.892-5.955,22.458-10.774,30.336-21.112 c8.391-11.009,13-15.276,15.897-15.276c2.066,0,3.261,2.171,4.337,5.615c11.626,37.267,42.373,43.115,68.933,43.115 c12.155,0,23.433-1.225,31.597-1.225c8.694,0,13.862,1.391,12.799,7.129c-7.916,0.524-8.894,1.139-60.975,2.155 C1242.24,411.547,1224.63,411.914,1211.187,411.914L1211.187,411.914z M1348.463,408.898c-7.234,0-10.466-0.416-10.53-3.322 c-0.155-7.24,0.852-6.025,21.241-8.631c0,3.787,0,7.092,0,11.886C1354.921,408.831,1351.369,408.898,1348.463,408.898 L1348.463,408.898z M1295.987,424.434c9.448-0.528,18.895-1.27,28.348-1.38c0.005,0,0.011,0,0.016,0 c1.591,0,4.418,2.574,4.586,4.172c3.18,29.945,1.634,29.833-4.547,35.33c-28.288,25.163-52.86,35.581-70.659,35.581 c-29.859,0-40.646-29.344-17.851-67.635c2.431-4.077,5.208-3.402,60.094-6.301 C1295.978,424.278,1295.982,424.357,1295.987,424.434L1295.987,424.434z M1404.811,460.777c-3.23,0-6.28-0.501-9.074-2.958 c2.235-3.24,4.918-4.873,7.856-4.873c3.707,0,7.819,2.603,11.939,7.862c-1.285-0.203-2.557-0.27-3.811-0.27 C1409.348,460.539,1407.037,460.777,1404.811,460.777L1404.811,460.777z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.9404,
    y1: 584.6121,
    x2: 144.2274,
    y2: 584.6121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M142.423,465.958c-0.283,2.677-0.053,5.537-0.935,8.001c-33.362,93.183-49.806,108.905-51.66,140.416 c-2.751,46.759,36.676,51.662,44.623,30.172c1.702-4.608,4.998-8.625,7.578-12.905c0.733,0.241,1.465,0.486,2.199,0.727 c-4.456,26.249-11.119,60.088-34.474,70.117c-14.54,6.232-44.556-12.244-41.612-58.869c3.677-58.361,26.619-84.414,70.601-176.311 c0.344-0.719,1.249-1.168,1.895-1.741C141.231,465.697,141.827,465.826,142.423,465.958z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.0839,
    y1: 703.6584,
    x2: 106.0839,
    y2: 465.5657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.243,468.805c-0.074,1.635-0.171,3.174-0.638,4.479c-14.754,41.21-26.182,67.217-34.526,86.207 c-10.442,23.764-16.194,36.855-17.248,54.766c-1.157,19.66,4.94,30.51,10.259,36.151c5.089,5.398,11.658,8.37,18.497,8.37 c9.087,0,16.651-5.187,19.74-13.539c1.093-2.961,2.91-5.682,4.833-8.564c0.132-0.197,0.264-0.395,0.396-0.595 c-4.803,27.191-12.072,55.756-32.59,64.567c-1.564,0.67-3.346,1.01-5.297,1.01c-6.442,0-13.777-3.716-19.621-9.941 c-5.927-6.314-15.617-20.941-13.91-47.974c2.678-42.506,15.886-68.114,39.865-114.601 C118.783,512.119,128.726,492.843,140.243,468.805 M140.638,465.566c-0.646,0.574-1.551,1.023-1.895,1.741 c-43.982,91.896-66.924,117.95-70.601,176.311c-2.576,40.796,20.082,60.041,35.527,60.041c2.206,0,4.267-0.393,6.085-1.172 c23.355-10.029,30.017-43.868,34.473-70.117c-0.734-0.241-1.465-0.486-2.199-0.727c-2.58,4.28-5.876,8.296-7.578,12.905 c-2.921,7.899-10.094,12.232-17.863,12.232c-13.368,0-28.5-12.831-26.76-42.404c1.854-31.511,18.298-47.233,51.66-140.416 c0.882-2.464,0.653-5.324,0.935-8.001C141.827,465.826,141.231,465.697,140.638,465.566L140.638,465.566z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.0355,
    y1: 818.7484,
    x2: 2067.2368,
    y2: 818.7484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1999.772,863.378c20.548-44.185,22.452-44.119,16.291-47.128c-42.18-20.579-41.153-18.331-37.295-26.83 c17.523-38.624,14.742-31.803,18.932-38.14c15.458,8.148,30.387,16.015,45.784,24.132c-6.365,14.28-12.475,27.995-19.063,42.779 c39.711,22.567,46.39,18.427,41.364,29.414c-5.589,12.234-10.302,24.876-15.879,38.613 C2032.866,878.455,2016.255,870.89,1999.772,863.378z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 2022.1361,
    y1: 886.2174,
    x2: 2022.1361,
    y2: 751.2793
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1998.343,753.879l10.835,5.711l31.716,16.717l-10.237,22.971l-8.064,18.097l-0.738,1.657l1.577,0.896 c14.074,7.998,24.119,12.704,30.766,15.819c5.587,2.618,9.279,4.347,10.547,5.826c0.63,0.734,0.916,1.493-0.78,5.2 c-3.976,8.703-7.487,17.552-11.205,26.92c-1.271,3.201-2.577,6.494-3.926,9.839l-11.846-5.396 c-11.651-5.307-23.135-10.538-34.553-15.742c3.783-8.113,6.901-14.661,9.441-19.995c5.433-11.408,8.16-17.135,8.984-20.554 c1.181-4.901-1.648-6.282-3.922-7.393c-6.117-2.984-11.233-5.445-15.747-7.615c-11.904-5.724-18.462-8.877-21.021-11.005 c-1.507-1.253-1.508-1.427-0.02-4.636c0.14-0.302,0.286-0.618,0.437-0.95c14.448-31.845,14.999-32.598,17.052-35.398 C1997.857,754.554,1998.085,754.242,1998.343,753.879 M1997.7,751.279c-4.19,6.337-1.409-0.484-18.932,38.14 c-3.858,8.499-4.885,6.251,37.295,26.83c6.161,3.009,4.257,2.943-16.291,47.129c16.483,7.512,33.094,15.077,50.134,22.839 c5.576-13.737,10.289-26.379,15.879-38.613c5.026-10.987-1.653-6.847-41.364-29.414c6.588-14.784,12.699-28.499,19.063-42.779 C2028.087,767.294,2013.158,759.427,1997.7,751.279L1997.7,751.279z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1303.7794,
    y1: 601.4633,
    x2: 1408.0923,
    y2: 601.4633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1367.93,604.913c-21.1-5.795-40.88-4.205-62.622-0.477c10.541-25.118,9.488-18.032,20.145-37.794 c3.515-6.518,9.39-7.837,15.623-8.025c27.14-0.829,35.92-1.53,60.176,7.328c24.771,9.045-24.306,47.628-42.906,63.805 c-8.825,7.673-42.992,13.511-54.527,15.021c-0.469-4.985,3.313-5.572,5.887-6.974 C1373.732,602.915,1359.036,611.863,1367.93,604.913z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1355.9358,
    y1: 644.7701,
    x2: 1355.9358,
    y2: 558.1566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1360.488,560.157c12.932,0,22.228,1.147,40.078,7.667c3.237,1.182,5.012,2.878,5.426,5.184 c2.104,11.725-27.128,36.613-42.832,49.985c-2.228,1.897-4.331,3.688-6.125,5.248c-7.087,6.162-33.97,11.789-50.965,14.204 c0.457-0.931,1.455-1.427,3.008-2.127c0.523-0.236,1.064-0.48,1.586-0.764c20.975-11.427,33.617-18.213,41.171-22.267 c12.327-6.616,12.327-6.616,14.591-8.554c0.624-0.534,1.401-1.199,2.737-2.243l3.136-2.451l-3.838-1.054 c-9.539-2.62-19.294-3.893-29.823-3.893c-8.805,0-18.196,0.862-30.068,2.775c5.366-12.544,7.333-15.571,10.198-19.981 c1.939-2.985,4.353-6.7,8.448-14.294c3.158-5.856,8.558-6.813,13.924-6.975l3.359-0.104 C1350.581,560.321,1355.835,560.157,1360.488,560.157 M1360.488,558.157c-5.51,0-11.726,0.225-19.412,0.46 c-6.233,0.188-12.107,1.507-15.623,8.025c-10.657,19.762-9.604,12.677-20.145,37.794c11.498-1.971,22.443-3.345,33.328-3.345 c9.699,0,19.351,1.091,29.294,3.822c-8.894,6.951,5.802-1.998-58.224,32.884c-2.574,1.402-6.356,1.988-5.887,6.974 c11.535-1.509,45.702-7.348,54.527-15.021c18.6-16.176,67.677-54.759,42.906-63.805 C1383.866,559.595,1374.433,558.157,1360.488,558.157L1360.488,558.157z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.8833,
    y1: 126.4078,
    x2: 501.6668,
    y2: 126.4078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M207.883,196.695c0.381-9.652,4.131-15.59,12.938-19.651c48.529-22.391,13.886-14.343,274.029-119.981 c1.305-0.53,2.893-1.172,4.119-0.861c1.108,0.285,2.86,2.05,2.685,2.742c-6.593,25.943-17.766,0.705-290.797,137.455 C210.137,196.761,209.149,196.585,207.883,196.695z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.7751,
    y1: 196.6948,
    x2: 354.7751,
    y2: 56.1209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M498.269,58.121c0.107,0,0.172,0.011,0.183,0.013c0.266,0.092,0.81,0.547,1.113,0.901 c-2.639,9.982-5.903,11.18-32.796,21.046c-34.135,12.523-105.171,38.584-256.731,114.495c0.807-7.695,4.286-12.333,11.621-15.715 c11.836-5.461,18.79-9.143,26.153-13.041c22.687-12.011,50.922-26.959,247.79-106.903 C496.475,58.562,497.562,58.121,498.269,58.121 M498.269,56.121c-1.094,0-2.351,0.509-3.42,0.942 c-260.143,105.638-225.499,97.59-274.029,119.981c-8.807,4.061-12.556,9.999-12.938,19.651c1.266-0.109,2.254,0.066,2.974-0.296 C483.888,59.649,495.062,84.887,501.655,58.944c0.175-0.692-1.577-2.457-2.685-2.742 C498.746,56.146,498.512,56.121,498.269,56.121L498.269,56.121z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 2074.4736,
    y1: 128.9466,
    x2: 2326.7463,
    y2: 128.9466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M2074.839,181.285c-1.551-6.115,2.028-14.145,7.109-16.276c72.453-30.428,236.49-86.234,244.799-88.401 c-0.065,10.183-3.333,14.309-11.617,17.132C2261.482,112.015,2122.905,159.014,2074.839,181.285z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 2200.6099,
    y1: 181.2848,
    x2: 2200.6099,
    y2: 76.6083
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M2324.641,79.342c-0.536,7.042-3.196,10.133-10.156,12.505l-5.274,1.796 c-55.455,18.884-184.045,62.672-232.739,84.695c-0.049-4.695,2.654-9.976,6.25-11.485 C2152.501,137.548,2302.2,86.506,2324.641,79.342 M2326.746,76.608c-8.309,2.167-172.345,57.973-244.798,88.401 c-5.081,2.131-8.66,10.161-7.109,16.276c48.066-22.271,186.643-69.27,240.291-87.545 C2323.413,90.917,2326.681,86.791,2326.746,76.608L2326.746,76.608z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.2922,
    y1: 865.2588,
    x2: 1899.6331,
    y2: 865.2588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1861.465,835.466c-6.007,11.892-11.313,28.667-38.311,44.676c-56.266,33.357-70.662,38.078-89.321,40.221 c-13.117,1.508-25.251,7.101-29.541,5.655c0.697-0.552,1.314-1.283,2.103-1.629c44.254-19.431,56.946-23.143,100.578-48.956 c76.339-45.194,33.427-39.01,71.895-68.781c14.039-10.876,28.989,17.788,15.441,37.799 C1889.831,851.057,1871.759,845.231,1861.465,835.466z M1872.819,821.458c3.461,5.935,8.647,8.485,16.037,7.425 C1877.68,817.517,1881.754,820.114,1872.819,821.458z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1801.9628,
    y1: 926.254,
    x2: 1801.9628,
    y2: 804.2634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1885.212,804.263v2h0c3.395,0,6.868,2.727,9.291,7.293c4.004,7.546,4.984,19.678-1.849,29.771 c-1.087,1.604-3.496,1.941-5.325,1.941c-7.197,0-17.724-4.838-24.488-11.254l-1.95-1.849l-1.212,2.399 c-0.149,0.295-0.297,0.593-0.445,0.892c0.569-1.31,1.032-2.581,1.5-3.862c2.092-5.739,4.256-11.673,19.359-23.361 c1.686-1.306,3.408-1.969,5.118-1.969L1885.212,804.263 M1885.728,831.117c1.087,0,2.235-0.086,3.412-0.254l3.916-0.562 l-2.773-2.82c-1.485-1.511-2.7-2.774-3.712-3.825c-3.914-4.069-5.232-5.439-7.55-5.439c-0.827,0-1.616,0.201-2.615,0.455 c-0.963,0.245-2.162,0.55-3.884,0.809l-2.915,0.438l1.485,2.547C1874.439,828.206,1879.363,831.117,1885.728,831.117  M1858.041,837.925c-0.185,0.389-0.372,0.783-0.562,1.182c-5.401,11.381-12.123,25.545-35.345,39.314 c-56.421,33.449-70.303,37.861-88.529,39.954c-5.827,0.67-11.524,2.143-16.257,3.419c4.618-2,8.871-3.827,12.813-5.52 c27.528-11.821,42.691-18.333,77.831-39.121C1843.93,855.878,1853.808,845.793,1858.041,837.925 M1885.211,804.263 c-2.066,0-4.216,0.741-6.342,2.388c-38.469,29.771,4.443,23.587-71.895,68.781c-43.632,25.812-56.324,29.525-100.578,48.955 c-0.789,0.346-1.406,1.077-2.103,1.629c0.484,0.163,1.067,0.237,1.741,0.237c5.299,0,16.163-4.554,27.801-5.891 c18.659-2.143,33.055-6.864,89.321-40.221c26.998-16.009,32.303-32.784,38.311-44.676c7.252,6.879,18.364,11.803,25.864,11.803 c3.146,0,5.657-0.867,6.98-2.819C1905.805,827.471,1896.785,804.261,1885.211,804.263L1885.211,804.263z M1885.728,829.117 c-5.754,0-9.959-2.599-12.909-7.659c3.492-0.525,4.996-1.241,6.201-1.241c1.878,0,3.027,1.742,9.836,8.666 C1887.766,829.039,1886.724,829.117,1885.728,829.117L1885.728,829.117z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1790.0123,
    y1: 511.9727,
    x2: 1987.7684,
    y2: 511.9727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1790.012,572.323c2.094-8.217,1.835-15.095,9.571-19.335c1.009-0.553,172.147-97.612,187.84-101.364 c1.839,15.24-2.242,14.773-48.158,38.508C1856,533.176,1790.012,572.323,1790.012,572.323z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1888.8904,
    y1: 572.3226,
    x2: 1888.8904,
    y2: 451.6229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1985.685,454.306c0.355,4.695-0.346,7.191-3.44,10.017c-4.113,3.757-12.386,7.961-27.405,15.594 c-4.805,2.442-10.252,5.21-16.493,8.436c-70.878,36.641-129.88,70.836-145.38,79.911c0.014-0.068,0.028-0.135,0.042-0.202 c1.234-6.012,2.126-10.356,7.537-13.322c0.056-0.031,0.628-0.354,1.662-0.939C1880.807,509.362,1967.978,461.201,1985.685,454.306  M1987.423,451.623c-15.693,3.753-186.831,100.811-187.84,101.364c-7.736,4.241-7.477,11.118-9.571,19.335 c0,0,65.988-39.147,149.253-82.191C1985.181,466.396,1989.263,466.863,1987.423,451.623L1987.423,451.623z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 2262.5659,
    y1: 336.3069,
    x2: 2331.1272,
    y2: 336.3069
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M2285.693,302.146c47.624,25.784,47.212,23.627,44.4,29.331c-16.945,34.371-18.375,40.651-22.41,38.659 c-47.629-23.586-47.707-22.444-43.326-29.745C2274.781,323,2278.655,311.292,2285.693,302.146z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 2296.8464,
    y1: 370.4674,
    x2: 2296.8464,
    y2: 302.1464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2286.266,304.73c9.383,5.072,16.765,8.988,22.755,12.165c12.737,6.756,19.753,10.478,20.106,11.802 c0.009,0.218-0.358,0.952-0.625,1.489l-0.203,0.407c-4.071,8.257-7.235,14.87-9.777,20.183 c-4.99,10.427-8.286,17.316-9.613,17.692c-0.001,0-0.097-0.004-0.338-0.123c-5.29-2.62-9.993-4.934-14.169-6.989 c-20-9.843-29.129-14.335-29.807-16.64c-0.165-0.561,0.503-1.674,1.35-3.083l0.128-0.213c4.761-7.943,8.134-14.646,11.11-20.559 C2280.409,314.449,2283.02,309.261,2286.266,304.73 M2285.694,302.146c-7.038,9.145-10.912,20.853-21.337,38.245 c-4.381,7.301-4.302,6.159,43.326,29.745c0.431,0.213,0.832,0.331,1.225,0.331c3.292,0,6.049-8.288,21.185-38.99 C2332.905,325.774,2333.317,327.93,2285.694,302.146L2285.694,302.146z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 1307.8043,
    y1: 704.2932,
    x2: 1377.0637,
    y2: 704.2932
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1377.064,699.814c-32.616,51.429-12.725,47.843-66.155,13.715c-6.693-4.271-3.75-3.421,20.651-41.075 c3.821-5.9,3.577-4.063,42.495,23.812C1375.215,697.098,1375.973,698.5,1377.064,699.814z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 1342.4341,
    y1: 738.8682,
    x2: 1342.4341,
    y2: 669.7183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1334.839,671.718c1.991,0,7.984,4.365,19.925,13.061c4.807,3.5,10.788,7.857,18.125,13.111 c0.522,0.374,1.009,1.04,1.573,1.811c0.055,0.075,0.11,0.15,0.165,0.225c-6.125,9.739-10.396,17.54-13.547,23.295 c-4.975,9.086-7.472,13.646-10.355,13.646c-2.767,0-7.379-3.314-15.02-8.806c-5.643-4.056-13.372-9.61-23.72-16.219 c-0.78-0.497-2.084-1.33-2.17-1.751c-0.27-1.318,3.085-6.234,8.162-13.675c3.672-5.382,8.702-12.753,15.262-22.876 C1334.143,672.144,1334.517,671.718,1334.839,671.718 M1334.839,669.718c-1.43,0-2.19,1.053-3.279,2.736 c-24.402,37.654-27.344,36.804-20.651,41.075c25.121,16.045,34.033,25.339,39.816,25.339c6.517,0,9.058-11.805,26.339-39.054 c-1.091-1.314-1.849-2.716-3.009-3.548C1346.232,676.338,1338.425,669.718,1334.839,669.718L1334.839,669.718z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.4357,
    y1: 776.0077,
    x2: 217.6339,
    y2: 776.0077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M161.534,745.12c-4.9-10.977-10.215-11.731-18.577-3.294c-3.513,3.544-3.43,6.273,0.28,9.413 c13.56,11.473,25.961,0.864,40.472-8.078c2.088,6.365,0.149,10.933-5.758,14.946c-22.794,15.483-40.435,24.596-43.206,39.792 c-2.487,13.636,14.194,31.643,81.684,1.2c0.401,0.324,0.804,0.648,1.204,0.972c-1.666,2.129-2.998,4.678-5.055,6.321 c-58.977,47.108-111.616,19.987-70.544-32.003c7.237-9.155-16.806-4.13-7.828-28.556c7.021-19.113,22.783-25.571,25.982-24.399 c6.133,2.256,6.056,8.314,7.145,13.343C168.37,739.57,164.839,742.194,161.534,745.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.5335,
    y1: 830.7126,
    x2: 172.5335,
    y2: 721.3028
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M159.268,723.303L159.268,723.303c0.147,0,0.225,0.012,0.236,0.012c0.001,0,0.002,0,0.001-0.001 c4.041,1.489,4.665,5.097,5.386,9.275c0.149,0.86,0.302,1.749,0.489,2.612c0.586,2.712-0.703,4.404-3.19,6.671 c-2.009-3.828-5.014-7.757-9.596-7.758c-3.28,0-6.793,2.003-11.057,6.305c-2.238,2.257-3.237,4.292-3.145,6.406 c0.09,2.051,1.252,3.995,3.553,5.943c4.362,3.69,8.86,5.484,13.752,5.484c8.097,0,15.863-4.974,24.084-10.239 c0.866-0.555,1.748-1.12,2.638-1.684c0.575,4.063-1.163,7.117-5.592,10.126c-3.586,2.436-7.023,4.7-10.347,6.889 c-18.122,11.936-31.216,20.56-33.703,34.198c-0.842,4.617,0.3,9.085,3.215,12.581c2.905,3.483,9.006,7.635,21.577,7.635 c14.046,0,32.789-5.075,55.752-15.09c-0.623,0.834-1.265,1.584-1.991,2.164c-19.001,15.177-39.404,23.882-55.975,23.882 c-11.574,0-20.306-4.323-23.957-11.859c-4.918-10.153-0.47-25.179,12.205-41.223c1.437-1.818,2.009-3.451,1.749-4.993 c-0.388-2.305-2.4-3.59-4.531-4.952c-4.472-2.857-9.541-6.095-4.738-19.161C142.077,730.211,155.097,723.303,159.268,723.303  M159.267,721.303c-4.592,0-18.565,6.853-25.06,24.532c-8.979,24.426,15.064,19.401,7.828,28.556 c-26.266,33.249-14.213,56.323,13.321,56.323c15.52,0,35.964-7.338,57.223-24.319c2.057-1.643,3.388-4.192,5.055-6.321 c-0.401-0.324-0.804-0.648-1.204-0.972c-27.162,12.252-46.094,16.656-58.859,16.656c-18.952,0-24.311-9.709-22.824-17.856 c2.771-15.196,20.413-24.309,43.206-39.792c5.907-4.012,7.845-8.581,5.758-14.946c-9.982,6.15-18.963,13.089-28.012,13.089 c-4.106,0-8.228-1.43-12.461-5.011c-3.71-3.141-3.793-5.87-0.28-9.413c3.744-3.778,6.877-5.713,9.636-5.713 c3.403,0,6.235,2.944,8.941,9.006c3.305-2.926,6.835-5.55,5.8-10.342c-1.089-5.029-1.012-11.087-7.145-13.343 C159.95,721.348,159.639,721.303,159.267,721.303L159.267,721.303z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.4684,
    y1: 246.7864,
    x2: 378.693,
    y2: 246.7864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M237.468,320.724c1-0.534,86.11-60.761,110.835-95.101c4.017-5.578,3.822-5.97-2.269-8.796 c-11.798-5.473-13.837-10.966-9.832-23.529c8.538-26.791,32.245-30.206,33.852-10.901c1.853,22.208-9.352,23.481-1.803,26.69 c17.492,7.453,9.401,22.498,1.678,18.899c-27.777-12.95,3.328,5.113-87.054,68.985c-12.727,8.991-25.956,17.274-39.051,25.73 c-1.156,0.749-2.95,0.508-4.451,0.727C238.739,322.526,238.104,321.624,237.468,320.724z M362.441,198.447 c0.044-5.092-1.342-9.827-6.26-11.895c-4.464-1.879-7.646,1.592-10.451,4.566c-5.897,6.253,0.947,8.667,8.769,12.314 C361.456,206.676,362.415,206.06,362.441,198.447z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.0804,
    y1: 323.4284,
    x2: 308.0804,
    y2: 170.1444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M359.004,170.144v2c5.128,0,8.514,3.895,9.058,10.419c0.954,11.43-1.657,16.932-3.216,20.219 c-0.915,1.929-1.638,3.452-1.004,5.12c0.592,1.558,2.166,2.403,3.627,3.024c7.758,3.305,9.785,8.094,9.095,11.474 c-0.489,2.395-2.271,4.133-4.237,4.133c-0.516,0-1.038-0.121-1.55-0.36c-6.227-2.903-9.252-4.117-11.865-4.118 c0,0-0.001,0-0.001,0c-4.075,0-5.975,3.02-9.122,8.024c-6.306,10.025-19.428,30.886-68.065,65.258 c-10.134,7.159-20.779,13.991-31.074,20.598c-2.638,1.693-5.276,3.386-7.911,5.087c-0.335,0.217-1.241,0.259-1.969,0.292 c-0.14,0.006-0.281,0.013-0.423,0.02l-0.092-0.13c12.649-8.937,86.635-62.417,109.672-94.414c2.195-3.049,3.513-5.022,2.97-7.096 c-0.563-2.151-2.852-3.213-6.021-4.682c-10.725-4.975-12.528-9.315-8.768-21.108c4.764-14.95,14.171-21.76,20.895-21.761 L359.004,170.144 M359.974,207.289c4.437,0,4.454-5.106,4.467-8.825c0.061-7.014-2.458-11.642-7.483-13.755 c-1.086-0.457-2.186-0.689-3.269-0.689c-4.014,0-6.94,3.104-9.292,5.598l-0.122,0.129c-2.207,2.34-3.081,4.499-2.673,6.598 c0.72,3.698,5.171,5.74,10.324,8.104c0.567,0.26,1.144,0.525,1.727,0.797C356.361,206.507,358.362,207.289,359.974,207.289  M359.002,170.144c-7.872,0.001-17.868,7.676-22.8,23.154c-4.006,12.563-1.966,18.056,9.832,23.529 c6.091,2.825,6.286,3.217,2.269,8.796c-24.725,34.339-109.835,94.567-110.835,95.101c0.635,0.9,1.27,1.802,1.905,2.705 c1.5-0.219,3.294,0.022,4.451-0.727c13.095-8.456,26.324-16.74,39.051-25.73c72.37-51.143,66.848-72.917,76.034-72.915 c2.286,0,5.484,1.35,11.02,3.93c0.805,0.375,1.612,0.547,2.395,0.547c6.735,0,11.596-12.77-4.073-19.447 c-7.55-3.209,3.655-4.482,1.803-26.69C369.376,174.245,364.757,170.144,359.002,170.144L359.002,170.144z M359.974,205.289 c-1.188,0-2.93-0.67-5.475-1.857c-7.822-3.647-14.666-6.06-8.769-12.314c2.253-2.389,4.75-5.099,7.958-5.099 c0.786,0,1.615,0.163,2.493,0.532c4.917,2.067,6.303,6.803,6.26,11.895C362.424,203.275,362.033,205.289,359.974,205.289 L359.974,205.289z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 474.8346,
    y1: 356.8764,
    x2: 542.8874,
    y2: 356.8764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M542.887,353.292c-30.317,40.988-28.216,39.147-33.578,34.294c-29.207-26.437-38.55-26.016-32.917-33.081 c27.627-34.601,24.307-34.48,35.33-26.383C522.354,335.932,532.302,344.675,542.887,353.292z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 508.861,
    y1: 390.08,
    x2: 508.861,
    y2: 323.6728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M503.915,325.673L503.915,325.673c1.17,0,2.864,1.263,5.209,3.012c0.445,0.332,0.916,0.683,1.415,1.05 c7.344,5.395,14.238,11.138,21.537,17.217c2.631,2.192,5.338,4.446,8.07,6.685c-1.887,2.553-3.644,4.933-5.281,7.151 c-7.998,10.835-13.282,17.993-16.73,22.211c-3.724,4.554-4.864,5.072-5.172,5.083c-0.257-0.05-0.974-0.727-1.497-1.221 c-0.254-0.24-0.524-0.494-0.814-0.757c-11.615-10.513-20.135-16.826-25.773-21.003c-4.565-3.382-7.863-5.825-8.037-7.158 c-0.059-0.451,0.316-1.188,1.114-2.189c4.337-5.432,7.975-10.089,10.898-13.831C497.304,331.103,501.546,325.673,503.915,325.673  M503.915,323.673c-4.361,0-8.946,7.568-27.522,30.832c-5.633,7.065,3.71,6.644,32.917,33.081c1.51,1.367,2.428,2.494,3.645,2.494 c3.105,0,8.154-7.343,29.933-36.788c-10.585-8.616-20.533-17.359-31.165-25.17C508.111,325.469,506.04,323.673,503.915,323.673 L503.915,323.673z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 1305.8486,
    y1: 810.067,
    x2: 1388.101,
    y2: 810.067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M1382.99,789.941c-3.216-3.828-8.839-12.434-12.664-5.129c-10.118,19.311-1.324,9.399-14.433,67.55 c-0.276,1.213-1.927,2.116-2.939,3.158c-0.754-1.051-1.805-2.002-2.208-3.176c-15.003-43.576-8.073-27.349-21.589-49.753 c-3.491,3.899-6.087,3.106-9.008,0.876c-11.129-8.486-18.468-5.002-11.7-23.102c2.12-5.668,5.813-6.755,12.812-4.078 c18.851,7.222,25.403,31.75,34.763,47.851c0.814-6.729,5.235-68.193,23.965-58.487 C1392.645,772.204,1387.923,778.652,1382.99,789.941z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1346.9747,
    y1: 855.5194,
    x2: 1346.9747,
    y2: 764.6146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M1376.12,764.615v2c0.916,0,1.909,0.273,2.95,0.813c9.669,5.006,7.89,8.915,3.593,18.358 c-0.055,0.12-0.109,0.241-0.165,0.362c-2.422-2.986-5.332-6.184-8.617-6.184c-1.494,0-3.63,0.68-5.326,3.92 c-5.368,10.246-5.62,12.83-6.368,20.502c-0.704,7.226-1.883,19.32-8.233,47.496c-0.074,0.17-0.407,0.479-0.739,0.763 c-0.264-0.341-0.478-0.662-0.577-0.951c-2.969-8.623-5.101-14.97-6.658-19.604c-4.69-13.963-4.78-14.23-8.884-20.58 c-1.421-2.198-3.366-5.209-6.226-9.95l-1.398-2.317l-1.805,2.016c-1.248,1.393-2.313,2.071-3.257,2.071 c-0.794,0-1.734-0.447-3.048-1.451c-2.959-2.256-5.675-3.71-7.857-4.878c-3.142-1.682-4.808-2.637-5.388-4.307 c-0.713-2.053-0.033-5.639,2.206-11.625c1.371-3.666,3.135-4.172,4.836-4.172c1.407,0,3.17,0.412,5.388,1.261 c13.405,5.135,20.297,19.621,26.962,33.63c2.269,4.769,4.413,9.274,6.787,13.359l2.998,5.157l0.717-5.922 c0.065-0.541,0.154-1.429,0.271-2.601c4.773-47.992,13.225-55.161,17.838-55.162L1376.12,764.615 M1376.118,764.615 c-15.482,0.006-19.339,53.285-20.094,59.524c-9.36-16.101-15.912-40.629-34.763-47.851c-2.4-0.918-4.411-1.393-6.103-1.393 c-3.243,0-5.316,1.746-6.709,5.471c-6.768,18.1,0.571,14.616,11.7,23.102c1.451,1.107,2.821,1.86,4.261,1.86 c1.459,0,2.99-0.774,4.747-2.736c13.516,22.404,6.586,6.176,21.589,49.753c0.403,1.174,1.454,2.125,2.208,3.176 c1.011-1.042,2.663-1.945,2.939-3.158c13.11-58.15,4.316-48.239,14.434-67.55c1.074-2.051,2.29-2.848,3.554-2.848 c3.238,0,6.796,5.224,9.109,7.977c4.933-11.288,9.655-17.736-3-24.289C1378.623,764.943,1377.336,764.614,1376.118,764.615 L1376.118,764.615z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.943,
    y1: 450.4666,
    x2: 136.4513,
    y2: 450.4666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M74.829,444.452c-30.838-4.04-23.553-39.091-3.725-25.702c22.017,14.869,24.321,37.639,29.887,47.002 c5.792-24.458,5.284-49.674,23.094-58.465c5.064-2.501,7.326,3.226,10.502,5.563c4.716,3.473-0.896,13.868-1.748,16.017 c-6.662-4.077-13.317-10.192-16.825-0.372c-11.253,31.483-6.007,45.736-15.307,63.704c-0.222,0.427-0.677,0.736-1.941,2.067 C91.319,476.786,88.344,457.81,74.829,444.452z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.1975,
    y1: 494.2659,
    x2: 95.1975,
    y2: 406.6672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M126.482,408.667c1.403,0,2.703,1.462,4.078,3.009c0.877,0.986,1.783,2.006,2.84,2.784 c2.533,1.866-0.045,8.313-1.447,11.477c-0.195-0.126-0.389-0.253-0.581-0.378c-3.435-2.237-6.679-4.35-9.889-4.35 c-3.312,0-5.785,2.224-7.353,6.612c-5.741,16.061-7.214,27.479-8.514,37.553c-1.206,9.35-2.168,16.8-6.259,25.063 c-1.572-3.977-2.972-8.041-4.336-11.998c-4.325-12.555-8.798-25.537-18.786-35.409l-0.479-0.473l-0.667-0.087 c-13.797-1.808-19.583-10.267-19.12-17.361c0.24-3.678,2.415-7.389,6.737-7.39c2.157,0,4.674,0.93,7.279,2.69 c15.646,10.566,21.031,25.358,24.963,36.159c1.478,4.059,2.754,7.565,4.325,10.207l2.526,4.249l1.139-4.811 c1.362-5.75,2.375-11.521,3.355-17.101c3.178-18.102,5.923-33.735,18.678-40.031C125.524,408.806,126.033,408.667,126.482,408.667  M126.482,406.667c-0.728,0-1.521,0.186-2.398,0.619c-17.81,8.792-17.302,34.008-23.094,58.465 c-5.566-9.363-7.87-32.133-29.887-47.002c-3.151-2.128-5.985-3.032-8.4-3.032c-12.78,0.001-13.812,25.336,12.125,28.734 c13.516,13.358,16.49,32.334,23.937,49.814c1.264-1.331,1.719-1.64,1.941-2.067c9.3-17.968,4.054-32.221,15.307-63.704 c1.393-3.899,3.281-5.286,5.469-5.286c3.323,0,7.338,3.2,11.356,5.658c0.852-2.149,6.464-12.544,1.748-16.017 C131.96,410.918,129.959,406.667,126.482,406.667L126.482,406.667z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.2723,
    y1: 269.8957,
    x2: 616.0988,
    y2: 269.8957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M464.272,306.801c11.702-18.556-25.433-3.547,146.283-73.492c1.684-0.685,3.588-0.839,5.543-1.273 c-0.718,22.773-8.425,8.636-150.549,75.72C465.124,307.436,464.699,307.118,464.272,306.801z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.1855,
    y1: 307.7556,
    x2: 540.1855,
    y2: 232.0358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M613.976,234.472c-0.335,4.551-1.285,6.862-4.318,9.155c-4.034,3.05-11.728,5.981-25.696,11.3 c-21.282,8.106-56.656,21.578-116.171,49.561c0.828-1.858,1.181-3.334,1.486-4.607c0.872-3.641,1.309-5.469,18.334-13.336 c18.225-8.422,55.688-23.682,123.698-51.384C612.094,234.842,613.005,234.649,613.976,234.472 M616.099,232.036 c-1.956,0.434-3.859,0.587-5.543,1.273c-171.717,69.945-134.582,54.936-146.283,73.492c0.427,0.318,0.852,0.635,1.277,0.955 C607.674,240.672,615.381,254.808,616.099,232.036L616.099,232.036z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 2250.0491,
    y1: 272.6323,
    x2: 2396.2478,
    y2: 272.6323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M2394.752,244.249c5.725,17.514,2.103,7.574-144.229,56.767c-1.77-5.659,1.577-13.1,7.354-15 C2303.414,271.027,2391.325,244.405,2394.752,244.249z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 2323.1484,
    y1: 301.0161,
    x2: 2323.1484,
    y2: 244.2485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M2393.397,246.567c0.821,2.631,1.138,4.199,0.548,5.32c-1.69,3.208-11.946,6.214-34.418,12.8 c-22.107,6.479-55.364,16.226-107.466,33.703c-0.283-4.381,2.498-9.177,6.442-10.475 C2302.72,273.361,2381.036,249.639,2393.397,246.567 M2394.752,244.249c-3.427,0.157-91.339,26.779-136.875,41.767 c-5.778,1.901-9.125,9.341-7.354,15.001C2396.855,251.823,2400.478,261.762,2394.752,244.249L2394.752,244.249z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 1942.3445,
    y1: 545.2758,
    x2: 2012.7512,
    y2: 545.2758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M1984.077,557.959c2.675-19.948,1.123-31.421,10.64-48.201c7.479-13.187,17.549,0.103,17.964,2.738 c0.717,4.516-4.268,13.569-5.874,16.679c-0.867-1.976-1.038-2.974-1.617-3.585c-14.834-15.673-10.878,10.197-20.667,60.948 c-0.775-0.008-1.551-0.017-2.33-0.026c-16.658-43.12-9.903-22.811-16.97-37.952c-5.214-11.178-25.983-5.21-22.485-27.071 c2.165-13.587,20.551-2.17,27.605,10.509C1974.891,540.162,1979.101,548.515,1984.077,557.959z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.5479,
    y1: 586.5367,
    x2: 1977.5479,
    y2: 504.0149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M2002.327,506.015c4.062,0,8.069,5.499,8.379,6.794c0.427,2.685-1.927,8.016-3.774,11.746 c-0.088-0.117-0.184-0.23-0.289-0.341c-3.389-3.581-5.938-5.178-8.264-5.179c0,0-0.001,0-0.001,0 c-6.119,0-7.28,8.919-9.825,28.458c-1.271,9.757-2.832,21.749-5.454,35.817c-10.08-26.023-10.961-27.123-12.394-28.912 c-0.587-0.733-1.317-1.645-3.67-6.685c-2.331-4.997-7.082-6.95-11.676-8.84c-7.013-2.884-12.552-5.161-10.646-17.071 c0.636-3.993,2.7-4.455,4.198-4.455c5.754,0,15.136,7.446,19.685,15.622c3.105,5.575,6.069,11.273,9.208,17.306 c1.448,2.783,2.937,5.645,4.502,8.615l2.919,5.54l0.832-6.207c0.663-4.946,1.06-9.277,1.443-13.466 c1.155-12.619,1.99-21.736,8.954-34.015C1998.236,507.606,2000.212,506.015,2002.327,506.015 M2002.327,504.015 c-2.533,0-5.206,1.503-7.61,5.743c-9.517,16.78-7.965,28.254-10.64,48.201c-4.976-9.444-9.185-17.797-13.732-25.962 c-4.794-8.616-14.82-16.65-21.433-16.649c-3.118,0-5.478,1.787-6.172,6.141c-3.498,21.86,17.27,15.892,22.484,27.071 c7.067,15.141,0.312-5.168,16.97,37.952c0.78,0.009,1.555,0.018,2.33,0.026c7.867-40.786,6.856-65.503,13.855-65.502 c1.71,0,3.899,1.476,6.811,4.554c0.578,0.611,0.749,1.609,1.617,3.585c1.606-3.11,6.592-12.163,5.874-16.679 C2012.399,510.708,2007.674,504.015,2002.327,504.015L2002.327,504.015z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.5154,
    y1: 310.6664,
    x2: 610.5491,
    y2: 310.6664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M591.207,278.28c-1.165,3.69-2.332,7.383-3.55,11.231c21.604,13.008,27.324,16.364,19.653,40.405 c-6.26,19.618-74.278,30.643-17.033-52.457C590.587,277.732,590.899,278.006,591.207,278.28z M580.451,304.442 c-10.139,10.876-5.305,29.033,16.792,22.318C615.934,321.084,585.74,307.245,580.451,304.442z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.0318,
    y1: 343.8744,
    x2: 589.0318,
    y2: 277.4584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M586.356,286.992c-0.201,0.635-0.403,1.273-0.606,1.915l-0.476,1.503l1.351,0.813l0.2,0.12 c21.311,12.832,25.746,15.502,18.58,37.963c-2.099,6.577-12.784,12.567-22.418,12.567c-3.971,0-9.254-1.046-11.873-6.031 C568.346,330.575,567.023,317.424,586.356,286.992 M588.487,330.211c2.838,0,5.98-0.517,9.338-1.538 c4.685-1.423,7.186-3.602,7.436-6.479c0.544-6.274-10.278-12.643-22.054-18.591c-0.754-0.381-1.375-0.694-1.818-0.929 l-1.354-0.718l-1.045,1.121c-5.205,5.584-6.991,13.271-4.444,19.127C576.757,327.293,581.839,330.211,588.487,330.211  M590.277,277.458c-34.984,50.787-23.186,66.416-7.29,66.416c10.114,0,21.889-6.33,24.323-13.959 c7.671-24.041,1.951-27.396-19.653-40.405c1.218-3.848,2.385-7.541,3.55-11.231C590.899,278.006,590.587,277.732,590.277,277.458 L590.277,277.458z M588.487,328.211c-14.448,0-16.659-14.519-8.035-23.77c5.289,2.803,35.482,16.643,16.792,22.318 C593.941,327.764,591.026,328.211,588.487,328.211L588.487,328.211z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 1931.9495,
    y1: 280.7341,
    x2: 1997.777,
    y2: 280.7341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M1994.016,263.5c-11.478-7.066-12.134-8.449-17.762,28.383c-3.576,23.367-3.365,25.545-5.06,25.29 c-2.497-0.395-3.977-5.706-4.446-7.751c-2.444-10.728-7.385-20.137-14.438-28.455c-4.341,1.354-16.663-2.869-19.348-6.542 c-2.054-2.812-0.811-14.236,2.181-16.746c8.519-7.147,26.657,11.049,34.562,32.562c0.272,0.74,0.92,1.345,1.524,2.201 c3.453-24.868,2.521-28.634,10.5-43.677c5.614-10.584,19.074-0.309,15.432,8.837C1996.39,259.541,1995.199,261.312,1994.016,263.5 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 1964.8633,
    y1: 317.1912,
    x2: 1964.8633,
    y2: 244.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M1988.268,246.277L1988.268,246.277c2.167,0,4.547,1.444,6.063,3.679c1.49,2.197,1.845,4.715,0.972,6.907 c-0.467,1.173-1.12,2.304-1.877,3.614c-0.044,0.076-0.088,0.152-0.132,0.229c-3.057-1.876-5.368-3.177-7.546-3.177 c-6.001-0.001-7.432,7.62-11.472,34.052c-0.838,5.475-1.462,9.746-1.963,13.178c-0.682,4.667-1.166,7.98-1.535,9.703 c-0.626-0.922-1.446-2.718-2.08-5.484c-2.434-10.684-7.435-20.543-14.862-29.304l-0.856-1.01l-1.264,0.394 c-0.246,0.077-0.702,0.168-1.478,0.168c-4.853,0-13.781-3.41-15.66-5.981c-1.381-1.891-0.373-12.167,1.852-14.034 c0.892-0.748,1.926-1.112,3.16-1.112c7.636,0,21.335,14.041,28.239,32.831c0.293,0.798,0.771,1.394,1.233,1.97 c0.173,0.216,0.356,0.442,0.535,0.695l2.919,4.136l0.696-5.014c0.65-4.679,1.14-8.574,1.572-12.01 c1.847-14.678,2.404-19.108,8.714-31.005C1984.701,247.429,1986.307,246.277,1988.268,246.277 M1988.267,244.277 c-2.436,0-4.844,1.295-6.538,4.488c-7.979,15.043-7.047,18.809-10.5,43.677c-0.604-0.856-1.252-1.461-1.524-2.201 c-6.711-18.267-20.802-34.142-30.116-34.142c-1.655,0-3.16,0.502-4.445,1.58c-2.992,2.51-4.236,13.934-2.181,16.746 c2.334,3.193,11.949,6.801,17.275,6.801c0.801,0,1.505-0.082,2.073-0.259c7.052,8.318,11.993,17.728,14.438,28.455 c0.469,2.045,1.949,7.356,4.446,7.751c0.076,0.011,0.148,0.018,0.216,0.018c1.467,0,1.427-2.986,4.843-25.308 c3.81-24.935,5.341-32.355,9.495-32.354c1.981,0,4.56,1.69,8.268,3.972c1.183-2.188,2.374-3.96,3.145-5.898 C1999.704,251.214,1993.908,244.276,1988.267,244.277L1988.267,244.277z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.5572,
    y1: 228.3568,
    x2: 282.3774,
    y2: 228.3568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M265.295,195.052c-0.657,3.106-0.913,6.373-2.067,9.28c-1.603,4.039-1.369,6.437,3.259,8.119 c27.258,9.913,16.481,49.395-9.926,49.926c-10.699,0.212-18.516-10.301-15.255-21.738c3.997-14.026,15.532-38.507,22.211-46.305 C264.11,194.573,264.701,194.811,265.295,195.052z M275.642,240.017c-4.835-10.743-22.037-16.428-22.745-14.804 c-1.787,4.115-4.753,8.308-4.722,12.456C248.249,247.306,264.861,250.398,275.642,240.017z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.4673,
    y1: 262.38,
    x2: 261.4673,
    y2: 194.3336
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M262.561,198.959c-0.292,1.644-0.625,3.204-1.193,4.635c-0.838,2.111-1.558,4.572-0.547,6.824 c0.77,1.714,2.353,2.958,4.981,3.913c12.717,4.625,15.687,15.684,14.226,24.492c-1.743,10.512-10.378,21.291-23.508,21.555 c-0.093,0.002-0.186,0.003-0.278,0.003c-4.224,0-8.126-1.959-10.703-5.374c-2.883-3.82-3.725-8.856-2.31-13.818 C246.827,228.562,256.092,208.592,262.561,198.959 M260.153,248.486c6.086,0,12.237-2.562,16.876-7.029l1.015-0.977l-0.578-1.284 c-4.722-10.491-19.65-16.257-23.738-16.257c-1.759,0-2.424,0.924-2.666,1.477c-0.47,1.082-1.026,2.169-1.614,3.321 c-1.622,3.175-3.3,6.458-3.274,9.948C246.224,244.045,251.972,248.486,260.153,248.486 M263.516,194.334 c-6.679,7.798-18.214,32.279-22.211,46.305c-3.229,11.324,4.401,21.741,14.937,21.741c0.105,0,0.212-0.001,0.318-0.003 c26.406-0.53,37.184-40.013,9.926-49.926c-4.628-1.682-4.862-4.08-3.259-8.119c1.154-2.906,1.41-6.174,2.067-9.28 C264.701,194.811,264.11,194.573,263.516,194.334L263.516,194.334z M260.153,246.486c-6.588,0-11.936-3.359-11.979-8.817 c-0.031-4.148,2.935-8.34,4.722-12.456c0.08-0.184,0.371-0.274,0.831-0.274c3.609,0,17.626,5.549,21.914,15.077 C270.967,244.518,265.197,246.486,260.153,246.486L260.153,246.486z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 2080.7549,
    y1: 492.8247,
    x2: 2119.3606,
    y2: 492.8247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M2101.576,463.536c-4.161,8.669,0.719,11.468,6.794,15.469c12.703,8.362,14.547,25.809,4.731,35.47 c-15.91,15.649-35.425,4.668-31.938-9.779c3.69-15.292,13.992-35.887,18.389-41.077 C2100.227,463.593,2100.902,463.564,2101.576,463.536z M2093.819,487.424c-0.881,0.311-1.765,0.622-2.646,0.935 c-1.191,8.087-6.035,16.732,7.578,18.146c3.229,0.335,17.678-3.592,10.706-8.516 C2104.319,494.365,2099.041,490.935,2093.819,487.424z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 2100.0576,
    y1: 522.1139,
    x2: 2100.0576,
    y2: 463.5356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M2098.029,469.445c0.113,5.238,4.422,8.066,8.626,10.825l0.616,0.405c5.694,3.749,9.334,9.72,9.987,16.383 c0.597,6.097-1.429,11.926-5.559,15.99c-5.936,5.839-11.595,7.065-15.297,7.065c-4.581,0-8.671-1.858-11.222-5.097 c-2.196-2.789-2.932-6.288-2.072-9.852c1.387-5.749,3.696-12.172,6.25-18.206l-0.163,1.108c-0.196,1.329-0.506,2.722-0.806,4.069 c-0.95,4.266-1.934,8.677,0.5,12.057c1.727,2.398,4.885,3.805,9.657,4.301c0.189,0.02,0.405,0.031,0.644,0.031 c2.759,0,12.505-2.069,13.955-6.638c0.363-1.142,0.515-3.378-2.534-5.532c-3.661-2.582-7.443-5.1-11.1-7.535 c-1.527-1.016-3.053-2.033-4.575-3.056l-0.834-0.561l-0.948,0.335l-0.747,0.264c-0.634,0.224-1.269,0.448-1.903,0.673 l-1.107,0.394C2092.291,480.039,2095.496,473.717,2098.029,469.445 M2101.577,463.536c-0.675,0.028-1.349,0.057-2.024,0.083 c-4.397,5.19-14.699,25.786-18.389,41.077c-2.281,9.451,5.281,17.418,15.238,17.418c5.264,0,11.198-2.227,16.7-7.639 c9.816-9.661,7.972-27.108-4.731-35.47C2102.295,475.003,2097.415,472.204,2101.577,463.536L2101.577,463.536z M2099.189,506.525 c-0.162,0-0.309-0.007-0.438-0.02c-13.613-1.414-8.769-10.059-7.578-18.146c0.88-0.313,1.765-0.624,2.646-0.935 c5.222,3.511,10.5,6.94,15.638,10.565C2116.151,502.717,2103.098,506.525,2099.189,506.525L2099.189,506.525z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 2080.667,
    y1: 230.3788,
    x2: 2118.573,
    y2: 230.3788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M2099.132,203.311c-0.591,3.2-1.183,6.402-1.774,9.582c8.875,4.503,25.011,9.569,20.404,27.481 c-4.838,18.837-23.152,18.494-26.392,17.541c-20.857-6.149-6.942-27.07,5.572-55.423 C2097.674,202.766,2098.401,203.038,2099.132,203.311z M2110.592,238.652c-3.719-6.069-9.497-8.393-15.844-9.744 c-9.89-2.099-8.763,12.002-0.386,14.024C2100.359,244.378,2105.891,243.14,2110.592,238.652z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 2099.6201,
    y1: 258.2653,
    x2: 2099.6201,
    y2: 202.4924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M2095.942,209.563c-0.183,0.99-0.367,1.978-0.55,2.964l-0.274,1.472l1.335,0.677 c1.022,0.518,2.116,1.034,3.274,1.58c8.811,4.152,19.776,9.319,16.098,23.62c-3.906,15.207-17.081,16.389-21.026,16.389 c-1.539,0-2.525-0.169-2.863-0.269c-4.384-1.292-7.127-3.277-8.385-6.069c-1.94-4.301-0.461-10.741,2.557-18.472 c-0.159,0.495-0.273,1.022-0.34,1.578c-0.55,4.619,2.401,10.46,8.126,11.842c1.732,0.418,3.442,0.629,5.082,0.629 c4.867,0,9.24-1.819,12.997-5.407l1.168-1.115l-0.844-1.377c-4.377-7.143-11.455-9.447-17.134-10.656 c-0.8-0.17-1.575-0.256-2.304-0.256c-2.933,0-5.247,1.444-6.385,3.835c1.857-4.637,4.228-9.715,6.722-15.056 C2094.099,213.539,2095.018,211.572,2095.942,209.563 M2096.942,202.492c-12.514,28.352-26.429,49.274-5.572,55.423 c0.635,0.187,1.85,0.35,3.429,0.35c6.475,0,19.074-2.748,22.963-17.891c4.607-17.911-11.528-22.977-20.404-27.481 c0.591-3.18,1.183-6.382,1.774-9.582C2098.401,203.038,2097.674,202.766,2096.942,202.492L2096.942,202.492z M2098.975,243.506 c-1.501,0-3.042-0.195-4.613-0.574c-7.801-1.883-9.315-14.236-1.503-14.236c0.578,0,1.208,0.068,1.889,0.212 c6.347,1.352,12.125,3.675,15.844,9.744C2107.123,241.964,2103.202,243.506,2098.975,243.506L2098.975,243.506z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 2087.2764,
    y1: 904.6131,
    x2: 2115.7996,
    y2: 904.6131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M2113.636,920.056c2.339,7.302-0.797,12.729-5.055,17.552c-2.435,2.755-4.082,6.457-9.084,6.422 c-12.281-0.077-14.864-17.801-9.72-30.019c3.476-8.261,18.348-41.033,24.78-48.815c0.412,0.245,0.828,0.49,1.244,0.732 c-17.827,42.655-23.197,45.288-16.808,59c1.875,4.021,7.653,4.359,10.767,0.679 C2111.209,923.889,2112.353,921.913,2113.636,920.056z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 2101.5381,
    y1: 944.0302,
    x2: 2101.5381,
    y2: 865.196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M2104.262,887.434c-0.456,1.015-0.897,1.993-1.322,2.937c-8.841,19.621-10.942,24.283-5.76,35.401 c1.264,2.711,4,4.395,7.142,4.395c2.668,0,5.206-1.192,6.966-3.271c0.4-0.473,0.775-0.96,1.134-1.454 c-0.181,4.305-2.602,7.742-5.338,10.841c-0.519,0.587-0.993,1.199-1.452,1.79c-1.903,2.453-3.214,3.957-6.064,3.957l-0.058,0 c-3.126-0.019-5.622-1.41-7.418-4.133c-3.549-5.382-3.752-15.317-0.471-23.11C2093.97,909.201,2099.098,897.874,2104.262,887.434  M2114.556,865.196c-6.431,7.782-21.304,40.554-24.78,48.815c-5.144,12.218-2.561,29.942,9.72,30.019c0.024,0,0.047,0,0.07,0 c4.947,0,6.591-3.68,9.014-6.422c4.258-4.823,7.394-10.25,5.055-17.552c-1.283,1.857-2.427,3.833-3.877,5.55 c-1.455,1.719-3.49,2.561-5.438,2.561c-2.222,0-4.33-1.097-5.329-3.24c-6.389-13.712-1.02-16.344,16.808-58.999 C2115.384,865.686,2114.968,865.441,2114.556,865.196L2114.556,865.196z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 2365.6064,
    y1: 325.0252,
    x2: 2391.4358,
    y2: 325.0252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M2390.941,290.711c-14.834,33.615-15.066,33.437-16.098,37.851c-1.108,4.751,0.391,14.79,6.759,15.376 c4.079,0.378,8.312-8.735,8.862-9.735c2.532,7.493-0.346,12.453-3.338,17.359c-0.447,0.732-1.38,1.156-1.84,1.883 c-2.422,3.85-5.068,8.257-10.272,6.649c-22.589-6.967,1.302-47.973,11.42-67.885c0.512-1.012,1.586-1.737,2.396-2.594 C2389.535,289.98,2390.236,290.345,2390.941,290.711z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 2378.521,
    y1: 360.4344,
    x2: 2378.521,
    y2: 289.6161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M2384.597,300.112c-1.603,3.617-2.965,6.682-4.126,9.295c-6.376,14.349-6.758,15.208-7.575,18.701 c-0.927,3.978-0.229,10.388,2.543,14.23c1.537,2.131,3.605,3.372,5.979,3.591c0.144,0.013,0.289,0.02,0.433,0.02 c2.953,0,5.524-2.719,7.583-5.861c-0.094,4.003-2.015,7.152-4.014,10.43c-0.061,0.094-0.325,0.314-0.5,0.459 c-0.413,0.344-0.928,0.772-1.327,1.403l-0.141,0.225c-2.213,3.521-3.849,5.83-6.326,5.83c-0.47,0-0.982-0.084-1.522-0.251 c-3.427-1.057-5.686-2.991-6.906-5.912C2363.81,340.578,2376.028,316.587,2384.597,300.112 M2388.83,289.616 c-0.811,0.856-1.884,1.582-2.396,2.594c-10.118,19.912-34.009,60.918-11.42,67.885c0.756,0.233,1.457,0.34,2.112,0.34 c3.855,0,6.09-3.698,8.16-6.989c0.46-0.727,1.393-1.152,1.84-1.883c2.992-4.906,5.87-9.867,3.338-17.359 c-0.539,0.981-4.612,9.747-8.613,9.747c-0.083,0-0.166-0.004-0.248-0.011c-6.368-0.586-7.866-10.624-6.759-15.376 c1.032-4.413,1.264-4.235,16.098-37.851C2390.236,290.345,2389.535,289.98,2388.83,289.616L2388.83,289.616z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 1239.0161,
    y1: 156.9645,
    x2: 1358.7928,
    y2: 156.9645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M1358.793,134.009c-7.865,8.317,7.621-1.332-56.043,22.557c-26.536,9.958-46.637,19.048-63.568,25.005 c-0.751-3.594,1.132-5.585,4.052-6.825c5.271-2.238,53.457-23.978,114.346-42.389 C1357.987,132.908,1358.39,133.46,1358.793,134.009z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 1298.9044,
    y1: 181.5714,
    x2: 1298.9044,
    y2: 132.3576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M1355.132,135.193c-0.083,0.107-0.161,0.207-0.235,0.303c-0.875,1.129-0.875,1.129-5.528,2.588 c-6.037,1.893-18.599,5.831-47.321,16.609c-12.973,4.868-24.503,9.567-34.675,13.713c-9.691,3.949-18.202,7.418-26.053,10.276 c0.395-0.772,1.213-1.464,2.697-2.094c0.426-0.181,1.131-0.489,2.099-0.911C1290.727,156.208,1329.543,143.033,1355.132,135.193  M1357.579,132.358c-60.889,18.411-109.075,40.151-114.346,42.389c-2.92,1.24-4.803,3.231-4.052,6.825 c16.932-5.957,37.032-15.047,63.568-25.005c63.664-23.889,48.178-14.24,56.043-22.557 C1358.39,133.46,1357.987,132.908,1357.579,132.358L1357.579,132.358z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 1441.193,
    y1: 447.5063,
    x2: 1486.422,
    y2: 447.5063
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M1464.776,448.668c-6.615,11.836-6.711,14.635-11.279,11.571c-10.036-6.736-15.254-6.756-10.566-13.936 c5.861-8.971,5.861-8.971,15.336-3.419c5.887,3.452,5.887,3.452,8.87-2.801c3.736-7.837,4.354-8.014,11.678-3.36 c9.462,6.01,9.212,5.879,4.07,15.724C1479.773,458.415,1478.04,456.077,1464.776,448.668z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 1463.8075,
    y1: 461.3887,
    x2: 1463.8075,
    y2: 433.6239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M1472.327,435.624L1472.327,435.624c1.03,0,3.565,1.611,5.416,2.787c3.783,2.403,6.283,3.991,6.627,5.158 c0.325,1.103-0.952,3.545-2.885,7.24l-0.372,0.712c-1.205,2.31-1.715,2.31-1.989,2.31c-1.317,0-4.203-1.663-8.198-3.964 c-1.504-0.866-3.208-1.848-5.173-2.945l-0.49-0.274c1.385-0.891,2.315-2.841,3.681-5.705 C1470.013,438.699,1471.479,435.624,1472.327,435.624 M1449.953,441.071c1.264,0,3.666,1.407,7.302,3.538 c2.849,1.67,4.418,2.59,6.018,2.59c0.011,0,0.021,0,0.032,0l-0.276,0.493c-1.225,2.191-2.206,4.035-3.073,5.662 c-1.516,2.848-3.084,5.792-3.747,6.034c-0.065,0-0.45-0.039-1.6-0.81c-2.393-1.606-4.547-2.856-6.277-3.86 c-2.72-1.578-4.869-2.825-5.112-3.849c-0.108-0.453,0.045-1.423,1.384-3.473C1447.472,443.011,1448.788,441.071,1449.953,441.071  M1472.327,433.624c-1.935,0-3.052,1.977-5.189,6.459c-1.712,3.588-2.441,5.117-3.864,5.117c-1.057,0-2.497-0.844-5.006-2.315 c-4.172-2.445-6.507-3.813-8.314-3.813c-2.297,0-3.742,2.211-7.022,7.232c-4.688,7.18,0.53,7.2,10.566,13.936 c1.12,0.751,1.97,1.15,2.714,1.15c2.292,0,3.571-3.785,8.565-12.72c8.109,4.529,11.907,7.163,14.347,7.163 c1.551,0,2.552-1.065,3.762-3.385c5.142-9.845,5.392-9.713-4.07-15.724C1475.681,434.731,1473.775,433.624,1472.327,433.624 L1472.327,433.624z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.1202,
    y1: 506.7293,
    x2: 250.9563,
    y2: 506.7293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M246.139,476.427c-0.23,0.575-12.344,30.735-12.344,30.735c-2.745,8.215,8.217,21.604,13.571,8.161 c0.598-1.5,1.441-2.907,2.385-4.773c4.332,8.549-3.774,25.717-12.254,27.036c-8.998,1.403-25.286-13.895,5.789-61.363 c0.162-0.243,0.618-0.296,0.935-0.438C244.861,476,245.5,476.212,246.139,476.427z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.0381,
    y1: 537.6735,
    x2: 238.0381,
    y2: 475.7851
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M241.296,483.121c-3.654,9.098-9.356,23.295-9.356,23.295l-0.022,0.055l-0.019,0.056 c-1.23,3.681-0.297,8.458,2.376,12.17c1.989,2.761,4.592,4.345,7.143,4.345c2.2,0,5.249-1.114,7.521-6.298 c-0.092,3.141-1.069,6.798-2.845,10.262c-2.48,4.838-5.892,8.134-8.906,8.603c-0.27,0.042-0.552,0.063-0.838,0.063 c-2.194,0-5.249-1.314-7.243-5.001C226.668,526.157,223.293,512.785,241.296,483.121 M244.221,475.785 c-0.318,0.143-0.773,0.195-0.935,0.438c-29.794,45.512-16.048,61.45-6.935,61.45c0.392,0,0.775-0.029,1.146-0.087 c8.48-1.319,16.586-18.488,12.254-27.036c-0.944,1.866-1.787,3.272-2.385,4.773c-1.641,4.121-3.809,5.72-5.948,5.72 c-4.838,0-9.526-8.185-7.622-13.881c0,0,12.114-30.16,12.344-30.735C245.5,476.212,244.861,476,244.221,475.785L244.221,475.785z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 1268.905,
    y1: 368.852,
    x2: 1313.1355,
    y2: 368.852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M1304.796,379.314c-12.636-6.529-15.32-9.303-17.725-3.962c-2.076,4.612-4.426,6.744-9.127,2.479 c-2.775-2.519-7.966-3.686-8.914-6.516c-0.834-2.49,2.727-6.448,4.339-9.762c2.212-4.551,5.062-2.834,9.396-0.492 c14.637,7.904,7.537-8.883,20.938-1.625C1315.974,366.085,1316.202,369.738,1304.796,379.314z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 1291.0203,
    y1: 380.1365,
    x2: 1291.0203,
    y2: 357.5674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M1298.083,357.567v2c1.104,0,2.675,0.547,4.667,1.626c5.602,3.035,8.184,5.222,8.373,7.09 c0.234,2.306-3.207,5.714-6.598,8.635c-1.604-0.84-3.035-1.609-4.327-2.304c-4.892-2.631-7.587-4.08-9.914-4.08 c-3.238,0-4.545,2.903-5.037,3.996c-1.077,2.393-2.046,3.606-2.879,3.606c-0.415,0-1.366-0.232-3.08-1.787 c-1.304-1.184-2.929-2.04-4.501-2.868c-1.664-0.877-3.549-1.871-3.861-2.802c-0.276-0.825,1.322-3.363,2.277-4.879 c0.698-1.108,1.42-2.254,1.964-3.373c0.839-1.725,1.453-1.725,1.715-1.725c1.02,0,2.735,0.929,4.552,1.913l0.379,0.205 c3.003,1.621,5.438,2.41,7.444,2.41c3.385,0,4.985-2.133,6.153-3.691c1.095-1.46,1.576-1.971,2.671-1.972L1298.083,357.567  M1298.082,357.567c-4.448,0.001-4.119,5.663-8.823,5.663c-1.525,0-3.578-0.595-6.494-2.169c-2.353-1.271-4.268-2.358-5.882-2.358 c-1.358,0-2.503,0.771-3.514,2.851c-1.612,3.314-5.173,7.271-4.339,9.762c0.948,2.83,6.139,3.997,8.914,6.516 c1.772,1.607,3.209,2.306,4.424,2.306c2.009,0,3.409-1.911,4.703-4.785c0.877-1.949,1.792-2.817,3.213-2.817 c2.475,0,6.486,2.632,14.512,6.779c11.407-9.576,11.179-13.229-1.093-19.878C1301.21,358.085,1299.427,357.567,1298.082,357.567 L1298.082,357.567z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 1956.1256,
    y1: 163.2847,
    x2: 1979.3406,
    y2: 163.2847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M1976.034,132.52c-10.975,30.238-16.834,37.925-4.748,46.187c2.155-2.534,4.35-5.121,6.658-7.839 c6.137,13.765-9.459,32.174-17.596,19.999c-10.862-16.263,1.228-40.046,13.737-59.14 C1974.734,131.99,1975.382,132.255,1976.034,132.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 1967.733,
    y1: 194.8425,
    x2: 1967.733,
    y2: 131.7269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M1970.945,140.474c-0.567,1.497-1.112,2.925-1.632,4.288c-7.495,19.644-10.597,27.775,0.844,35.596 l1.486,1.016l1.166-1.371c1.412-1.66,2.841-3.343,4.307-5.07c0.847,4.701-0.717,9.374-2.765,12.529 c-2.154,3.319-5.059,5.381-7.581,5.381c-1.79,0-3.391-1.039-4.76-3.087C1952.886,176.093,1961.4,156.399,1970.945,140.474  M1974.085,131.727c-12.509,19.094-24.599,42.877-13.737,59.14c1.866,2.793,4.124,3.976,6.423,3.976 c7.724,0,15.902-13.367,11.173-23.974c-2.308,2.718-4.503,5.305-6.658,7.839c-12.086-8.262-6.227-15.949,4.748-46.187 C1975.382,132.255,1974.733,131.99,1974.085,131.727L1974.085,131.727z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 1173.5612,
    y1: 446.0577,
    x2: 1216.0328,
    y2: 446.0577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M1194.699,443.681c3.636-5.864,5.502-10.746,6.84-10.513c3.453,0.601,16.479,5.553,14.236,10.202 c-1.894,3.936-4.284,7.635-6.518,11.474c-3.331-1.413-6.818-2.18-9.398-4.14c-4.573-3.474-6.564-1.047-8.395,2.711 c-3.327,6.823-3.307,6.833-10.134,2.793c-9.374-5.55-9.352-5.539-4.748-15.152C1179.901,434.13,1182.211,437.285,1194.699,443.681 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 1194.797,
    y1: 458.9553,
    x2: 1194.797,
    y2: 433.1602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M1201.859,435.28c3.374,0.825,10.7,3.944,12.035,6.543c0.209,0.408,0.134,0.564,0.078,0.68 c-1.337,2.778-2.912,5.407-4.578,8.19c-0.331,0.552-0.662,1.106-0.992,1.661c-0.555-0.208-1.104-0.404-1.645-0.598 c-2.144-0.767-4.17-1.491-5.688-2.644c-1.846-1.402-3.502-2.084-5.063-2.084c0,0,0,0-0.001,0c-3.654,0-5.468,3.723-6.339,5.511 l-0.028,0.058c-0.967,1.983-1.966,4.033-2.467,4.357c-0.683-0.016-2.602-1.152-4.823-2.467c-3.828-2.266-6.357-3.764-6.724-4.922 c-0.359-1.132,0.87-3.697,2.729-7.58l0.031-0.064c1.33-2.776,2.009-2.776,2.373-2.776c1.308,0,3.784,1.35,7.211,3.218 c1.673,0.912,3.568,1.945,5.818,3.098l1.64,0.84l0.971-1.566c1.312-2.116,2.412-4.133,3.297-5.753 C1200.469,437.565,1201.329,435.99,1201.859,435.28 M1201.446,433.16c-1.332,0-3.195,4.792-6.747,10.521 c-7.531-3.857-11.359-6.536-13.941-6.536c-1.699,0-2.859,1.161-4.176,3.911c-4.604,9.613-4.625,9.602,4.748,15.152 c2.966,1.755,4.639,2.746,5.856,2.746c1.585,0,2.396-1.68,4.278-5.539c1.211-2.485,2.491-4.388,4.542-4.388 c1.051,0,2.304,0.5,3.853,1.676c2.58,1.96,6.067,2.727,9.398,4.14c2.234-3.84,4.624-7.539,6.518-11.474 c2.242-4.649-10.784-9.601-14.236-10.202C1201.508,433.163,1201.477,433.16,1201.446,433.16L1201.446,433.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 555.5634,
    y1: 908.1884,
    x2: 580.3825,
    y2: 908.1884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M576.281,878.631c-2.821,7.05-10.019,24.081-11.466,31.806c-1.073,5.74,3.161,17.491,10.715,11.415 c1.643-1.318,3.093-2.878,4.783-4.472c0.87,6.286-6.645,18.963-12.037,20.776c-4.431,1.489-10.885-2.51-11.891-8.143 c-2.002-11.211-1.696-9.233,16.875-50.756c0.25-0.556,0.972-0.902,1.476-1.349C575.252,878.149,575.766,878.39,576.281,878.631z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.9729,
    y1: 938.4691,
    x2: 567.9729,
    y2: 877.9075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M564.857,902.778c-0.919,2.799-1.64,5.327-2.007,7.291c-0.662,3.54,0.357,9.252,3.208,12.685 c1.519,1.829,3.395,2.795,5.426,2.795c1.752,0,3.535-0.72,5.298-2.138c0.275-0.221,0.542-0.445,0.805-0.674 c-1.902,5.688-6.758,12.449-9.948,13.522c-0.413,0.139-0.872,0.209-1.363,0.209c-3.165,0-7.226-2.911-7.921-6.808l-0.011-0.061 C556.921,921.635,556.769,920.789,564.857,902.778 M574.737,877.907c-0.504,0.447-1.226,0.793-1.476,1.349 c-18.571,41.523-18.877,39.545-16.875,50.756c0.862,4.828,5.727,8.456,9.89,8.456c0.694,0,1.368-0.101,2.001-0.313 c5.393-1.813,12.907-14.49,12.037-20.776c-1.691,1.594-3.141,3.154-4.783,4.472c-1.482,1.192-2.835,1.698-4.046,1.698 c-4.963,0-7.531-8.499-6.668-13.113c1.446-7.725,8.645-24.756,11.466-31.806C575.766,878.39,575.252,878.149,574.737,877.907 L574.737,877.907z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 1810.9637,
    y1: 595.1158,
    x2: 1835.6383,
    y2: 595.1158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M1832.169,563.452c-13.86,33.137-15.39,36.924-8.476,46.87c4.131,5.945,8.822-3.96,10.193-6.308 c0.583,0.228,1.165,0.451,1.752,0.679c-1.686,4.744-2.996,9.663-5.143,14.193c-7.953,16.784-19.502,6.258-19.532-6.47 c-0.033-12.125,16.25-45.856,19.589-49.757C1831.092,562.927,1831.63,563.19,1832.169,563.452z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 1823.301,
    y1: 627.5722,
    x2: 1823.301,
    y2: 562.6594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M1820.38,587.466c-4.277,12.31-3.429,16.661,1.67,23.998c1.568,2.257,3.296,2.731,4.47,2.731 c1.752,0,3.309-1.027,4.642-2.429c-0.733,2.139-1.527,4.266-2.474,6.264c-2.305,4.864-5.053,7.542-7.74,7.542 c-4.163,0-7.968-6.273-7.984-13.161C1812.949,607.113,1816.379,597.071,1820.38,587.466 M1830.552,562.659 c-3.339,3.901-19.622,37.632-19.589,49.757c0.019,8.014,4.604,15.156,9.984,15.156c3.164,0,6.603-2.471,9.548-8.686 c2.147-4.529,3.457-9.449,5.143-14.193c-0.587-0.228-1.169-0.451-1.752-0.679c-1.063,1.82-4.12,8.18-7.366,8.18 c-0.941,0-1.899-0.535-2.828-1.872c-6.913-9.946-5.383-13.733,8.476-46.87C1831.63,563.19,1831.092,562.927,1830.552,562.659 L1830.552,562.659z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 474.684,
    y1: 107.8411,
    x2: 497.1642,
    y2: 107.8411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M491.109,80.4c-4.328,12.061-7.828,16.353-6.888,33.67c0.081,1.522,2.871,3.443,4.785,4.076 c1.239,0.409,6.638-6.289,7.736-7.563c1.767,9.965-2.21,17.237-8.305,23.47c-4.146,4.237-14.919-2.713-13.649-17.25 C476.143,101.196,484.916,82.557,491.109,80.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.9241,
    y1: 135.2823,
    x2: 485.9241,
    y2: 80.3999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M485.497,89.456c-2.405,6.442-3.937,12.496-3.273,24.72c0.156,2.948,4.214,5.227,6.156,5.869 c0.239,0.079,0.49,0.119,0.747,0.119c1.248,0,2.555-0.749,6.043-4.671c-0.063,6.121-2.683,11.559-8.162,17.162 c-0.408,0.417-0.954,0.628-1.623,0.628c-1.481,0-3.264-0.981-4.77-2.624c-2.918-3.184-4.315-8.17-3.834-13.682 C477.669,106.734,481.572,96.212,485.497,89.456 M491.109,80.4c-6.193,2.157-14.966,20.796-16.322,36.403 c-1.021,11.695,5.751,18.479,10.597,18.479c1.178,0,2.242-0.401,3.052-1.229c6.095-6.234,10.073-13.505,8.305-23.47 c-1.065,1.236-6.182,7.581-7.616,7.581c-0.044,0-0.084-0.006-0.12-0.018c-1.914-0.633-4.704-2.554-4.785-4.076 C483.28,96.753,486.781,92.461,491.109,80.4L491.109,80.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 1908.3362,
    y1: 430.9917,
    x2: 1931.9896,
    y2: 430.9917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M1931.99,435.88c-3.46,10.572-5.797,24.877-16.146,22.513c-20.631-4.706,7.427-48.681,10.921-55.062 c0.714,0.372,1.428,0.745,2.142,1.117c-2.269,4.586-8.719,16.187-11.783,27.945c-0.823,3.167,2.058,14.921,10.509,6.81 c1.038-0.999,1.433-2.668,2.116-4.039C1930.496,435.402,1931.241,435.641,1931.99,435.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 1920.163,
    y1: 458.6522,
    x2: 1920.163,
    y2: 403.3312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M1917.543,424.416c-0.89,2.441-1.7,4.955-2.356,7.474c-0.608,2.341,0.173,6.835,2.266,9.541 c1.303,1.684,2.992,2.574,4.885,2.574c1.87,0,3.848-0.889,5.893-2.646c-2.3,7.716-4.815,15.292-10.21,15.292 c-0.542,0-1.125-0.07-1.732-0.209c-2.558-0.584-4.238-1.874-5.136-3.946C1908.462,446.285,1912.621,434.69,1917.543,424.416  M1926.764,403.331c-3.494,6.38-31.551,50.355-10.921,55.062c0.769,0.176,1.493,0.259,2.177,0.259 c8.524,0,10.766-12.987,13.969-22.773c-0.749-0.239-1.494-0.477-2.243-0.716c-0.683,1.371-1.078,3.04-2.116,4.039 c-2.099,2.014-3.853,2.803-5.294,2.803c-4.359,0-5.834-7.232-5.215-9.613c3.065-11.758,9.514-23.359,11.783-27.945 C1928.192,404.076,1927.478,403.704,1926.764,403.331L1926.764,403.331z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.9243,
    y1: 867.2245,
    x2: 220.458,
    y2: 867.2245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M220.177,872.178c2.281,16.581-9.943,24.754-13.752,22.117c-13.179-9.123-8.451-22.593-2.994-36.611 c7.404-19.019,8.574-17.776,10.588-18.017c-6.101,15.115-16.776,33.441-1.568,39.195c1.191,0.451,3.798-2.672,5.677-4.271 C218.922,873.917,219.5,872.989,220.177,872.178z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.1912,
    y1: 894.782,
    x2: 209.1912,
    y2: 839.6671
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M202.832,865.047c-0.38,3.106-0.181,5.998,0.899,8.549c1.374,3.245,4.069,5.646,8.01,7.137 c0.304,0.115,0.629,0.174,0.963,0.174c1.717,0,3.316-1.549,5.168-3.344c0.197-0.191,0.39-0.378,0.578-0.557 c-0.196,6.294-2.746,10.258-4.466,12.231c-2.135,2.449-4.453,3.545-5.803,3.545c-0.272,0-0.497-0.048-0.618-0.131 C197.899,885.96,198.772,876.843,202.832,865.047 M214.018,839.667c-2.013,0.24-3.183-1.002-10.588,18.016 c-5.457,14.019-10.185,27.488,2.994,36.611c0.471,0.326,1.071,0.487,1.756,0.487c4.855,0,13.994-8.074,11.996-22.604 c-0.676,0.811-1.255,1.739-2.05,2.414c-1.755,1.493-4.143,4.315-5.422,4.315c-0.091,0-0.176-0.014-0.255-0.044 C197.242,873.108,207.917,854.783,214.018,839.667L214.018,839.667z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.4817,
    y1: 100.9762,
    x2: 265.8818,
    y2: 100.9762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M262.428,72.892c-10.506,33.882-16.969,33.104-5.614,39.897c4.771,2.856,7.191-4.329,9.063-5.346 c0.094,7.407-1.356,14.455-6.292,20.178c-3.331,3.861-10.502,1.323-13.146-4.032c-5.971-12.101,2.692-26.182,12.832-48.288 c0.486-1.058,1.452-1.892,2.195-2.829C261.786,72.611,262.106,72.752,262.428,72.892z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.1817,
    y1: 129.4811,
    x2: 255.1817,
    y2: 72.4713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M252.94,93.531c-0.294,0.728-0.575,1.421-0.844,2.083c-4.405,10.844-5.451,13.421,3.691,18.89 c1.053,0.63,2.127,0.95,3.191,0.95c1.914,0,3.399-0.971,4.596-2.184c-0.674,5.301-2.472,9.527-5.504,13.043 c-0.668,0.774-1.603,1.167-2.777,1.167c-2.681,0-5.716-2.054-7.061-4.778C244.366,114.865,247.299,105.91,252.94,93.531  M261.466,72.471c-0.742,0.937-1.709,1.772-2.195,2.829c-10.14,22.105-18.803,36.186-12.832,48.288 c1.764,3.574,5.545,5.893,8.855,5.893c1.65,0,3.183-0.576,4.291-1.861c4.937-5.723,6.386-12.771,6.292-20.178 c-1.565,0.85-3.513,6.013-6.899,6.013c-0.664,0-1.382-0.198-2.164-0.666c-11.356-6.793-4.893-6.015,5.614-39.897 C262.106,72.752,261.786,72.611,261.466,72.471L261.466,72.471z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 2100.1443,
    y1: 102.6345,
    x2: 2119.28,
    y2: 102.6345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M2116.728,77.36c-6.053,14.929-9.762,19.696-7.096,30.422c1.574,6.327,12.077,1.338,9.129,8.579 c-10.608,26.069-24.055,4.911-16.326-14.269c2.817-6.989,6.168-13.776,9.519-20.535c0.906-1.82,2.677-3.211,4.052-4.797 C2116.246,76.959,2116.487,77.158,2116.728,77.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 2109.7122,
    y1: 128.5094,
    x2: 2109.7122,
    y2: 76.7595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M2107.481,95.443c-0.966,3.963-1.035,7.812,0.21,12.821c1.052,4.225,4.864,4.902,7.387,5.349 c0.748,0.133,1.859,0.33,2.201,0.558c0.007,0.14-0.014,0.56-0.371,1.435c-4.117,10.117-7.805,10.903-8.837,10.903 c-1.479,0-2.633-1.248-3.339-2.295c-2.818-4.174-3.875-12.857-0.442-21.376C2105.289,100.362,2106.368,97.884,2107.481,95.443  M2116.006,76.759c-1.375,1.586-3.145,2.977-4.052,4.797c-3.351,6.759-6.702,13.546-9.519,20.535 c-5.147,12.77-0.905,26.418,5.636,26.418c3.283,0,7.145-3.438,10.689-12.149c2.948-7.241-7.554-2.252-9.129-8.579 c-2.666-10.726,1.043-15.492,7.096-30.422C2116.487,77.158,2116.247,76.959,2116.006,76.759L2116.006,76.759z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 1128.3073,
    y1: 295.0591,
    x2: 1162.891,
    y2: 295.0591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M1128.307,312.018c16.712-14.765,18.245-14.583,17.289-20.259c-0.554-3.305-0.095-14.904,5.349-15.156 c7.493-0.344,14.368,10.044,11.12,16.645c-0.561,1.137-2.396,2.567-3.412,2.407c-5.737-0.9-4.087,0.461-29.283,17.87 C1129.015,313.023,1128.662,312.521,1128.307,312.018z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 1145.5991,
    y1: 313.5244,
    x2: 1145.5991,
    y2: 276.5939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M1151.31,278.594L1151.31,278.594c2.768,0,5.822,2.033,7.78,5.179c1.863,2.993,2.315,6.285,1.181,8.59 c-0.221,0.449-1.057,1.136-1.479,1.289c-0.716-0.11-1.472-0.205-2.203-0.205c-2.947,0-4.785,1.365-10.876,5.886 c-0.215,0.16-0.437,0.324-0.665,0.494c2.767-2.946,3.13-4.782,2.521-8.4c-0.381-2.273-0.141-9.286,2.033-11.98 c0.587-0.727,1.1-0.832,1.434-0.847C1151.128,278.596,1151.219,278.594,1151.31,278.594 M1151.309,276.594 c-0.121,0-0.243,0.003-0.364,0.008c-5.444,0.252-5.903,11.851-5.349,15.156c0.956,5.676-0.577,5.494-17.289,20.259 c0.355,0.504,0.708,1.005,1.063,1.507c21.679-14.979,23.483-18.077,27.219-18.077c0.606,0,1.263,0.082,2.064,0.207 c0.053,0.008,0.108,0.012,0.165,0.012c1.039,0,2.716-1.342,3.247-2.419C1165.26,286.753,1158.658,276.593,1151.309,276.594 L1151.309,276.594z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 2265.7307,
    y1: 143.7003,
    x2: 2286.3865,
    y2: 143.7003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M2281.997,121.628c-14.889,30.045-9.972,27.838-5.656,33.558c8.407-6.64,6.028-4.197,7.771-9.545 c10.39,14.347-18.177,33.011-18.38,10.18c-0.111-12.222,7.523-25.202,14.828-34.94 C2281.042,121.131,2281.519,121.381,2281.997,121.628z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 2276.0586,
    y1: 166.5193,
    x2: 2276.0586,
    y2: 120.8814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M2272.66,137.23c-4.444,11.315-2.851,13.833,0.454,17.303c0.541,0.568,1.1,1.155,1.631,1.858l1.232,1.632 l1.604-1.267c1.077-0.85,1.976-1.551,2.729-2.138c2.21-1.723,3.335-2.6,4-3.463c0.334,2.362-0.344,4.498-1.166,6.106 c-2.078,4.07-6.504,7.259-10.076,7.259c-4.576,0-5.308-5.461-5.337-8.716C2267.681,150.228,2269.333,144.016,2272.66,137.23  M2280.56,120.881c-7.304,9.738-14.939,22.717-14.828,34.94c0.069,7.724,3.383,10.698,7.337,10.698 c7.735,0,17.918-11.385,11.043-20.878c-1.743,5.347,0.635,2.905-7.771,9.545c-4.316-5.72-9.234-3.513,5.655-33.558 C2281.519,121.381,2281.042,121.131,2280.56,120.881L2280.56,120.881z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 1309.985,
    y1: 165.4785,
    x2: 1367.2076,
    y2: 165.4785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M1367.208,153.909c-7.38,6.529,5.557,1.09-55.841,24.519c-0.278,0.105-0.672-0.096-1.358-0.212 c-0.44-6.555,5.46-7.447,9.201-8.976c5.94-2.431,39.035-15.418,47.135-16.742C1366.63,152.968,1366.918,153.439,1367.208,153.909z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 1338.5963,
    y1: 178.458,
    x2: 1338.5963,
    y2: 152.4989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M1362.987,155.364c-1.738,1.914-3.286,2.528-32.985,13.827c-5.08,1.933-10.973,4.174-17.814,6.784 c0.644-2.21,2.787-3.089,5.882-4.18c0.634-0.223,1.289-0.454,1.898-0.703C1326.512,168.413,1351.873,158.538,1362.987,155.364  M1366.345,152.499c-8.1,1.323-41.196,14.311-47.135,16.742c-3.741,1.529-9.641,2.42-9.201,8.976 c0.551,0.093,0.914,0.242,1.18,0.242c0.065,0,0.124-0.009,0.179-0.03c61.398-23.43,48.462-17.99,55.841-24.519 C1366.918,153.439,1366.63,152.968,1366.345,152.499L1366.345,152.499z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 1250.1768,
    y1: 237.7775,
    x2: 1300.5707,
    y2: 237.7775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M1250.177,248.097c4.33-5.718-5.888-1.106,48.957-21.569c0.478,0.659,0.957,1.318,1.437,1.978 c-4.524,5.326,2.462,2.739-43.602,19.153c-1.921,0.686-4.002,0.924-6.007,1.369 C1250.698,248.717,1250.437,248.408,1250.177,248.097z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 1275.3737,
    y1: 249.0275,
    x2: 1275.3737,
    y2: 226.5276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M1297.478,229.28c-1.704,2.395-2.616,2.755-37.754,15.274l-3.428,1.221 c-0.872,0.311-1.805,0.523-2.785,0.716c0.961-1.246,3.834-2.338,23.802-9.728C1282.72,234.762,1289.346,232.31,1297.478,229.28  M1299.134,226.528c-54.845,20.463-44.627,15.851-48.957,21.569c0.261,0.311,0.521,0.62,0.784,0.931 c2.006-0.445,4.087-0.683,6.008-1.369c46.065-16.414,39.078-13.827,43.602-19.153 C1300.091,227.846,1299.612,227.187,1299.134,226.528L1299.134,226.528z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 1135.7346,
    y1: 367.9593,
    x2: 1157.7347,
    y2: 367.9593
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M1153.436,356.801c2.582,5.67,7.158,11.371,1.836,17.556c-1.292,1.503-5.11,0.83-7.767,1.159 c-0.177-0.549-0.353-1.099-0.53-1.649c-1.223,1.385-7.314,9.954-9.457,1.728c-1.128-4.319-3.664-8.713,0.598-13.978 c1.09,3.938,1.993,7.195,3,10.83c8.38-3.379-0.574-11.2,4.974-15.064c1.594,3.776,3.134,7.429,4.676,11.081 c0.442-0.165,0.885-0.329,1.329-0.493c-0.195-3.632-0.388-7.263-0.583-10.892C1152.154,356.985,1152.794,356.893,1153.436,356.801 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 1146.7346,
    y1: 379.1179,
    x2: 1146.7346,
    y2: 356.8007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1153.778,361.983c2.16,4.394,3.047,7.502-0.007,11.054c-0.428,0.354-2.448,0.363-3.533,0.367 c-0.432,0.002-0.87,0.004-1.306,0.015l-0.053-0.166l-1.077-3.344l-2.326,2.634c-0.125,0.142-0.298,0.352-0.508,0.61 c-2.817,3.451-4.035,3.966-4.51,3.966c-0.078,0-0.568-0.352-1.005-2.029c-0.197-0.754-0.431-1.501-0.658-2.224 c-0.581-1.851-1.098-3.501-1.066-5.155l1.46,5.271l0.598,2.158l2.077-0.838c6.085-2.454,5.208-7.204,4.627-10.347 c-0.054-0.293-0.103-0.568-0.147-0.826l0.216,0.513l2.363,5.6l0.745,1.764l1.795-0.668l1.324-0.491l1.384-0.511l-0.079-1.473 L1153.778,361.983 M1153.436,356.801c-0.642,0.092-1.281,0.184-1.923,0.278c0.195,3.629,0.387,7.26,0.583,10.892 c-0.445,0.164-0.887,0.328-1.33,0.493c-1.542-3.651-3.082-7.305-4.676-11.081c-5.548,3.864,3.406,11.685-4.974,15.064 c-1.007-3.636-1.91-6.892-3-10.83c-4.262,5.265-1.726,9.659-0.598,13.978c0.678,2.602,1.751,3.523,2.94,3.523 c2.57,0,5.682-4.305,6.518-5.252c0.177,0.55,0.353,1.1,0.53,1.649c2.657-0.328,6.474,0.344,7.767-1.159 C1160.593,368.172,1156.018,362.471,1153.436,356.801L1153.436,356.801z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 1338.0524,
    y1: 186.9123,
    x2: 1359.877,
    y2: 186.9123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M1348.972,195.657c-2.606,0.782-5.211,1.564-7.815,2.345c-4.236-15.465-3.766-10.848-0.823-16.928 c1.91,8.671,0.817,5.869,4.277,10.364c3.021-5.205,2.742-1.15,1.982-14.713c5.151,4.183,2.188,11.538,9.111,12.802 c-0.525-4.4-0.999-8.325-1.643-13.704c6.146,5.406,7.315,13.161,4.004,18.253C1355.818,197.536,1355.201,197.565,1348.972,195.657 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 1348.9646,
    y1: 198.0023,
    x2: 1348.9646,
    y2: 175.8223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M1356.943,183.05c0.922,2.242,1.132,4.494,0.778,6.491l-0.03-0.251L1356.943,183.05 M1349.09,186.301 c0.919,2.31,2.502,4.508,6.255,5.193l1.687,0.308c-0.187,0.416-0.402,0.812-0.643,1.184c-1.259,1.939-1.498,1.939-1.973,1.939 c-0.929,0-2.674-0.512-4.858-1.181l-0.58-0.178l-0.581,0.174l-3.403,1.021l1.347-2.32c0.56-0.965,0.995-1.583,1.344-2.079 C1348.691,188.935,1349.055,188.198,1349.09,186.301 M1341.051,190.214c0.148,0.187,0.312,0.388,0.497,0.609 c0.377,0.452,0.847,1.015,1.479,1.835l1.685,2.189l-2.171,0.652c-0.412-1.48-0.77-2.743-1.077-3.827 C1341.315,191.146,1341.177,190.661,1341.051,190.214 M1354.062,175.822c0.644,5.379,1.117,9.304,1.643,13.704 c-6.923-1.264-3.96-8.618-9.111-12.802c0.76,13.563,1.039,9.508-1.982,14.713c-3.461-4.495-2.368-1.693-4.277-10.364 c-2.943,6.08-3.412,1.463,0.823,16.928c2.604-0.782,5.208-1.564,7.815-2.345c2.637,0.808,4.268,1.268,5.443,1.268 c1.6,0,2.354-0.854,3.65-2.85C1361.377,188.983,1360.208,181.228,1354.062,175.822L1354.062,175.822z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 1333.8134,
    y1: 517.9772,
    x2: 1359.5898,
    y2: 517.9772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M1346.12,530.284c-1.376-2.973-0.18-3.263-8.22-9.7c-4.44-3.55-4.211,1.498-3.99-10.038 c7.087,0.31,3.555-2.837,13.728,9.974c3.444-9.037,5.475-17.186,10.589-14.234c1.529,0.885,1.345,4.735,1.362,7.751 c-7.958-3.77-7.795,1.827-11.897,16.06C1347.167,530.161,1346.646,530.223,1346.12,530.284z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 1346.7017,
    y1: 530.2838,
    x2: 1346.7017,
    y2: 505.6706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M1356.219,507.671c0.245,0,0.561,0.102,0.915,0.295c0.298,0.473,0.401,1.871,0.437,3.185 c-0.689-0.173-1.324-0.258-1.925-0.258c-0.89,0-1.659,0.16-2.336,0.471C1354.293,509.232,1355.297,507.671,1356.219,507.671  M1338.109,512.415c0.593,0,1.225,0.749,4.509,4.954c0.939,1.203,2.07,2.651,3.454,4.394l1.364,1.717 c-0.006,0.024-0.013,0.049-0.02,0.074c-0.237,0.889-0.49,1.838-0.763,2.84c-0.898-1.62-2.608-3.453-7.503-7.373 c-1.481-1.184-2.593-1.6-3.31-1.835c-0.052-0.779-0.018-2.377,0.026-4.43l0.004-0.205c0.539-0.021,0.991-0.056,1.38-0.086 C1337.593,512.439,1337.891,512.415,1338.109,512.415 M1356.219,505.671c-3.712,0-5.627,7.098-8.581,14.849 c-7.086-8.924-7.522-10.105-9.53-10.105c-0.723,0-1.649,0.153-3.164,0.153c-0.318,0-0.662-0.007-1.035-0.023 c-0.22,11.536-0.449,6.488,3.99,10.038c8.04,6.438,6.844,6.728,8.22,9.7c0.526-0.061,1.047-0.122,1.573-0.186 c3.27-11.347,3.829-17.205,7.953-17.205c1.049,0,2.33,0.379,3.944,1.144c-0.017-3.016,0.167-6.866-1.362-7.751 C1357.5,505.866,1356.835,505.671,1356.219,505.671L1356.219,505.671z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 1263.8042,
    y1: 321.6343,
    x2: 1292.6663,
    y2: 321.6343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M1278.406,334.605c-6.629-14.552-2.539-9.509-14.602-18.921c3.203-14.468,8.026-4.029,16.104,8.432 c0.188-1,1.481-9.949,4.028-13.15c1.058-1.33,4.674-2.486,5.436-1.805c1.603,1.43,2.078,4.122,3.294,6.938 C1281.132,315.911,1284.08,315.163,1278.406,334.605z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 1278.2352,
    y1: 334.605,
    x2: 1278.2352,
    y2: 308.6637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M1267.821,310.676c1.471,0.357,4.972,5.926,7.538,10.009c0.916,1.457,1.863,2.963,2.871,4.519l0.474,0.731 c-0.219,0.847-0.458,1.762-0.722,2.749c-0.211-0.495-0.406-0.955-0.589-1.387c-2.342-5.537-2.552-5.803-7.473-9.474 c-1.046-0.78-2.304-1.719-3.873-2.929C1266.889,311.604,1267.625,310.831,1267.821,310.676 M1288.344,310.981 c0.541,0.689,0.952,1.8,1.403,3.068c-0.278-0.003-0.545-0.005-0.8-0.005c-2.05,0-3.563,0.189-4.73,0.661 c0.515-1.352,0.964-2.091,1.284-2.492C1285.836,311.791,1287.358,311.106,1288.344,310.981 M1267.767,308.664 c-1.559,0-2.858,2.027-3.963,7.02c12.063,9.412,7.973,4.369,14.602,18.921c4.959-16.991,3.331-18.562,10.542-18.562 c1.04,0,2.265,0.033,3.719,0.057c-1.216-2.816-1.691-5.508-3.294-6.938c-0.156-0.139-0.431-0.202-0.778-0.202 c-1.355,0-3.816,0.948-4.658,2.006c-2.547,3.201-3.84,12.15-4.027,13.15C1274.618,315.956,1270.724,308.664,1267.767,308.664 L1267.767,308.664z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 1388.3997,
    y1: 287.7419,
    x2: 1403.5492,
    y2: 287.7419
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M1393.923,276.891c6.059,3.551,10.487,4.358,9.484,10.905c-2.021,13.176-15.41,13.688-14.998,4.812 C1388.707,286.287,1390.673,280.501,1393.923,276.891z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 1395.9745,
    y1: 298.5927,
    x2: 1395.9745,
    y2: 276.8911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M1394.418,279.468c0.575,0.315,1.127,0.608,1.641,0.88c4.641,2.463,5.953,3.342,5.371,7.145 c-0.916,5.974-4.573,9.1-7.712,9.1c-0.99,0-1.85-0.33-2.422-0.93c-0.641-0.671-0.948-1.695-0.889-2.961 C1390.655,287.437,1392.099,282.717,1394.418,279.468 M1393.923,276.891c-3.25,3.609-5.217,9.396-5.515,15.717 c-0.181,3.898,2.299,5.985,5.31,5.985c3.845,0,8.555-3.407,9.689-10.796C1404.41,281.249,1399.982,280.442,1393.923,276.891 L1393.923,276.891z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 1444.7506,
    y1: 481.6238,
    x2: 1472.0963,
    y2: 481.6238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M1459.555,493.635c-4.539-7.952-4.491-10.962-9.878-10.754c-1.643,0.063-4.332-1.715-4.801-3.202 c-0.499-1.597,0.565-4.963,1.835-5.513c5.079-2.2,10.178,5.144,13.912,9.076c1.323-6.698,3.394-15.981,9.584-13.087 c1.077,0.508,1.292,2.867,1.888,4.405c-10.026,3.612-8.395,4.159-11.043,19.044 C1460.554,493.616,1460.054,493.624,1459.555,493.635z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 1458.4235,
    y1: 493.6353,
    x2: 1458.4235,
    y2: 469.6124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M1468.014,471.612L1468.014,471.612c0.34,0,0.728,0.091,1.152,0.269c0.157,0.298,0.344,0.967,0.477,1.461 c-2.246,0.873-3.879,1.67-5.1,2.588C1465.415,473.532,1466.556,471.613,1468.014,471.612 M1448.63,475.764 c2.693,0,5.944,3.689,8.557,6.654c0.694,0.788,1.35,1.532,1.987,2.202l1.13,1.19c-0.082,0.501-0.165,1.026-0.251,1.577 c-0.114,0.725-0.234,1.492-0.366,2.311c-0.295-0.565-0.569-1.098-0.829-1.606c-2.309-4.503-3.703-7.221-8.677-7.221 c-0.187,0-0.38,0.004-0.589,0.012c-0.834,0-2.58-1.203-2.806-1.801c-0.202-0.645,0.323-2.591,0.828-3.124 C1447.947,475.828,1448.281,475.764,1448.63,475.764 M1468.013,469.612c-4.515,0.001-6.236,7.796-7.389,13.63 c-3.264-3.437-7.57-9.479-11.994-9.479c-0.638,0-1.279,0.126-1.918,0.403c-1.27,0.549-2.335,3.916-1.835,5.513 c0.461,1.461,3.066,3.204,4.714,3.204c0.029,0,0.058-0.001,0.086-0.002c0.173-0.007,0.34-0.01,0.503-0.01 c4.885,0,4.982,3.067,9.375,10.764c0.499-0.011,0.998-0.02,1.498-0.031c2.648-14.885,1.017-15.432,11.043-19.044 c-0.596-1.538-0.81-3.897-1.888-4.405C1469.41,469.783,1468.681,469.612,1468.013,469.612L1468.013,469.612z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 1170.2786,
    y1: 232.2391,
    x2: 1185.0668,
    y2: 232.2391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M1174.862,221.462c3.864,2.67,13.128,7.557,9.293,15.833c-1.467,3.165-7.819,6.846-10.631,5.396 C1167.549,239.611,1170.925,233.842,1174.862,221.462z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 1177.6726,
    y1: 243.0165,
    x2: 1177.6726,
    y2: 221.4617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M1175.948,224.587c4.876,3.282,8.769,6.739,6.393,11.867c-0.929,2.004-5.018,4.563-7.292,4.563 c-0.369,0-0.548-0.072-0.608-0.103c-3.147-1.622-2.759-3.782,0.429-13.135C1175.207,226.787,1175.571,225.719,1175.948,224.587  M1174.862,221.462c-3.937,12.38-7.313,18.15-1.338,21.229c0.434,0.224,0.953,0.325,1.525,0.325c3.132,0,7.866-3.046,9.107-5.722 C1187.99,229.019,1178.726,224.131,1174.862,221.462L1174.862,221.462z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 1334.7493,
    y1: 494.3274,
    x2: 1351.465,
    y2: 494.3274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1351.447,495.228c-0.575,9.458-17.31,9.898-16.68-0.539 C1335.519,482.104,1352.088,484.655,1351.447,495.228z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 1343.1071,
    y1: 502.4189,
    x2: 1343.1071,
    y2: 486.2359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M1342.805,488.236L1342.805,488.236c1.896,0,3.774,0.793,5.024,2.12c1.174,1.247,1.734,2.89,1.621,4.75 c-0.222,3.65-3.662,5.313-6.764,5.313c-1.936,0-3.652-0.643-4.708-1.765c-0.903-0.959-1.312-2.252-1.215-3.846 C1337.128,488.71,1341.48,488.236,1342.805,488.236 M1342.805,486.236c-3.886,0-7.687,2.576-8.038,8.453 c-0.315,5.232,3.731,7.73,7.92,7.73c4.167,0,8.474-2.474,8.761-7.191C1351.789,489.592,1347.241,486.236,1342.805,486.236 L1342.805,486.236z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 1286.9105,
    y1: 131.9866,
    x2: 1311.6665,
    y2: 131.9866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M1300.339,133.039c3.61-14.16,1.798-10.052,8.218-14.184c1.036,1.967,2.072,3.932,3.11,5.896 c-0.261,0.408-0.519,0.813-0.78,1.218c-9.175-2.634-8.175,3.733-9.312,18.93c-0.515,0.073-1.029,0.147-1.544,0.219 c-3.04-6.207-2.696-10.172-8.717-11.935c-3.256-0.945-2.756-1.64-4.403-8.623C1293.783,125.067,1290.377,122.279,1300.339,133.039 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 1299.2885,
    y1: 145.118,
    x2: 1299.2885,
    y2: 118.8553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1307.772,121.657c0.319,0.604,0.637,1.209,0.956,1.813c-0.442-0.054-0.861-0.08-1.259-0.08 c-1.034,0-1.915,0.158-2.667,0.461c0.065-0.17,0.128-0.315,0.191-0.437c0.188-0.364,0.257-0.435,1.451-1.05 C1306.817,122.172,1307.256,121.945,1307.772,121.657 M1290.84,126.58c0.79,0,0.979,0.126,5.024,4.546 c0.843,0.921,1.832,2.002,3.008,3.272l1.297,1.401c-0.082,1.114-0.154,2.287-0.229,3.514c-0.008,0.125-0.015,0.251-0.023,0.378 c-1.43-3.708-2.789-6.888-8.046-8.427c-1.205-0.35-1.312-0.519-1.389-0.642c-0.292-0.464-0.553-1.673-0.914-3.347 c-0.045-0.208-0.092-0.425-0.141-0.651c0.262-0.006,0.501-0.015,0.721-0.023C1290.405,126.59,1290.632,126.58,1290.84,126.58  M1308.556,118.855c-6.419,4.132-4.608,0.024-8.218,14.184c-7.111-7.681-7.411-8.458-9.499-8.458c-0.531,0-1.176,0.05-2.079,0.05 c-0.522,0-1.13-0.017-1.851-0.07c1.647,6.982,1.146,7.678,4.403,8.623c6.021,1.763,5.677,5.727,8.717,11.935 c0.515-0.072,1.029-0.147,1.544-0.219c0.971-12.971,0.384-19.509,5.896-19.509c0.946,0,2.072,0.193,3.416,0.579 c0.261-0.405,0.519-0.81,0.78-1.218C1310.628,122.787,1309.592,120.822,1308.556,118.855L1308.556,118.855z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 1252.6637,
    y1: 144.4407,
    x2: 1266.8683,
    y2: 144.4407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M1266.868,144.726c-3.878,4.786-6.854,11.281-13.001,7.613c-2.32-1.383-1.548-17.083,4.641-16.871 C1262.183,135.595,1265.681,139.888,1266.868,144.726z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 1259.766,
    y1: 153.4158,
    x2: 1259.766,
    y2: 135.4657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M1258.384,137.466L1258.384,137.466l0.055,0.001c2.363,0.082,5.033,3.063,6.229,6.821 c-0.451,0.587-0.888,1.182-1.315,1.764c-2.026,2.759-3.939,5.365-6.069,5.365c-0.648,0-1.382-0.227-2.185-0.675 c-0.702-1.437-0.739-7.862,1.248-11.521C1256.977,138.056,1257.663,137.466,1258.384,137.466 M1258.384,135.466 c-6.075,0-6.822,15.5-4.517,16.873c1.261,0.752,2.387,1.077,3.416,1.077c3.989,0,6.502-4.885,9.585-8.69 c-1.187-4.838-4.685-9.131-8.36-9.258C1258.467,135.466,1258.425,135.466,1258.384,135.466L1258.384,135.466z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 1271.54,
    y1: 264.7724,
    x2: 1290.2351,
    y2: 264.7724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1290.235,260.837c-0.961,4.88-1.923,9.757-3.092,15.708c-1.756-1.614-2.572-1.993-2.69-2.528 c-3.099-13.863-12.489-10.826-12.909-17.022c-0.092-1.342,1.435-3.912,2.374-3.971c6.402-0.415,7.134,4.328,13.744,14.116 c0.788-2.591,1.377-4.527,1.967-6.463C1289.83,260.732,1290.034,260.784,1290.235,260.837z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 1280.8876,
    y1: 276.5452,
    x2: 1280.8876,
    y2: 252.9995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1274.664,254.999c3.013,0,4.085,1.551,7.341,6.932c1.108,1.831,2.364,3.907,3.999,6.328l0.565,0.837 c-0.185,0.94-0.374,1.899-0.568,2.885c-2.185-7.733-6.506-10.236-9.427-11.928c-2.18-1.263-2.939-1.772-3.035-3.178 c0.006-0.417,0.511-1.431,0.904-1.874C1274.518,255,1274.592,254.999,1274.664,254.999 M1274.664,252.999 c-0.24,0-0.488,0.008-0.746,0.025c-0.939,0.059-2.466,2.629-2.374,3.971c0.42,6.196,9.81,3.159,12.909,17.022 c0.118,0.534,0.933,0.913,2.69,2.528c1.169-5.951,2.131-10.828,3.092-15.708c-0.201-0.052-0.405-0.105-0.606-0.16 c-0.589,1.936-1.178,3.872-1.967,6.463C1281.318,257.746,1280.389,252.999,1274.664,252.999L1274.664,252.999z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 1191.5823,
    y1: 179.803,
    x2: 1213.0773,
    y2: 179.803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M1193.218,165.454c9.757,2.061,21.641,19.429,19.635,28.698c-16.625-26.471-10.849-11.09-21.271-27.686 C1192.128,166.129,1192.673,165.791,1193.218,165.454z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 1202.3298,
    y1: 194.152,
    x2: 1202.3298,
    y2: 165.454
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M1195.069,168.188c3.75,1.738,7.969,5.76,11.291,10.889c1.436,2.217,2.576,4.453,3.375,6.563 c-5.583-8.332-7.461-9.75-9.29-11.13C1199.188,173.56,1198.077,172.72,1195.069,168.188 M1193.218,165.454 c-0.545,0.337-1.09,0.675-1.636,1.012c10.422,16.596,4.647,1.215,21.271,27.686 C1214.859,184.883,1202.975,167.515,1193.218,165.454L1193.218,165.454z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 1188.3998,
    y1: 329.7198,
    x2: 1212.8755,
    y2: 329.7198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M1188.4,336.232c4.775-10.561,15.848-9.545,24.476-13.025C1207.661,332.954,1196.49,331.764,1188.4,336.232 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 1200.6377,
    y1: 336.2323,
    x2: 1200.6377,
    y2: 323.2073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M1206.79,327.112c-2.845,1.969-6.327,2.936-9.935,3.938c-0.858,0.238-1.725,0.479-2.59,0.736 c3.083-2.419,7.072-3.371,11.452-4.417C1206.073,327.284,1206.431,327.199,1206.79,327.112 M1212.875,323.207 c-8.627,3.48-19.701,2.464-24.476,13.025C1196.49,331.764,1207.661,332.954,1212.875,323.207L1212.875,323.207z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 1430.5072,
    y1: 161.4917,
    x2: 1440.1454,
    y2: 161.4917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M1434.823,149.851c-0.442,5.752-0.806,10.526-1.174,15.299c0.596,0.153,1.191,0.307,1.787,0.46 c1.235-0.723,2.471-1.445,3.71-2.171c0.333,0.195,0.666,0.39,0.998,0.585c-1.612,3.038-3.224,6.076-4.836,9.109 C1429.12,169.979,1428.866,159.026,1434.823,149.851z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 1435.3263,
    y1: 173.1328,
    x2: 1435.3263,
    y2: 149.8507
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M1432.991,167.045l0.16,0.041l0.074,0.019l1.714,0.441l0.797,0.205l0.242-0.142 c-0.447,0.842-0.895,1.685-1.342,2.527C1433.774,169.187,1433.276,168.028,1432.991,167.045 M1434.823,149.851 c-5.957,9.175-5.703,20.128,0.486,23.282c1.612-3.034,3.224-6.071,4.836-9.109c-0.333-0.195-0.666-0.39-0.998-0.585 c-1.24,0.725-2.475,1.448-3.71,2.171c-0.596-0.153-1.191-0.306-1.787-0.46C1434.017,160.377,1434.381,155.602,1434.823,149.851 L1434.823,149.851z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 1396.4099,
    y1: 212.55,
    x2: 1404.8179,
    y2: 212.55
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M1404.818,213.673c-0.179,1.098-0.312,9.318-4.766,8.695c-5.352-0.742-3.815-4.176-1.634-19.67 c0.578,0.103,1.152,0.206,1.73,0.306C1399.147,210.793,1396.977,219.401,1404.818,213.673z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 1400.6139,
    y1: 222.4019,
    x2: 1400.6139,
    y2: 202.6982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M1398.474,216.588c0.64,0.613,1.488,0.947,2.421,0.947c0.444,0,0.913-0.074,1.415-0.225 c-0.585,2.731-1.401,3.091-1.788,3.091c-0.062,0-0.126-0.005-0.195-0.015c-0.603-0.083-1.37-0.248-1.602-0.561 C1398.381,219.366,1398.337,218.235,1398.474,216.588 M1398.418,202.698c-2.181,15.494-3.718,18.928,1.634,19.67 c0.162,0.023,0.319,0.034,0.47,0.034c3.994,0,4.124-7.671,4.296-8.728c-1.78,1.3-3.044,1.862-3.923,1.862 c-2.992,0-1.521-6.511-0.747-12.53C1399.57,202.904,1398.996,202.801,1398.418,202.698L1398.418,202.698z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 1308.095,
    y1: 516.9927,
    x2: 1317.4946,
    y2: 516.9927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M1317.495,521.878c-2.309,2.291-3.767,3.736-5.228,5.184c-3.185-4.266-7.371-3.405-0.324-20.139 C1312.766,512.145,1307.492,518.435,1317.495,521.878z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 1312.7948,
    y1: 527.0623,
    x2: 1312.7948,
    y2: 506.9232
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M1310.171,518.893c0.698,1.32,1.884,2.568,3.825,3.637l-1.629,1.615c-0.132-0.134-0.261-0.263-0.386-0.389 c-1.229-1.232-1.846-1.85-1.885-3.56C1310.088,519.808,1310.113,519.373,1310.171,518.893 M1311.942,506.923 c-7.047,16.734-2.86,15.873,0.324,20.139c1.461-1.448,2.919-2.894,5.228-5.184 C1307.492,518.435,1312.766,512.145,1311.942,506.923L1311.942,506.923z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 1239.7323,
    y1: 304.5479,
    x2: 1247.449,
    y2: 304.5479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M1244.173,294.811c-0.574,4.026-1.148,8.049-1.829,12.815c2.35-0.458,3.598-0.699,4.982-0.968 c0,2.508,1.317,0.44-4.707,8.102c-3.562-8.079-4.375-2.459,0.707-20.423C1243.61,294.494,1243.893,294.654,1244.173,294.811z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 1243.5907,
    y1: 314.7597,
    x2: 1243.5907,
    y2: 294.3362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M1244.416,309.261c-0.352,0.451-0.774,0.982-1.244,1.575c-0.053,0.067-0.107,0.135-0.162,0.204 c-0.179-0.324-0.342-0.611-0.49-0.868c-0.104-0.183-0.196-0.344-0.276-0.488l0.483-0.094L1244.416,309.261 M1243.328,294.336 c-5.082,17.965-4.27,12.344-0.707,20.424c6.024-7.662,4.707-5.594,4.707-8.102c-1.384,0.27-2.633,0.51-4.983,0.968 c0.681-4.766,1.255-8.789,1.829-12.815C1243.893,294.654,1243.61,294.494,1243.328,294.336L1243.328,294.336z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 1332.3073,
    y1: 120.8293,
    x2: 1340.785,
    y2: 120.8293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M1334.777,123.339c2.565,0,4.089,0,5.609,0c0.149,0.357,0.477,0.834,0.381,0.95 c-1.884,2.228-4.685,6.592-5.589,6.231c-5.261-2.098-2.525-6.453,2.063-19.403c0.416,0.16,0.833,0.32,1.248,0.477 C1337.305,115.342,1336.122,119.085,1334.777,123.339z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 1336.5461,
    y1: 130.5414,
    x2: 1336.5461,
    y2: 111.1172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M1337.411,125.339c-0.023,0.031-0.046,0.061-0.069,0.091c-0.638,0.845-1.606,2.129-2.247,2.829 c-0.724-0.474-0.975-1.186-0.62-2.921h0.302H1337.411 M1337.241,111.117c-4.588,12.95-7.324,17.305-2.063,19.403 c0.036,0.014,0.074,0.021,0.115,0.021c1.008,0,3.664-4.113,5.474-6.252c0.096-0.116-0.232-0.593-0.381-0.951 c-1.52,0-3.044,0-5.609,0c1.345-4.253,2.528-7.996,3.712-11.744C1338.074,111.437,1337.657,111.277,1337.241,111.117 L1337.241,111.117z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 1318.3794,
    y1: 196.3227,
    x2: 1327.0986,
    y2: 196.3227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M1327.099,197.777c-1.66,1.798-3.362,5.136-4.97,5.092c-6.038-0.171-3.314-8.269-1.868-13.093 c1.618,2.821,3.088,5.381,4.558,7.939C1325.578,197.735,1326.339,197.755,1327.099,197.777z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 1322.739,
    y1: 202.8696,
    x2: 1322.739,
    y2: 189.7759
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M1320.897,194.902l2.187,3.809l0.329,0.554c-0.494,0.656-1.063,1.365-1.408,1.595 c-0.912-0.063-1.149-0.392-1.23-0.505C1320.078,199.389,1320.374,197.132,1320.897,194.902 M1320.261,189.776 c-1.446,4.824-4.17,12.922,1.868,13.093c0.01,0,0.021,0,0.031,0c1.598,0,3.289-3.306,4.938-5.093 c-0.76-0.022-1.52-0.042-2.28-0.061C1323.349,195.157,1321.879,192.597,1320.261,189.776L1320.261,189.776z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 1345.3795,
    y1: 460.1889,
    x2: 1353.6501,
    y2: 460.1889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M1346.433,454.21c2.031,2.591,3.575,4.564,5.119,6.538c0.698,0.156,1.397,0.313,2.098,0.469 c-1.482,1.649-2.961,3.3-4.442,4.952C1344.13,458.515,1345.131,461.571,1346.433,454.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 1349.5149,
    y1: 466.1682,
    x2: 1349.5149,
    y2: 454.2097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M1347.496,458.81c0.753,0.961,1.454,1.858,2.149,2.746l0.332,0.424l0.14,0.178 c-0.229,0.255-0.458,0.51-0.686,0.766c-0.157-0.229-0.305-0.445-0.445-0.647c-0.889-1.291-1.476-2.143-1.587-2.549 C1347.355,459.569,1347.393,459.29,1347.496,458.81 M1346.433,454.21c-1.303,7.362-2.304,4.306,2.775,11.958 c1.481-1.652,2.959-3.303,4.442-4.952c-0.701-0.156-1.4-0.313-2.098-0.469C1350.008,458.774,1348.464,456.801,1346.433,454.21 L1346.433,454.21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 1198.7646,
    y1: 473.9554,
    x2: 1206.7491,
    y2: 473.9554
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M1200.291,468.753c1.846,1.064,3.71,2.14,6.459,3.727c-1.176,1.94-2.582,4.26-4.049,6.678 C1198.166,475.586,1197.818,473.314,1200.291,468.753z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 1202.7568,
    y1: 479.1582,
    x2: 1202.7568,
    y2: 468.7526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M1201.147,471.555c0.861,0.496,1.78,1.027,2.833,1.635l-1.761,2.904 C1200.623,474.497,1200.437,473.326,1201.147,471.555 M1200.29,468.753c-2.473,4.562-2.124,6.833,2.409,10.406 c1.467-2.418,2.874-4.738,4.05-6.678C1204,470.892,1202.137,469.817,1200.29,468.753L1200.29,468.753z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 1289.2847,
    y1: 253.9498,
    x2: 1298.672,
    y2: 253.9498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M1289.285,258.051c1.38-2.751,2.203-5.204,3.734-7.079c0.814-1,5.358-3.194,5.653,3.866 C1298.681,255.042,1289.479,257.988,1289.285,258.051z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 1293.9783,
    y1: 258.051,
    x2: 1293.9783,
    y2: 249.8487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M1295.611,251.849L1295.611,251.849c0.403,0,0.738,0.644,0.922,1.696c-0.759,0.268-1.895,0.654-3.476,1.176 c0.459-0.933,0.927-1.761,1.489-2.457C1294.71,252.117,1295.21,251.849,1295.611,251.849 M1295.611,249.849 c-1.134,0-2.231,0.68-2.593,1.124c-1.531,1.875-2.354,4.328-3.734,7.079c0.194-0.063,9.396-3.009,9.387-3.213 C1298.508,250.914,1297.031,249.849,1295.611,249.849L1295.611,249.849z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 708.0281,
    y1: 642.5458,
    x2: 779.6882,
    y2: 642.5458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M745.595,644.971c34.876,27.393,36.852,26.288,32.318,33.046c-22.565,33.642-21.505,37.764-28.196,31.775 c-29.182-26.132-37.602-25.607-32.827-32.113c8.702-11.84,17.452-23.645,26.615-36.042 c-26.176-21.743-33.604-27.951-33.604-27.951c-4.51-3.692-2.094-3.642,20.95-37.439c4.811-7.063,6.093-3.948,38.462,22.958 c2.661,2.212,3.697,4.63,1.259,8.178C762.264,619.482,754.296,631.817,745.595,644.971z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 743.8582,
    y1: 712.0892,
    x2: 743.8582,
    y2: 573.0025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M734.999,575.003L734.999,575.003c2.422,0,8.331,4.98,20.104,14.901c3.711,3.127,7.917,6.672,12.931,10.839 c2.252,1.872,2.468,3.21,0.889,5.508c-5.969,8.693-11.7,17.412-17.767,26.642c-1.751,2.663-3.52,5.356-5.318,8.082l-1.054-0.876 c-25.872-21.491-33.525-27.885-33.615-27.96c-1.329-1.088-1.329-1.088-0.873-2.186c0.858-2.067,3.506-5.812,8.312-12.612 c3.37-4.768,7.984-11.297,13.896-19.968C733.854,575.391,734.441,575.003,734.999,575.003 M743.097,645.553l1.262,0.991 c7.117,5.59,12.856,9.987,17.467,13.52c8.637,6.618,13.394,10.263,15.158,12.548c1.018,1.319,1.078,1.591-0.732,4.291 c-5.865,8.744-10.199,15.595-13.363,20.597c-4.623,7.309-7.964,12.589-9.252,12.589c-0.59,0-2.093-1.345-2.586-1.786 c-11.807-10.573-20.211-16.79-25.772-20.904c-3.827-2.831-6.355-4.701-7.304-6.031c-0.417-0.584-0.646-0.906,0.526-2.503 c6.574-8.945,13.078-17.739,19.965-27.048L743.097,645.553 M734.999,573.003c-1.651,0-2.751,1.193-4.149,3.245 c-23.044,33.798-25.46,33.748-20.95,37.439c0,0,7.428,6.208,33.604,27.951c-9.164,12.397-17.913,24.202-26.615,36.042 c-4.775,6.506,3.645,5.981,32.827,32.113c1.61,1.441,2.771,2.297,3.92,2.297c3.628,0,7.14-8.525,24.276-34.072 c4.534-6.758,2.558-5.653-32.318-33.046c8.701-13.154,16.67-25.489,24.977-37.588c2.438-3.548,1.402-5.966-1.259-8.178 C746.347,580.116,739.03,573.002,734.999,573.003L734.999,573.003z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 702.2052,
    y1: 377.8777,
    x2: 751.5311,
    y2: 377.8777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M723.515,402.135c-33.796-5.534-23.225-49.586,2.781-48.829 C766.49,354.474,753.446,407.037,723.515,402.135z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 726.8681,
    y1: 402.458,
    x2: 726.8681,
    y2: 353.2973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M725.637,353.297v2c0.2,0,0.399,0.003,0.602,0.009c17.387,0.505,23.431,11.106,23.289,20.86 c-0.087,6.001-2.376,12.079-6.28,16.676c-4.172,4.912-9.797,7.617-15.838,7.617c-1.169,0-2.371-0.1-3.571-0.296 c-15.585-2.552-20.318-13.539-19.551-22.971c0.875-10.761,9.099-21.892,21.349-21.893L725.637,353.297 M725.635,353.297 c-25.52,0.002-35.628,43.351-2.12,48.838c1.334,0.218,2.631,0.323,3.895,0.323c27.091,0,37.29-48.036-1.113-49.151 C726.074,353.3,725.855,353.297,725.635,353.297L725.635,353.297z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 675.2979,
    y1: 308.1366,
    x2: 727.8201,
    y2: 308.1366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M727.805,291.692c0.268,14.495-2.712,13.461-47.667,32.468c-1.419,0.6-3.217,0.302-4.84,0.421 c1.104-14.439,3.433-12.722,46.498-31.197C723.537,292.634,725.469,292.337,727.805,291.692z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 701.559,
    y1: 324.5807,
    x2: 701.559,
    y2: 291.6924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M725.824,294.253c-0.112,8.608-2.878,9.932-30.492,21.39c-4.649,1.929-9.918,4.115-15.973,6.675 c-0.493,0.208-1.222,0.234-1.883,0.236c0.844-8.622,3.048-9.711,27.266-19.809c5.103-2.128,10.887-4.54,17.844-7.524 C723.529,294.815,724.598,294.548,725.824,294.253 M727.805,291.692c-2.337,0.644-4.268,0.942-6.01,1.691 c-43.065,18.475-45.394,16.758-46.498,31.197c0.35-0.026,0.708-0.032,1.069-0.032c0.338,0,0.678,0.005,1.016,0.005 c0.974,0,1.929-0.045,2.755-0.394C725.094,305.154,728.074,306.188,727.805,291.692L727.805,291.692z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 2476.6272,
    y1: 521.6223,
    x2: 2574.5239,
    y2: 521.6223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M2477.349,560.526c20.303-10.189,40.602-20.382,60.901-30.571c-0.074-0.697-0.149-1.393-0.223-2.089 c-41.056-9.881-67.867,2.394-60.042-9.118c24.967-36.748,21.666-35.801,37.562-37.627c27.355-3.144,43.895,5.667,55.276,10.423 c12.807,5.351-10.885,33.815-21.521,42.683c-21.415,17.88-15.077,21.014-71.146,28.56 C2477.887,562.033,2477.621,561.28,2477.349,560.526z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 2525.5754,
    y1: 562.7864,
    x2: 2525.5754,
    y2: 480.4583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M2526.833,482.458c17.97,0,30.516,5.44,39.677,9.413c1.234,0.535,2.413,1.046,3.542,1.518 c1.443,0.603,2.185,1.525,2.406,2.99c1.303,8.644-15.313,28.704-24.438,36.312c-3.659,3.055-6.493,5.662-8.993,7.963 c-11.548,10.625-14.94,13.75-56.514,19.519c10.838-5.439,21.674-10.879,32.51-16.319l24.125-12.111l1.239-0.622l-0.147-1.378 l-0.223-2.089l-0.15-1.402l-1.371-0.33c-11.905-2.865-24.16-4.258-37.466-4.258c-4.371,0-8.175,0.138-11.531,0.26 c-2.434,0.089-4.537,0.165-6.29,0.165c-2.984,0-4.115-0.255-4.536-0.424c0.082-0.275,0.313-0.83,0.967-1.793 c3.847-5.662,6.957-10.331,9.701-14.449c7.101-10.66,10.666-16.01,13.841-18.717c2.923-2.492,5.711-2.811,11.821-3.509 l0.774-0.089C2519.523,482.677,2523.244,482.458,2526.833,482.458 M2526.833,480.458c-3.544,0-7.301,0.204-11.286,0.662 c-15.896,1.826-12.596,0.879-37.562,37.627c-3.016,4.438-0.886,5.341,5.224,5.341c4.193,0,10.258-0.425,17.821-0.425 c10.005,0,22.63,0.744,36.998,4.203c0.074,0.696,0.149,1.393,0.223,2.089c-20.299,10.189-40.598,20.382-60.901,30.571 c0.272,0.754,0.539,1.507,0.806,2.26c56.069-7.546,49.731-10.68,71.146-28.56c10.636-8.867,34.328-37.332,21.521-42.683 C2561.099,487.48,2547.612,480.458,2526.833,480.458L2526.833,480.458z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 2498.6714,
    y1: 616.6312,
    x2: 2564.3745,
    y2: 616.6312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M2530.772,651.104c-0.289-1.002-11.233-40.791-14.898-39.546c-4.161,1.441-6.488-1.682-9.405-3.426 c-8.682-5.187-9.799-9.216-4.915-18.209c1.954-3.592,6.028-4.236,10.64-1.432c16.572,10.073,16.225,26.322,22.971,38.044 c2.072-7.841,4.096-15.695,6.216-23.518c10.69-39.447,32.22-12.997,18.63-1.091c-15.612-11.794-9.644-4.998-25.494,44.794 C2534.066,648.13,2532.467,649.172,2530.772,651.104z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 2531.5229,
    y1: 651.1041,
    x2: 2531.5229,
    y2: 582.1583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M2556.258,584.158c2.248,0,4.389,1.829,5.453,4.66c1.05,2.791,1.085,7.031-1.887,10.467 c-3.688-2.74-6.244-4.367-8.584-4.367c-4.679,0-5.928,4.91-9.266,18.033c-2.002,7.87-4.744,18.648-9.363,33.159 c-0.096,0.299-0.421,0.685-0.853,1.128c-1.887-6.615-3.831-13.002-5.555-18.244c-5.919-17.998-8.1-19.464-10.156-19.465 c-0.279,0-0.554,0.045-0.828,0.139c-0.503,0.174-0.966,0.259-1.414,0.259c-1.439,0-2.697-0.936-4.154-2.02 c-0.681-0.507-1.385-1.03-2.157-1.492c-7.749-4.629-8.53-7.534-4.184-15.537c0.77-1.415,1.941-2.133,3.481-2.133 c1.289,0,2.798,0.503,4.363,1.454c10.779,6.552,14.014,15.932,17.142,25.003c1.508,4.372,2.932,8.502,5.134,12.329l2.425,4.214 l1.242-4.7c0.688-2.602,1.37-5.205,2.052-7.808c1.35-5.151,2.746-10.477,4.16-15.698 C2548.185,585.556,2554.453,584.158,2556.258,584.158 M2556.258,582.158c-4.767,0-10.664,5.311-14.877,20.858 c-2.12,7.823-4.144,15.677-6.216,23.518c-6.745-11.721-6.398-27.97-22.971-38.044c-1.934-1.176-3.774-1.745-5.402-1.745 c-2.254,0-4.104,1.092-5.238,3.177c-4.884,8.993-3.767,13.023,4.915,18.209c2.396,1.432,4.394,3.795,7.336,3.795 c0.64,0,1.325-0.112,2.068-0.369c0.057-0.019,0.115-0.029,0.174-0.029c3.825,0.003,14.439,38.589,14.723,39.575 c1.695-1.932,3.294-2.974,3.745-4.385c11.579-36.374,11.513-49.801,16.723-49.801c1.922,0,4.563,1.829,8.771,5.007 C2568.246,594.711,2563.587,582.158,2556.258,582.158L2556.258,582.158z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 2508.5449,
    y1: 414.9093,
    x2: 2533.1897,
    y2: 414.9093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M2531.114,382.005c-1.857,5.344-3.509,10.771-5.638,16.004c-2.4,5.898-5.786,11.446-7.661,17.482 c-1.216,3.925-2.162,24.463,11.621,12.99c1.284-1.067,1.73-3.134,2.931-5.486c3.281,9.751-3.746,23.251-12.274,25.457 c-10.127,2.615-17.65-16.271-4.586-41.167c4.564-8.686,9.002-17.438,13.496-26.16 C2529.708,381.418,2530.413,381.712,2531.114,382.005z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 2520.8672,
    y1: 448.6938,
    x2: 2520.8672,
    y2: 381.1248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M2525.465,392.394c-0.584,1.639-1.193,3.268-1.841,4.861c-0.931,2.287-2.046,4.586-3.124,6.81 c-1.682,3.469-3.422,7.055-4.595,10.835c-0.854,2.757-1.637,11.998,1.66,16.471c1.232,1.671,2.928,2.555,4.905,2.555 c2.39,0,5.087-1.278,8.244-3.906c0.153-0.127,0.296-0.26,0.43-0.399c-0.213,2.89-1.119,5.939-2.671,8.803 c-2.287,4.221-5.607,7.246-8.881,8.092c-0.459,0.119-0.915,0.179-1.355,0.179c-2.532,0-4.228-1.926-5.205-3.542 c-3.754-6.21-3.897-19.421,4.245-34.937C2520.036,402.965,2522.786,397.618,2525.465,392.394 M2529.003,381.125 c-4.494,8.721-8.932,17.473-13.496,26.16c-12.252,23.348-6.398,41.409,2.73,41.409c0.605,0,1.226-0.08,1.855-0.242 c8.529-2.206,15.555-15.706,12.274-25.457c-1.2,2.352-1.647,4.42-2.931,5.486c-2.949,2.455-5.224,3.444-6.966,3.444 c-6.399,0-5.611-13.349-4.655-16.434c1.875-6.036,5.261-11.584,7.661-17.482c2.129-5.232,3.78-10.66,5.638-16.004 C2530.413,381.712,2529.708,381.418,2529.003,381.125L2529.003,381.125z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 2194.5918,
    y1: 708.9274,
    x2: 2265.3201,
    y2: 708.9274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M2265.32,703.099c-6.567,13.087,0.847,0.221-21.302,36.169c-3.264,5.292-4.941,5.931-10.228,2.69 c-44.856-27.506-41.174-23.758-36.616-31.675c7.248-12.586,8.892-13.181,20.79-34.189c2.582-4.567,0.928-4.089,42.464,23.076 C2262.114,700.274,2263.594,701.698,2265.32,703.099z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 2229.9561,
    y1: 743.9353,
    x2: 2229.9561,
    y2: 673.9196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M2220.371,675.935c1.719,0.277,7.892,4.373,18.789,11.603c5.274,3.499,11.837,7.854,20.173,13.306 c1.042,0.682,2.041,1.536,3.098,2.44c0.131,0.112,0.262,0.224,0.395,0.337c-0.919,1.853-1.501,3.073-1.949,4.012 c-1.354,2.841-1.354,2.841-6.133,10.519c-2.538,4.078-6.373,10.24-12.427,20.066c-1.903,3.085-2.802,3.717-3.566,3.717 c-1.049,0-2.736-0.96-3.914-1.682c-5.547-3.401-10.352-6.325-14.505-8.852c-15.519-9.443-23.309-14.183-23.731-16.037 c-0.076-0.336,0.516-1.245,1.089-2.125c0.368-0.566,0.786-1.207,1.219-1.958c3.027-5.256,5.106-8.461,7.307-11.854 c3.082-4.751,6.575-10.136,13.491-22.348l0.183-0.327C2220.039,676.481,2220.233,676.133,2220.371,675.935 M2220.201,673.92 c-1.118,0-1.51,0.887-2.238,2.175c-11.897,21.008-13.542,21.602-20.79,34.189c-4.558,7.917-8.24,4.169,36.616,31.675 c2.123,1.302,3.664,1.977,4.96,1.977c1.93,0,3.316-1.501,5.269-4.667c22.149-35.948,14.735-23.082,21.302-36.169 c-1.726-1.402-3.206-2.825-4.893-3.929C2230.604,679.665,2223.048,673.919,2220.201,673.92L2220.201,673.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 2365.4192,
    y1: 717.0745,
    x2: 2423.3611,
    y2: 717.0745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M2397.7,727.086c2.799-17.322,1.759-23.565,12.252-40.343c2.941-4.689,15.059-0.382,13.22,7.363 c-2.181,9.194-3.307,9.707-11.652,4.398c-11.403,10.216-6.777,30.997-15.209,50.615c-0.508,0.079-1.016,0.158-1.524,0.232 c-4.907-10.651-11.568-28.578-13.461-33.852c-2.076-5.791-8.244-5.506-12.085-8.721c-12.173-10.177,6.861-44.494,27.216,20.391 C2396.872,727.139,2397.284,727.113,2397.7,727.086z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 2394.3904,
    y1: 749.3519,
    x2: 2394.3904,
    y2: 684.7971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M2414.184,686.797L2414.184,686.797c2.26,0,4.784,1.196,6.138,2.909c0.939,1.188,1.243,2.513,0.904,3.939 c-0.444,1.872-1.484,6.257-2.468,6.257c-1.316,0-4.591-2.083-6.165-3.085l-1.279-0.814l-1.129,1.012 c-7.041,6.308-8.433,16.259-9.906,26.793c-1.013,7.244-2.057,14.71-4.84,22.12c-4.659-10.575-10.438-26.106-12.231-31.103 c-1.618-4.513-5.211-5.998-8.382-7.308c-1.613-0.667-3.136-1.296-4.303-2.273c-3.247-2.715-3.709-7.544-2.487-10.911 c0.408-1.124,1.634-3.738,4.205-3.738c5.146,0,13.708,9.765,22.306,37.173l0.475,1.514l1.582-0.118 c0.393-0.029,0.782-0.054,1.222-0.082l1.593-0.101l0.255-1.576c0.529-3.271,0.927-6.188,1.278-8.763 c1.546-11.329,2.397-17.57,10.694-30.837C2412.197,686.928,2413.472,686.797,2414.184,686.797 M2414.183,684.797 c-1.8,0-3.391,0.605-4.231,1.946c-10.492,16.778-9.452,23.021-12.252,40.343c-0.416,0.026-0.828,0.052-1.244,0.083 c-9.296-29.634-18.316-38.574-24.214-38.574c-7.016,0-9.615,12.655-3.001,18.184c3.841,3.215,10.009,2.93,12.085,8.721 c1.893,5.274,8.554,23.201,13.461,33.852c0.508-0.074,1.016-0.153,1.524-0.232c8.432-19.618,3.807-40.399,15.209-50.615 c3.454,2.197,5.671,3.397,7.238,3.397c2.219,0,3.135-2.407,4.414-7.795C2424.485,688.575,2418.681,684.797,2414.183,684.797 L2414.183,684.797z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 2295.9854,
    y1: 685.9718,
    x2: 2318.6162,
    y2: 685.9718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M2318.616,688.022c-0.232,8.108-4.652,14.631-9.194,20.785c-2.742,3.71-8.748,1.774-11.016-2.308 c-6.41-11.506,0.804-22.727,11.209-44.632c0.258-0.543,1.056-0.828,2.865-0.657c-9.588,26.159-12.581,22.498-3.588,33.878 c7.679-6.48,5.235-4.297,8.388-7.99C2317.727,687.404,2318.169,687.711,2318.616,688.022z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 2307.3008,
    y1: 710.7836,
    x2: 2307.3008,
    y2: 661.1601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M2301.932,682.685c-1.278,4.862,0.251,7.139,5.391,13.642l1.281,1.62l1.578-1.332l2.156-1.816 c2.292-1.93,3.261-2.746,3.896-3.371c-1.142,5.913-4.624,11.047-8.42,16.19c-0.572,0.773-1.391,1.165-2.437,1.165 c-1.978,0-4.174-1.37-5.224-3.258C2296.452,698.882,2297.804,692.223,2301.932,682.685 M2311.53,661.16 c-1.151,0-1.707,0.27-1.915,0.707c-10.405,21.904-17.619,33.126-11.209,44.632c1.427,2.567,4.33,4.285,6.971,4.285 c1.559,0,3.028-0.599,4.045-1.977c4.542-6.154,8.963-12.677,9.195-20.785c-0.447-0.311-0.889-0.618-1.336-0.924 c-3.153,3.693-0.709,1.51-8.388,7.99c-8.993-11.379-6-7.718,3.588-33.878C2312.125,661.176,2311.81,661.16,2311.53,661.16 L2311.53,661.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.5216,
    y1: 685.5921,
    x2: 455.6563,
    y2: 685.5921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M432.891,718.378c-12.969-6.333-17.067-10.226-39.268-23.269c-6.025-3.543-5.031-3.294,19.07-41.018 c2.481-3.894,6.533,0.583,39.899,20.018c6.285,3.655,3.937,4.648-16.849,41.64C435.162,716.784,433.927,717.45,432.891,718.378z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.089,
    y1: 718.378,
    x2: 423.089,
    y2: 652.8062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M414.78,654.806L414.78,654.806c1.714,0,6.592,2.952,15.447,8.312c5.165,3.126,12.239,7.408,21.359,12.72 c2.261,1.315,2.394,1.58,1.78,3.551c-0.967,3.104-4.203,8.76-10.077,19.026c-2.514,4.395-5.644,9.864-9.291,16.354 c-0.192,0.341-0.723,0.749-1.286,1.18c-0.029,0.022-0.057,0.044-0.087,0.066c-6.796-3.381-11.181-6.142-17.647-10.214 c-4.926-3.102-11.056-6.962-20.342-12.418c-0.981-0.577-1.995-1.173-2.094-1.592c-0.459-1.928,4.377-9.448,14.013-24.431 c2.283-3.55,4.881-7.589,7.825-12.197c0.185-0.291,0.283-0.349,0.282-0.349h0C414.663,654.817,414.697,654.806,414.78,654.806  M414.78,652.806c-0.95,0-1.555,0.45-2.087,1.285c-24.101,37.724-25.095,37.475-19.07,41.018 c22.201,13.042,26.299,16.936,39.268,23.269c1.036-0.928,2.271-1.594,2.851-2.628c20.787-36.992,23.135-37.985,16.849-41.64 C426.382,658.843,418.261,652.806,414.78,652.806L414.78,652.806z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.9794,
    y1: 685.6166,
    x2: 359.0437,
    y2: 685.6166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M323.933,650.193c3.451,13.75,9.63,39.984,9.63,39.984c4.409,12.344,22.518,12.406,19.18,3.82 c-9.716-25.021-7.987-18.071-6.757-39.901c0.043-0.784,0.878-1.529,2.105-3.526c8.898,26.411,15.602,32.909,6.886,57.97 c-3.099,8.914-17.55,9.786-23.582,2.019c-2.701-3.478-5.009-7.263-7.585-11.039c-5.309,10.221-9.469,22.181-22.254,21.534 c-5.754-0.289-8.732-3.745-11.354-8.375c-5.073-8.945-2.808-18.327-2.138-27.601c1.349-18.6,1.932-17.869,7.234-25.319 c0.716,0.206,1.434,0.416,2.151,0.622c-2.297,24.628-6.006,41.179,4.952,44.365c13.484,3.913,25.404-12.31,16.98-34.417 c-1.45-3.811-1.594-6.776-0.149-10.333c1.295-3.185,2.133-6.553,3.174-9.843C322.915,650.167,323.423,650.18,323.933,650.193z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.0115,
    y1: 721.0797,
    x2: 323.0115,
    y2: 650.1536
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M323.054,654.947c3.483,14.132,8.507,35.452,8.563,35.689l0.026,0.109l0.038,0.105 c2.737,7.663,10.035,11.154,15.657,11.154c3.091,0,5.599-1.074,6.88-2.947c0.768-1.122,1.459-3.037,0.391-5.784 c-0.9-2.317-1.701-4.36-2.414-6.177c-5.568-14.191-5.568-14.191-4.801-24.215c0.143-1.867,0.314-4.11,0.483-6.834 c1.096,3.076,2.142,5.866,3.103,8.427c6.13,16.347,8.928,23.808,2.111,43.409c-1.26,3.626-5.202,5.969-10.043,5.969 c-4.108,0-7.873-1.689-10.07-4.519c-1.802-2.321-3.413-4.764-5.118-7.35c-0.773-1.173-1.573-2.386-2.394-3.589l-1.885-2.763 l-1.542,2.969c-0.641,1.233-1.271,2.505-1.881,3.734c-4.271,8.612-8.306,16.747-17.617,16.747c-0.289,0-0.582-0.007-0.882-0.023 c-4.753-0.239-7.24-2.995-9.715-7.365c-3.853-6.793-3.122-13.908-2.348-21.44c0.169-1.645,0.344-3.346,0.465-5.03 c1.139-15.715,1.573-16.961,5.09-21.839c-0.244,2.437-0.495,4.786-0.74,7.082c-2.123,19.881-3.526,33.015,7.434,36.201 c1.517,0.44,3.053,0.663,4.567,0.663c5.272,0,10.183-2.739,13.475-7.516c5.19-7.531,5.7-18.82,1.366-30.197 c-1.329-3.492-1.373-5.896-0.165-8.869C321.861,658.842,322.478,656.877,323.054,654.947 M322.406,650.154 c-1.04,3.29-1.879,6.658-3.173,9.843c-1.445,3.557-1.301,6.522,0.149,10.333c7.575,19.881-1.3,35.001-12.971,35.001 c-1.307,0-2.651-0.19-4.009-0.584c-10.958-3.186-7.249-19.737-4.952-44.365c-0.716-0.206-1.434-0.416-2.151-0.622 c-5.302,7.449-5.886,6.718-7.234,25.319c-0.67,9.273-2.935,18.656,2.138,27.601c2.621,4.63,5.6,8.086,11.354,8.375 c0.333,0.017,0.66,0.025,0.982,0.025c12.021,0,16.102-11.604,21.272-21.559c2.576,3.776,4.884,7.561,7.585,11.039 c2.755,3.548,7.266,5.292,11.65,5.292c5.214,0,10.248-2.469,11.932-7.312c8.716-25.061,2.012-31.559-6.886-57.97 c-1.226,1.997-2.061,2.742-2.105,3.526c-1.231,21.83-2.96,14.88,6.757,39.901c1.513,3.892-1.379,6.007-5.406,6.007 c-4.857,0-11.363-3.078-13.773-9.827c0,0-6.179-26.234-9.63-39.984C323.423,650.18,322.915,650.167,322.406,650.154 L322.406,650.154z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 2254.8877,
    y1: 864.2947,
    x2: 2323.5054,
    y2: 864.2947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M2290.219,901.255c-0.282-1-12.056-44.336-15.52-43.405c-6.457,1.686-9.869-4.595-15.252-5.73 c-3.482-0.732-4.862-3.386-4.503-6.917c0.558-5.495,1.146-13.678,6.492-13.886c3.82-0.149,8.515,1.625,11.49,4.131 c17.503,14.721,16.654,36.112,21.499,40.83c3.966-23.15,5.072-36.224,14.311-45.561c8.441-8.516,14.311,1.48,14.675,3.535 c0.596,3.373-1.7,7.289-3.009,10.877c-0.092,0.254-2.585,0.079-3.596-0.517C2296.82,832.854,2306.639,876.12,2290.219,901.255z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 2289.1965,
    y1: 901.2551,
    x2: 2289.1965,
    y2: 827.3341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2315.361,829.334c3.537,0,5.921,4.521,6.078,5.266c0.349,1.978-0.752,4.586-1.816,7.109 c-0.204,0.484-0.413,0.977-0.614,1.473c-0.515-0.071-1.012-0.192-1.192-0.294c-2.586-1.521-4.824-2.261-6.843-2.261 c-7.983,0-9.595,10.399-11.635,23.564c-1.544,9.959-3.418,22.054-8.47,31.944c-1.435-5.093-3.468-12.108-5.618-18.881 c-6.796-21.414-8.647-21.417-10.44-21.419c-0.213,0-0.426,0.028-0.618,0.08c-0.569,0.148-1.107,0.221-1.646,0.221 c-2.231,0-4.089-1.271-6.24-2.744c-1.94-1.328-3.947-2.701-6.451-3.229c-1.433-0.301-3.294-1.122-2.924-4.757l0.07-0.693 c0.448-4.486,1.124-11.265,4.51-11.396c0.124-0.005,0.249-0.007,0.375-0.007c3.175,0,7.184,1.509,9.75,3.67 c11.096,9.332,14.484,21.392,16.958,30.198c1.396,4.969,2.405,8.559,4.433,10.534l2.724,2.653l0.642-3.748 c0.478-2.788,0.914-5.431,1.328-7.938c2.964-17.955,4.753-28.792,12.432-36.552 C2311.991,830.273,2313.743,829.334,2315.361,829.334 M2315.361,827.334c-1.945,0-4.177,0.912-6.627,3.383 c-9.239,9.337-10.345,22.411-14.311,45.561c-4.845-4.718-3.996-26.109-21.499-40.83c-2.858-2.408-7.304-4.14-11.037-4.14 c-0.152,0-0.303,0.003-0.453,0.009c-5.345,0.208-5.934,8.391-6.492,13.886c-0.359,3.531,1.021,6.185,4.503,6.917 c4.753,1.002,7.969,6.016,13.102,6.016c0.68,0,1.395-0.088,2.151-0.286c0.037-0.01,0.074-0.015,0.113-0.015 c3.6,0.005,15.128,42.431,15.407,43.42c14.521-22.226,8.522-58.628,20.756-58.628c1.601,0,3.516,0.624,5.828,1.985 c0.711,0.419,2.155,0.63,2.981,0.63c0.349,0,0.588-0.038,0.615-0.113c1.31-3.588,3.605-7.503,3.009-10.877 C2323.151,832.794,2320.119,827.334,2315.361,827.334L2315.361,827.334z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.8517,
    y1: 833.404,
    x2: 472.3361,
    y2: 833.404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M467.472,819.315c-16.046-12.067-13.095-16.82-26.438,47.712c-0.269,1.305-1.673,2.374-2.554,3.557 c-6.143-6.94,0.674,3.81-13.428-32.112c-1.702-4.337-3.283-8.914-10.156-8.301c-3.448,0.306-7.355-2.431-10.769-4.311 c-11.543-6.353-6.178-28.081,8.082-19.664c17.806,10.534,19.832,22.292,26.784,41.771c0.506,0.026,1.014,0.053,1.522,0.079 c1.244-7.893,1.785-15.984,3.927-23.628c3.821-13.625,10.734-33.953,21.922-26.659 C477.422,804.968,470.264,814.27,467.472,819.315z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.0941,
    y1: 870.5835,
    x2: 435.0941,
    y2: 796.2244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M461.761,798.224L461.761,798.224c1.097,0,2.279,0.407,3.511,1.211c7.598,4.953,5.302,10.592,1.612,16.908 c-0.68-0.531-1.322-1.04-1.92-1.515c-3.679-2.92-6.109-4.849-8.63-4.849c-5.712,0-7.266,7.638-13.807,39.786 c-1.019,5.006-2.158,10.606-3.451,16.858c-0.048,0.234-0.322,0.595-0.638,0.962c-0.199-0.207-0.373-0.385-0.529-0.544 c-0.817-0.834-0.817-0.834-1.422-2.806c-0.885-2.885-2.956-9.64-9.573-26.494l-0.144-0.368c-1.613-4.124-3.62-9.257-10.673-9.258 c-0.443,0-0.906,0.021-1.377,0.063c-0.121,0.011-0.243,0.016-0.365,0.016c-2.177,0-4.971-1.618-7.436-3.045 c-0.621-0.359-1.231-0.713-1.827-1.041c-4.635-2.551-5.964-8.154-4.88-12.37c0.329-1.279,1.727-5.453,5.916-5.453 c1.524,0,3.228,0.55,5.064,1.633c14.973,8.858,18.19,18.255,23.521,33.823c0.754,2.203,1.535,4.482,2.397,6.899l0.448,1.255 l1.331,0.07l1.525,0.079l1.798,0.092l0.28-1.778c0.384-2.435,0.705-4.917,1.015-7.316c0.694-5.364,1.412-10.911,2.862-16.083 C451.343,807.22,456.521,798.225,461.761,798.224 M461.76,796.224c-8.524,0.001-14.051,16.547-17.318,28.194 c-2.142,7.644-2.683,15.735-3.927,23.628c-0.508-0.026-1.016-0.052-1.522-0.079c-6.952-19.479-8.977-31.237-26.784-41.771 c-2.262-1.335-4.3-1.912-6.082-1.912c-9.454,0-11.712,16.23-2,21.576c3.237,1.781,6.916,4.334,10.227,4.334 c0.182,0,0.363-0.008,0.542-0.024c0.419-0.037,0.819-0.056,1.2-0.056c5.866,0,7.358,4.284,8.956,8.356 c14.102,35.923,7.286,25.172,13.428,32.112c0.881-1.182,2.284-2.251,2.554-3.557c8.823-42.672,10.521-55.048,15.299-55.048 c2.448,0,5.703,3.249,11.139,7.336c2.792-5.045,9.95-14.348-1.108-21.556C464.74,796.701,463.207,796.224,461.76,796.224 L461.76,796.224z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 605.0594,
    y1: 586.8851,
    x2: 627.2427,
    y2: 586.8851
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M623.743,561.087c-6.561,15.207-17.006,31.277-5.607,36.971c1.474,0.737,7.014-5.657,9.107-6.549 c-2.816,7.578-2.79,16.448-10.474,21.482c-4.507,2.948-9.821,0.057-11.01-5.69c-2.941-14.199,3.755-24.975,13.22-44.137 c0.62-1.253,1.513-2.374,2.282-3.553C622.089,560.101,622.917,560.596,623.743,561.087z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 616.1511,
    y1: 614.1597,
    x2: 616.1511,
    y2: 559.6106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M614.368,576.891c-4.022,9.751-5.754,18.646,2.874,22.955c0.359,0.179,0.752,0.27,1.169,0.27 c1.43,0,2.894-1.057,5.074-2.964c-0.01,0.038-0.02,0.075-0.029,0.113c-1.44,5.548-2.8,10.788-7.781,14.051 c-0.856,0.56-1.748,0.843-2.652,0.843c-2.482,0-4.663-2.165-5.304-5.266C605.625,596.792,608.669,588.563,614.368,576.891  M621.261,559.611c-0.769,1.178-1.662,2.3-2.282,3.553c-9.465,19.162-16.161,29.938-13.22,44.137 c0.867,4.189,3.923,6.86,7.263,6.86c1.242,0,2.525-0.37,3.747-1.17c7.683-5.033,7.657-13.903,10.474-21.482 c-1.98,0.844-7.042,6.608-8.832,6.608c-0.103,0-0.195-0.019-0.275-0.059c-11.4-5.694-0.954-21.764,5.607-36.971 C622.917,560.596,622.089,560.101,621.261,559.611L621.261,559.611z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 2330.5408,
    y1: 553.595,
    x2: 2397.7808,
    y2: 553.595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M2389.496,522.047c0.364,1,7.202,18.256,8.073,28.733c2.254,27.293-13.986,36.825-23.856,28.008 c-3.105-2.773-5.655-6.168-9.115-10.018c-2.357,2.935-5.16,5.804-7.24,9.124c-6.032,9.606-18.726,9.751-23.97-0.079 c-5.122-9.606-2.053-13.561-0.609-29.769c0.469-5.244,1.726-10.145,4.796-14.307c0.819,0.123,1.638,0.241,2.458,0.359 c-0.276,6.028-0.473,12.059-0.863,18.078c-0.197,2.978-1.616,6.137-0.969,8.853c3.114,13.057,15.969,11.004,21.131,2.164 c4.836-8.283,2.558-16.987,3.382-25.52c0.377-3.916,1.998-7.71,3.053-11.56c0.88,0.07,1.76,0.14,2.641,0.21 c3.577,20.061,0.904,42.467,18.336,40.054c6.304-0.873,4.423-3.667-2.085-27.697 C2383.065,532.789,2385.461,528.15,2389.496,522.047z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 2364.1606,
    y1: 585.1434,
    x2: 2364.1606,
    y2: 522.0466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M2389.04,526.53c3.773,10.319,6.077,18.905,6.536,24.415c1.229,14.887-3.216,22.137-5.976,25.133 c-2.313,2.512-5.148,3.896-7.983,3.896c-2.339,0-4.611-0.926-6.572-2.677c-1.998-1.784-3.76-3.845-5.799-6.23 c-0.994-1.163-2.023-2.366-3.161-3.633l-1.573-1.75l-1.474,1.835c-0.715,0.891-1.465,1.767-2.26,2.694 c-1.773,2.07-3.605,4.21-5.115,6.619c-2.482,3.953-6.448,6.313-10.61,6.313c-4.167,0-7.776-2.285-9.901-6.269 c-3.401-6.379-2.885-9.882-1.753-17.557c0.432-2.928,0.969-6.571,1.372-11.093c0.414-4.629,1.422-8.292,3.136-11.326 c-0.034,0.797-0.068,1.595-0.101,2.392c-0.176,4.187-0.358,8.517-0.632,12.754c-0.064,0.971-0.287,2.008-0.523,3.105 c-0.445,2.067-0.905,4.205-0.395,6.344c1.617,6.781,6.019,10.829,11.775,10.829c5.034,0,10.148-3.188,13.029-8.121 c3.648-6.248,3.56-12.605,3.476-18.753c-0.036-2.624-0.07-5.102,0.169-7.584c0.239-2.478,1.029-4.938,1.867-7.542 c0.103-0.319,0.206-0.641,0.309-0.964c0.536,3.533,0.917,7.114,1.287,10.601c1.563,14.707,3.04,28.598,16.111,28.598 c0.869,0,1.791-0.067,2.74-0.198c1.748-0.242,3.683-0.714,4.774-2.377c1.769-2.696,0.645-6.732-2.692-18.712 c-0.739-2.651-1.575-5.655-2.511-9.112C2385.524,534.218,2386.456,530.949,2389.04,526.53 M2389.496,522.047 c-4.034,6.104-6.431,10.743-4.836,16.635c6.508,24.03,8.388,26.824,2.085,27.697c-0.871,0.121-1.692,0.179-2.466,0.179 c-14.714,0-12.472-21.175-15.871-40.233c-0.881-0.07-1.761-0.14-2.641-0.21c-1.056,3.85-2.677,7.644-3.053,11.56 c-0.824,8.533,1.454,17.237-3.382,25.52c-2.575,4.41-7.062,7.13-11.302,7.13c-4.26,0-8.269-2.749-9.83-9.293 c-0.648-2.716,0.771-5.874,0.968-8.853c0.39-6.019,0.587-12.05,0.863-18.078c-0.819-0.118-1.638-0.236-2.458-0.359 c-3.071,4.162-4.328,9.063-4.796,14.307c-1.445,16.208-4.513,20.163,0.609,29.769c2.618,4.907,7.091,7.328,11.666,7.328 c4.59,0,9.283-2.438,12.304-7.249c2.08-3.321,4.884-6.19,7.24-9.124c3.461,3.85,6.01,7.245,9.115,10.018 c2.381,2.127,5.131,3.186,7.905,3.186c8.723,0,17.661-10.484,15.951-31.194C2396.697,540.302,2389.86,523.047,2389.496,522.047 L2389.496,522.047z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 2095.7637,
    y1: 650.5476,
    x2: 2120.1714,
    y2: 650.5476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M2119.304,659.611c-0.879,20.364-15.613,30.751-21.504,17.184c-6.631-15.255,3.94-29.681,17.154-54.295 c0.85-1.586,2.225-2.891,3.356-4.328c0.622,0.306,1.24,0.613,1.862,0.92c-15.899,39.834-16.075,37.293-12.19,46.134 c0.376,0.867,4.021,1.17,5.55,0.442C2115.414,664.771,2116.654,662.519,2119.304,659.611z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 2107.9675,
    y1: 682.923,
    x2: 2107.9675,
    y2: 618.1723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M2114.996,626.624c-0.868,2.156-1.676,4.155-2.426,6.012c-9.926,24.57-10.116,25.039-6.729,32.695 l0.305,0.692c0.776,1.788,3.448,2.055,4.971,2.055c0.915,0,2.226-0.105,3.274-0.604c0.791-0.377,1.46-0.889,2.096-1.51 c-1.964,9.063-6.959,14.959-11.294,14.959c-2.827,0-4.583-2.678-5.559-4.925c-5.273-12.13,1.405-24.17,11.512-42.394 C2112.398,631.348,2113.679,629.038,2114.996,626.624 M2118.31,618.172c-1.13,1.437-2.506,2.742-3.355,4.328 c-13.213,24.614-23.785,39.04-17.154,54.295c1.835,4.227,4.528,6.128,7.393,6.128c6.333,0,13.505-9.292,14.11-23.312 c-2.65,2.908-3.89,5.16-5.773,6.058c-0.592,0.282-1.5,0.409-2.414,0.409c-1.447,0-2.906-0.319-3.136-0.851 c-3.885-8.841-3.708-6.3,12.19-46.134C2119.55,618.785,2118.932,618.479,2118.31,618.172L2118.31,618.172z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 1501.741,
    y1: 386.7094,
    x2: 1526.225,
    y2: 386.7094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M1514.836,398.979c-2.089-4.733-4.14-9.249-9.922-10.796c-1.529-0.409-3.29-3.778-3.167-5.675 c0.549-8.763,9.056,0.496,13.969,4.858c1.42-6.053,2.426-15.077,8.187-12.464c1.384,0.628,1.498,4.056,2.322,6.626 c-10.139,0.135-8.168,2.303-9.791,17.3C1515.9,398.879,1515.37,398.929,1514.836,398.979z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 1513.9829,
    y1: 398.9794,
    x2: 1513.9829,
    y2: 374.4393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M1522.005,376.439c0.254,0,0.557,0.071,0.901,0.211c0.26,0.452,0.532,1.758,0.716,2.643 c0.024,0.114,0.048,0.229,0.072,0.344c-1.83,0.147-3.242,0.447-4.342,0.946C1520.023,378.314,1520.882,376.44,1522.005,376.439  M1504.119,380.87c1.689,0.054,5.918,3.979,8.197,6.095c0.734,0.682,1.433,1.33,2.072,1.898l0.853,0.757 c-0.069,0.724-0.132,1.496-0.196,2.318c-0.059,0.753-0.121,1.546-0.191,2.387c-1.851-3.49-4.438-6.721-9.368-8.058 c-0.67-0.388-1.811-2.584-1.743-3.632C1503.816,381.475,1504.03,381.015,1504.119,380.87 M1522.004,374.439 c-4.112,0.001-5.041,7.611-6.288,12.928c-3.437-3.051-8.632-8.497-11.631-8.497c-1.289,0-2.173,1.006-2.338,3.64 c-0.122,1.897,1.639,5.265,3.167,5.675c5.782,1.547,7.832,6.063,9.922,10.796c0.534-0.051,1.064-0.101,1.599-0.151 c1.623-14.997-0.348-17.165,9.791-17.3c-0.823-2.569-0.938-5.997-2.322-6.626C1523.203,374.585,1522.573,374.439,1522.004,374.439 L1522.004,374.439z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 1413.6355,
    y1: 391.1461,
    x2: 1453.0374,
    y2: 391.1461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M1413.635,399.078c4.393-5.547-4.442-1.671,38.385-17.083c0.337,0.508,0.679,1.018,1.016,1.526 c-6.115,6.553,3.763,2.453-38.162,16.777C1414.459,399.89,1414.047,399.485,1413.635,399.078z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 1433.3364,
    y1: 400.2977,
    x2: 1433.3364,
    y2: 381.9946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M1449.193,385.136c-1.269,1.814-1.571,1.943-19.848,8.132c-3.431,1.162-7.476,2.531-12.253,4.16 c0.835-1.09,3.01-1.901,19.262-7.7C1439.933,388.451,1444.169,386.94,1449.193,385.136 M1452.021,381.995 c-42.827,15.412-33.993,11.536-38.385,17.083c0.412,0.408,0.823,0.813,1.239,1.22c41.925-14.324,32.048-10.224,38.162-16.777 C1452.7,383.013,1452.358,382.502,1452.021,381.995L1452.021,381.995z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 1516.7886,
    y1: 344.944,
    x2: 1524.5643,
    y2: 344.944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M1524.564,345.832c-1.542,1.939-3,3.958-4.722,5.721c-0.241,0.248-2.506-0.661-2.58-1.198 c-0.512-3.929-0.705-7.898-0.088-12.061c2.247,2.519,1.139,7.453,7.14,5.922C1524.398,344.754,1524.481,345.293,1524.564,345.832z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 1520.6765,
    y1: 351.5945,
    x2: 1520.6765,
    y2: 338.2935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M1518.824,345.313c0.665,0.582,1.536,1.016,2.708,1.149c-0.789,1.013-1.558,1.984-2.374,2.894 c-0.002-0.001-0.004-0.002-0.006-0.003C1518.985,347.935,1518.875,346.595,1518.824,345.313 M1517.175,338.293 c-0.618,4.163-0.425,8.132,0.087,12.061c0.066,0.475,1.844,1.24,2.421,1.24c0.076,0,0.131-0.013,0.159-0.042 c1.722-1.763,3.18-3.782,4.722-5.721c-0.083-0.539-0.166-1.077-0.249-1.616c-0.78,0.199-1.44,0.289-2.003,0.289 C1518.545,344.504,1519.13,340.485,1517.175,338.293L1517.175,338.293z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 1235.4934,
    y1: 448.1407,
    x2: 1315.2101,
    y2: 448.1407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M1315.21,430.998c-6.271,5.372,7.792-1.093-75.829,35.339c-0.913,0.398-2.008,0.383-3.888-0.471 c1.728-1.861,3.108-4.523,5.244-5.462c1.004-0.441,64.934-28.652,73.45-30.711C1314.529,430.128,1314.868,430.562,1315.21,430.998 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_170_",
    gradientUnits: "userSpaceOnUse",
    x1: 1275.3517,
    y1: 466.5891,
    x2: 1275.3517,
    y2: 429.6923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M1308.191,433.885c-4.543,2.291-15.393,7.022-44.303,19.602c-7.028,3.058-15.117,6.578-24.433,10.636 c0.692-0.856,1.372-1.574,2.087-1.889l0.187-0.083C1247.383,459.661,1290.65,440.63,1308.191,433.885 M1314.187,429.692 c-8.516,2.059-72.447,30.27-73.45,30.711c-2.136,0.94-3.515,3.601-5.244,5.462c1.129,0.513,1.974,0.723,2.668,0.723 c0.461,0,0.855-0.093,1.22-0.252c83.621-36.432,69.558-29.966,75.829-35.339C1314.868,430.562,1314.529,430.128,1314.187,429.692 L1314.187,429.692z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_171_",
    gradientUnits: "userSpaceOnUse",
    x1: 1247.8528,
    y1: 465.8887,
    x2: 1317.7068,
    y2: 465.8887
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M1247.853,483.017c5.742-6.829-8.027,0.899,68.464-35.72c0.464,0.522,0.928,1.045,1.391,1.566 c-6.541,6.924,6.177,0.394-59.286,31.613c-2.992,1.426-6.067,2.674-9.102,4.004 C1248.83,483.992,1248.341,483.503,1247.853,483.017z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_172_",
    gradientUnits: "userSpaceOnUse",
    x1: 1282.7798,
    y1: 484.4803,
    x2: 1282.7798,
    y2: 447.2971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M1313.508,450.858c-1.695,1.971-5.233,3.667-36.88,18.731c-5.479,2.608-11.79,5.612-19.067,9.082 c-1.995,0.951-4.081,1.844-6.099,2.707c1.153-1.563,3.623-2.755,26.403-13.556 C1286.486,463.734,1298.065,458.244,1313.508,450.858 M1316.316,447.297c-76.49,36.619-62.722,28.891-68.463,35.72 c0.488,0.486,0.977,0.975,1.465,1.463c3.035-1.33,6.111-2.578,9.103-4.004c65.464-31.219,52.745-24.689,59.286-31.613 C1317.245,448.342,1316.78,447.819,1316.316,447.297L1316.316,447.297z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_173_",
    gradientUnits: "userSpaceOnUse",
    x1: 1253.9229,
    y1: 439.5604,
    x2: 1259.9641,
    y2: 439.5604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M1255.168,433.138c6.928,9.431,5.545,8.861,0.935,12.846 C1253.381,442.394,1253.373,445.969,1255.168,433.138z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_",
    gradientUnits: "userSpaceOnUse",
    x1: 1256.9435,
    y1: 445.9833,
    x2: 1256.9435,
    y2: 433.1376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M1256.431,438.399c0.833,1.28,1.433,2.369,1.524,2.999c0.047,0.324-0.234,0.639-1.639,1.802 c-0.034-0.034-0.068-0.068-0.1-0.1c-0.101-0.1-0.221-0.22-0.288-0.295C1255.871,442.302,1256.101,440.66,1256.431,438.399  M1255.168,433.138c-1.796,12.831-1.787,9.257,0.935,12.846C1260.713,441.998,1262.096,442.569,1255.168,433.138L1255.168,433.138 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 1422.7114,
    y1: 344.891,
    x2: 1442.0961,
    y2: 344.891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M1439.651,333.764c1.688,8.89,7.047,25.362-6.737,19.624c-13.241,9.224-11.09-8.44-7.368-12.751 c0.976,8.052,0.277,5.546,3.233,8.951c2.704-4.371,1.62,0.11,1.726-12.068c0.005-0.563,0.679-1.117,1.419-2.241 c1.66,4.197,3.11,7.863,4.56,11.529c0.39-0.179,0.776-0.361,1.165-0.541c-0.197-4.139-0.394-8.279-0.591-12.416 C1437.925,333.821,1438.788,333.793,1439.651,333.764z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 1432.4032,
    y1: 356.0181,
    x2: 1432.4032,
    y2: 333.764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M1432.526,342.241l2.098,5.303l0.777,1.965l1.919-0.884l0.619-0.287l0.548-0.255l1.224-0.565l-0.064-1.347 l-0.156-3.271c0.671,3.791,1.016,7.599-0.17,9.072c-0.225,0.28-0.611,0.601-1.605,0.601c-1.031,0-2.388-0.347-4.034-1.033 l-1.012-0.421l-0.9,0.627c-2.836,1.976-4.42,2.271-5.112,2.271c-0.595,0-1.07-0.172-1.454-1.011 c-0.528-1.155-0.592-2.966-0.353-4.823c0.26,0.43,0.613,0.833,1.121,1.338c0.331,0.329,0.743,0.739,1.297,1.377l1.782,2.052 l1.43-2.311c0.497-0.804,0.853-1.278,1.113-1.625c1.107-1.477,1.088-2.033,1.004-4.373 C1432.575,344.047,1432.547,343.266,1432.526,342.241 M1439.651,333.764c-0.863,0.029-1.726,0.057-2.593,0.087 c0.197,4.137,0.394,8.277,0.591,12.416c-0.39,0.18-0.776,0.362-1.165,0.541c-1.45-3.667-2.9-7.333-4.56-11.529 c-0.74,1.124-1.415,1.678-1.419,2.241c-0.106,12.178,0.978,7.696-1.726,12.068c-2.956-3.405-2.257-0.899-3.233-8.951 c-2.97,3.44-4.941,15.381,1.112,15.381c1.532,0,3.58-0.766,6.255-2.63c1.97,0.82,3.548,1.186,4.802,1.186 C1445.241,354.574,1441.098,341.384,1439.651,333.764L1439.651,333.764z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_177_",
    gradientUnits: "userSpaceOnUse",
    x1: 1377.5327,
    y1: 356.7602,
    x2: 1393.7229,
    y2: 356.7602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M1377.554,356.522c0.704-10.858,16.297-10.249,16.168,0.579 C1393.595,367.859,1376.856,367.173,1377.554,356.522z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_178_",
    gradientUnits: "userSpaceOnUse",
    x1: 1385.6278,
    y1: 364.8471,
    x2: 1385.6278,
    y2: 348.6732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M1385.625,348.673v2c1.7,0,3.31,0.642,4.416,1.761c1.123,1.136,1.704,2.742,1.682,4.643 c-0.05,4.259-3.28,5.77-6.03,5.77c-1.872,0-3.655-0.711-4.77-1.901c-1.026-1.095-1.488-2.54-1.373-4.294 c0.286-4.412,3.451-5.978,6.074-5.978L1385.625,348.673 M1385.624,348.673c-3.864,0-7.728,2.569-8.07,7.849 c-0.359,5.483,3.901,8.325,8.139,8.325c3.994,0,7.968-2.526,8.029-7.746C1393.788,351.538,1389.706,348.673,1385.624,348.673 L1385.624,348.673z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_179_",
    gradientUnits: "userSpaceOnUse",
    x1: 1192.3872,
    y1: 390.669,
    x2: 1213.6157,
    y2: 390.669
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M1198.987,379.25c8.539,4.745,15.995,7.539,14.416,12.471c-0.615,1.919-4.678,12.026-8.745,10.132 C1187.691,393.95,1190.856,394.092,1198.987,379.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_180_",
    gradientUnits: "userSpaceOnUse",
    x1: 1203.0015,
    y1: 402.0881,
    x2: 1203.0015,
    y2: 379.2499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBC663"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9C5824"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#8B4B20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F4DE95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#9C4F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4C371"
    }
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M1199.771,381.957c0.82,0.441,1.624,0.866,2.411,1.283c6.276,3.319,10.083,5.475,9.316,7.871 c-1.135,3.545-4.188,8.977-5.806,8.977c-0.04,0-0.099-0.005-0.19-0.048c-5.909-2.752-10.473-5.001-11.041-6.808 c-0.428-1.361,1.076-3.95,3.352-7.868C1198.413,384.332,1199.068,383.204,1199.771,381.957 M1198.987,379.25 c-8.131,14.842-11.296,14.7,5.67,22.603c0.346,0.161,0.691,0.235,1.035,0.235c3.698,0,7.148-8.611,7.711-10.367 C1214.983,386.789,1207.526,383.995,1198.987,379.25L1198.987,379.25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArabic1);
export default __webpack_public_path__ + "static/media/arabic-1.91f565a2eb6743bd859d5c46aa78ee38.svg";
export { ForwardRef as ReactComponent };